/* eslint-disable */
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CriteriaTypeDTOBuilder = exports.CriteriaMetaDataDTOBuilder = exports.CreatePlacementResponseDTOBuilder = exports.CreatePlacementRequestDTOBuilder = exports.CreateMethodOptionsDTOBuilder = exports.CountTypeDTOBuilder = exports.CountOptionsDTOBuilder = exports.ContextDTOBuilder = exports.ConnectedDomainCriteriaEnumDTOBuilder = exports.ConnectedDomainCriteriaDTOBuilder = exports.ConditionsDTOBuilder = exports.ConditionalDTOBuilder = exports.CompoundCriteriaOperatorDTOBuilder = exports.CompoundCriteriaDTOBuilder = exports.ComparatorTypeEnumDTOBuilder = exports.ComparatorTypeDTOBuilder = exports.CallbackEventTypeDTOBuilder = exports.CallbackDeprecationDTOBuilder = exports.CallbackDTOBuilder = exports.CacheSettingsDTOBuilder = exports.CacheDTOBuilder = exports.CTypeDTOBuilder = exports.BytesValueDTOBuilder = exports.BulkUpsertMethodOptionsDTOBuilder = exports.BulkUpdateMethodOptionsDTOBuilder = exports.BulkUpdateByFilterMethodOptionsDTOBuilder = exports.BulkDeleteMethodOptionsDTOBuilder = exports.BulkDeleteByFilterMethodOptionsDTOBuilder = exports.BulkCreateMethodOptionsDTOBuilder = exports.BrandsCriteriaDTOBuilder = exports.BrandDTOBuilder = exports.AssetDTOBuilder = exports.ApplyFilterResultDTOBuilder = exports.ApplyFilterResponseDTOBuilder = exports.ApplyFilterRequestDTOBuilder = exports.ApplyFilterListResponseDTOBuilder = exports.ApplyFilterListRequestDTOBuilder = exports.AppScopeDTOBuilder = exports.ApiErrorDTOBuilder = exports.AnnotationDTOBuilder = exports.AlignedWithEnumDTOBuilder = exports.AdvicesConfigDTOBuilder = exports.AdvicesDTOBuilder = exports.AccountIdInContextDTOBuilder = exports.AccountDataDTOBuilder = exports.ABCTRConfigDTOBuilder = exports.resetBuilderConfig = exports.builderConfig = exports.defaultMinArraySize = exports.defaultMaxArraySize = void 0;
exports.FieldSetDTOBuilder = exports.FieldOptionsDTOBuilder = exports.FieldDescriptorProtoTypeDTOBuilder = exports.FieldDescriptorProtoDTOBuilder = exports.ExternalFilterProviderConfigDTOBuilder = exports.ExternalFilterCriteriaConditionTypeEnumDTOBuilder = exports.ExternalFilterCriteriaConditionTypeDTOBuilder = exports.ExternalFilterCriteriaDTOBuilder = exports.ExternalCriteriaConditionTypeEnumDTOBuilder = exports.ExternalCriteriaConditionTypeDTOBuilder = exports.ExternalCriteriaDTOBuilder = exports.ExternalAppDTOBuilder = exports.ExtensionRangeOptionsDTOBuilder = exports.ExtensionRangeDTOBuilder = exports.ExtensibleDTOBuilder = exports.ExtendedFieldsDTOBuilder = exports.ExposureDTOBuilder = exports.ExperimentCriteriaDTOBuilder = exports.ExecutionResultDTOBuilder = exports.EventsCountLimitDTOBuilder = exports.EventDTOBuilder = exports.EnumValueOptionsDTOBuilder = exports.EnumValueDescriptorProtoDTOBuilder = exports.EnumReservedRangeDTOBuilder = exports.EnumOptionsDTOBuilder = exports.EnumDescriptorProtoDTOBuilder = exports.EntityDTOBuilder = exports.EmitsDTOBuilder = exports.EligibleForSaleCriteriaEnumDTOBuilder = exports.EligibleForSaleCriteriaDTOBuilder = exports.DomainLengthCriteriaDTOBuilder = exports.DomainEventOptionsDTOBuilder = exports.DomainEventEventTypeDTOBuilder = exports.DomainEventDTOBuilder = exports.DescriptorProtoDTOBuilder = exports.DeprecatedDTOBuilder = exports.DeleteMethodOptionsDTOBuilder = exports.DecimalValueOptionsDTOBuilder = exports.DebugOfferResponseDTOBuilder = exports.DebugOfferRequestDTOBuilder = exports.DateUnitDTOBuilder = exports.CustomValidationErrorDTOBuilder = exports.CustomParamOperatorDTOBuilder = exports.CustomParamCriteriaDTOBuilder = exports.CustomParamDTOBuilder = exports.CustomHttpPatternDTOBuilder = exports.CustomFilterOperatorDTOBuilder = exports.CustomFilterDataSourceDTOBuilder = exports.CustomFilterCriteriaDTOBuilder = exports.CrudDTOBuilder = void 0;
exports.ListValueDTOBuilder = exports.ListPlacementsResponseDTOBuilder = exports.ListPlacementsRequestDTOBuilder = exports.ListOffersResponseDTOBuilder = exports.ListOffersRequestDTOBuilder = exports.ListOffersBulkResponseDTOBuilder = exports.ListOffersBulkRequestDTOBuilder = exports.ListMethodOptionsDTOBuilder = exports.ListDeletedMethodOptionsDTOBuilder = exports.ListCriteriaDTOBuilder = exports.LevelEnumDTOBuilder = exports.LevelDTOBuilder = exports.LastEventLimitDTOBuilder = exports.LabelDTOBuilder = exports.JSTypeDTOBuilder = exports.ItemPrioritizedDTOBuilder = exports.InheritCrudErrorsDTOBuilder = exports.IdentityResponseDTOBuilder = exports.IdentityRequestWithServerSignerDTOBuilder = exports.IdentityRequestWithExplicitContextDTOBuilder = exports.IdentityRequestDTOBuilder = exports.IdentityDTOBuilder = exports.IdentificationDataDTOBuilder = exports.Identification2ServiceDTOBuilder = exports.IdempotencyLevelDTOBuilder = exports.HttpDTOBuilder = exports.HookableDTOBuilder = exports.GetPlacementsBulkResponseDTOBuilder = exports.GetPlacementsBulkRequestDTOBuilder = exports.GetPlacementResponseDTOBuilder = exports.GetPlacementRequestDTOBuilder = exports.GetOfferResponseDTOBuilder = exports.GetOfferRequestDTOBuilder = exports.GetItemMethodOptionsDTOBuilder = exports.GetDeletedMethodOptionsDTOBuilder = exports.GeneratedCodeInfoDTOBuilder = exports.FrequencyCapsRequestOverridesDTOBuilder = exports.FrequencyCapsOverridesTypeDTOBuilder = exports.FrequencyCapsExecutionResultDTOBuilder = exports.FrequencyCapsEventsDTOBuilder = exports.FrequencyCapsEventTypeDTOBuilder = exports.FrequencyCapsConfigDTOBuilder = exports.FrequencyCapsConditionsResultDTOBuilder = exports.FrequencyCapsDTOBuilder = exports.FreeSiteCriteriaEnumDTOBuilder = exports.FreeSiteCriteriaDTOBuilder = exports.FormatDTOBuilder = exports.FixedItemDTOBuilder = exports.FileOptionsDTOBuilder = exports.FileDescriptorSetDTOBuilder = void 0;
exports.QueryMethodOptionsDTOBuilder = exports.PublishStatusDTOBuilder = exports.PublishPlacementResponseDTOBuilder = exports.PublishPlacementRequestDTOBuilder = exports.PublishErrorsDTOBuilder = exports.PriorityItemDTOBuilder = exports.PrioritizationStrategyParamsDTOBuilder = exports.PrioritizationStrategyOverridesDTOBuilder = exports.PrioritizationStrategyConfigDTOBuilder = exports.PrioritizationStrategyDTOBuilder = exports.PrioritizationABTestStrategiesDTOBuilder = exports.PremiumPlanCriteriaDTOBuilder = exports.PremiumLandingTabCriteriaEnumDTOBuilder = exports.PremiumLandingTabCriteriaDTOBuilder = exports.PremiumAccountCriteriaEnumDTOBuilder = exports.PremiumAccountCriteriaDTOBuilder = exports.PlanDTOBuilder = exports.PlacementStatusDTOBuilder = exports.PlacementDTOBuilder = exports.PersonTypeDTOBuilder = exports.PersonDTOBuilder = exports.PermissionTypeDTOBuilder = exports.PermissionRuleDTOBuilder = exports.ParentAccountDTOBuilder = exports.PagingTypeDTOBuilder = exports.PagingDTOBuilder = exports.OptimizeModeDTOBuilder = exports.OperatorValueTypeEnumDTOBuilder = exports.OperatorValueTypeDTOBuilder = exports.OperatorFieldSupportDTOBuilder = exports.OneofOptionsDTOBuilder = exports.OneofDescriptorProtoDTOBuilder = exports.OffersConfigDTOBuilder = exports.OfferDTOBuilder = exports.NullValueDTOBuilder = exports.NamePartDTOBuilder = exports.MethodOptionsDTOBuilder = exports.MethodDescriptorProtoDTOBuilder = exports.MethodDTOBuilder = exports.MetaSiteIdInContextDTOBuilder = exports.MessageOptionsDTOBuilder = exports.MessageAppendixTypeDTOBuilder = exports.MessageAppendixDTOBuilder = exports.MaturityDTOBuilder = exports.ManagerLocalizationIdsWrapperDTOBuilder = exports.ManagerIdsWrapperDTOBuilder = exports.MailboxCriteriaEnumDTOBuilder = exports.MailboxCriteriaDTOBuilder = exports.LocationDTOBuilder = exports.LocalizedDataDTOBuilder = void 0;
exports.UserDataDTOBuilder = exports.UserAccountInfoDTOBuilder = exports.UpsertMethodOptionsDTOBuilder = exports.UpdatePlacementStatusResponseDTOBuilder = exports.UpdatePlacementStatusRequestDTOBuilder = exports.UpdatePlacementSlugResponseDTOBuilder = exports.UpdatePlacementSlugRequestDTOBuilder = exports.UpdatePlacementResponseDTOBuilder = exports.UpdatePlacementRequestDTOBuilder = exports.UpdateMethodOptionsDTOBuilder = exports.UniqueDTOBuilder = exports.UninterpretedOptionDTOBuilder = exports.TranslatableTypeDTOBuilder = exports.TranslatableDTOBuilder = exports.TargetingDTOBuilder = exports.StatusCodesHttpStatusCodeDTOBuilder = exports.StatusCodesDTOBuilder = exports.SpiServiceDTOBuilder = exports.SpiHttpStatusCodeDTOBuilder = exports.SpiErrorDTOBuilder = exports.SourceCodeInfoDTOBuilder = exports.SortDTOBuilder = exports.SiteTypeCriteriaDTOBuilder = exports.SiteTypeDTOBuilder = exports.SiteDataDTOBuilder = exports.ShadowedStrategyDTOBuilder = exports.ServiceOptionsDTOBuilder = exports.ServiceEntityDTOBuilder = exports.ServiceDescriptorProtoDTOBuilder = exports.ServiceAppendixTypeDTOBuilder = exports.ServiceAppendixDTOBuilder = exports.SegmentNameDTOBuilder = exports.SegmentDTOBuilder = exports.SearchMethodOptionsDTOBuilder = exports.SearchDTOBuilder = exports.SchemaDTOBuilder = exports.RestoreFromTrashbinMethodOptionsDTOBuilder = exports.ResolveOfferResponseDTOBuilder = exports.ResolveOfferRequestDTOBuilder = exports.ReservedRangeDTOBuilder = exports.RequiredFieldsDTOBuilder = exports.RequiredFieldDTOBuilder = exports.RequestExtensionsDTOBuilder = exports.RequestContextDTOBuilder = exports.RemoveFromTrashbinMethodOptionsDTOBuilder = exports.ReleaseAudienceStatusDTOBuilder = exports.ReleaseAudienceDTOBuilder = exports.RefreshIdentityResponseDTOBuilder = exports.RefreshIdentityRequestDTOBuilder = exports.ReferenceEntityFieldDTOBuilder = void 0;
exports.aCountType = exports.aCountOptions = exports.aContext = exports.aConnectedDomainCriteriaEnum = exports.aConnectedDomainCriteria = exports.aConditions = exports.aConditional = exports.aCompoundCriteriaOperator = exports.aCompoundCriteria = exports.aComparatorTypeEnum = exports.aComparatorType = exports.aCallbackEventType = exports.aCallbackDeprecation = exports.aCallback = exports.aCacheSettings = exports.aCache = exports.aCType = exports.aBytesValue = exports.aBulkUpsertMethodOptions = exports.aBulkUpdateMethodOptions = exports.aBulkUpdateByFilterMethodOptions = exports.aBulkDeleteMethodOptions = exports.aBulkDeleteByFilterMethodOptions = exports.aBulkCreateMethodOptions = exports.aBrandsCriteria = exports.aBrand = exports.anAsset = exports.anApplyFilterResult = exports.anApplyFilterResponse = exports.anApplyFilterRequest = exports.anApplyFilterListResponse = exports.anApplyFilterListRequest = exports.anAppScope = exports.anApiError = exports.anAnnotation = exports.anAlignedWithEnum = exports.anAdvicesConfig = exports.anAdvices = exports.anAccountIdInContext = exports.anAccountData = exports.anABCTRConfig = exports.WqlOperatorDTOBuilder = exports.WqlDTOBuilder = exports.WixGlobalDataDTOBuilder = exports.WhatsNextConfigurationDTOBuilder = exports.WHATSNEXTConfigDTOBuilder = exports.UserStatusCriteriaEnumDTOBuilder = exports.UserStatusCriteriaDTOBuilder = exports.UserRoleCriteriaEnumDTOBuilder = exports.UserRoleCriteriaDTOBuilder = void 0;
exports.anExternalFilterCriteriaConditionTypeEnum = exports.anExternalFilterCriteriaConditionType = exports.anExternalFilterCriteria = exports.anExternalCriteriaConditionTypeEnum = exports.anExternalCriteriaConditionType = exports.anExternalCriteria = exports.anExternalApp = exports.anExtensionRangeOptions = exports.anExtensionRange = exports.anExtensible = exports.anExtendedFields = exports.anExposure = exports.anExperimentCriteria = exports.anExecutionResult = exports.anEventsCountLimit = exports.anEvent = exports.anEnumValueOptions = exports.anEnumValueDescriptorProto = exports.anEnumReservedRange = exports.anEnumOptions = exports.anEnumDescriptorProto = exports.anEntity = exports.anEmits = exports.anEligibleForSaleCriteriaEnum = exports.anEligibleForSaleCriteria = exports.aDomainLengthCriteria = exports.aDomainEventOptions = exports.aDomainEventEventType = exports.aDomainEvent = exports.aDescriptorProto = exports.aDeprecated = exports.aDeleteMethodOptions = exports.aDecimalValueOptions = exports.aDebugOfferResponse = exports.aDebugOfferRequest = exports.aDateUnit = exports.aCustomValidationError = exports.aCustomParamOperator = exports.aCustomParamCriteria = exports.aCustomParam = exports.aCustomHttpPattern = exports.aCustomFilterOperator = exports.aCustomFilterDataSource = exports.aCustomFilterCriteria = exports.aCrud = exports.aCriteriaType = exports.aCriteriaMetaData = exports.aCreatePlacementResponse = exports.aCreatePlacementRequest = exports.aCreateMethodOptions = void 0;
exports.aListOffersBulkResponse = exports.aListOffersBulkRequest = exports.aListMethodOptions = exports.aListDeletedMethodOptions = exports.aListCriteria = exports.aLevelEnum = exports.aLevel = exports.aLastEventLimit = exports.aLabel = exports.aJSType = exports.anItemPrioritized = exports.anInheritCrudErrors = exports.anIdentityResponse = exports.anIdentityRequestWithServerSigner = exports.anIdentityRequestWithExplicitContext = exports.anIdentityRequest = exports.anIdentity = exports.anIdentificationData = exports.anIdentification2Service = exports.anIdempotencyLevel = exports.aHttp = exports.aHookable = exports.aGetPlacementsBulkResponse = exports.aGetPlacementsBulkRequest = exports.aGetPlacementResponse = exports.aGetPlacementRequest = exports.aGetOfferResponse = exports.aGetOfferRequest = exports.aGetItemMethodOptions = exports.aGetDeletedMethodOptions = exports.aGeneratedCodeInfo = exports.aFrequencyCapsRequestOverrides = exports.aFrequencyCapsOverridesType = exports.aFrequencyCapsExecutionResult = exports.aFrequencyCapsEvents = exports.aFrequencyCapsEventType = exports.aFrequencyCapsConfig = exports.aFrequencyCapsConditionsResult = exports.aFrequencyCaps = exports.aFreeSiteCriteriaEnum = exports.aFreeSiteCriteria = exports.aFormat = exports.aFixedItem = exports.aFileOptions = exports.aFileDescriptorSet = exports.aFieldSet = exports.aFieldOptions = exports.aFieldDescriptorProtoType = exports.aFieldDescriptorProto = exports.anExternalFilterProviderConfig = void 0;
exports.aPriorityItem = exports.aPrioritizationStrategyParams = exports.aPrioritizationStrategyOverrides = exports.aPrioritizationStrategyConfig = exports.aPrioritizationStrategy = exports.aPrioritizationABTestStrategies = exports.aPremiumPlanCriteria = exports.aPremiumLandingTabCriteriaEnum = exports.aPremiumLandingTabCriteria = exports.aPremiumAccountCriteriaEnum = exports.aPremiumAccountCriteria = exports.aPlan = exports.aPlacementStatus = exports.aPlacement = exports.aPersonType = exports.aPerson = exports.aPermissionType = exports.aPermissionRule = exports.aParentAccount = exports.aPagingType = exports.aPaging = exports.anOptimizeMode = exports.anOperatorValueTypeEnum = exports.anOperatorValueType = exports.anOperatorFieldSupport = exports.anOneofOptions = exports.anOneofDescriptorProto = exports.anOffersConfig = exports.anOffer = exports.aNullValue = exports.aNamePart = exports.aMethodOptions = exports.aMethodDescriptorProto = exports.aMethod = exports.aMetaSiteIdInContext = exports.aMessageOptions = exports.aMessageAppendixType = exports.aMessageAppendix = exports.aMaturity = exports.aManagerLocalizationIdsWrapper = exports.aManagerIdsWrapper = exports.aMailboxCriteriaEnum = exports.aMailboxCriteria = exports.aLocation = exports.aLocalizedData = exports.aListValue = exports.aListPlacementsResponse = exports.aListPlacementsRequest = exports.aListOffersResponse = exports.aListOffersRequest = void 0;
exports.anUpdatePlacementSlugResponse = exports.anUpdatePlacementSlugRequest = exports.anUpdatePlacementResponse = exports.anUpdatePlacementRequest = exports.anUpdateMethodOptions = exports.anUnique = exports.anUninterpretedOption = exports.aTranslatableType = exports.aTranslatable = exports.aTargeting = exports.aStatusCodesHttpStatusCode = exports.aStatusCodes = exports.aSpiService = exports.aSpiHttpStatusCode = exports.aSpiError = exports.aSourceCodeInfo = exports.aSort = exports.aSiteTypeCriteria = exports.aSiteType = exports.aSiteData = exports.aShadowedStrategy = exports.aServiceOptions = exports.aServiceEntity = exports.aServiceDescriptorProto = exports.aServiceAppendixType = exports.aServiceAppendix = exports.aSegmentName = exports.aSegment = exports.aSearchMethodOptions = exports.aSearch = exports.aSchema = exports.aRestoreFromTrashbinMethodOptions = exports.aResolveOfferResponse = exports.aResolveOfferRequest = exports.aReservedRange = exports.aRequiredFields = exports.aRequiredField = exports.aRequestExtensions = exports.aRequestContext = exports.aRemoveFromTrashbinMethodOptions = exports.aReleaseAudienceStatus = exports.aReleaseAudience = exports.aRefreshIdentityResponse = exports.aRefreshIdentityRequest = exports.aReferenceEntityField = exports.aQueryMethodOptions = exports.aPublishStatus = exports.aPublishPlacementResponse = exports.aPublishPlacementRequest = exports.aPublishErrors = void 0;
exports.aWqlOperator = exports.aWql = exports.aWixGlobalData = exports.aWhatsNextConfiguration = exports.aWHATSNEXTConfig = exports.anUserStatusCriteriaEnum = exports.anUserStatusCriteria = exports.anUserRoleCriteriaEnum = exports.anUserRoleCriteria = exports.anUserData = exports.anUserAccountInfo = exports.anUpsertMethodOptions = exports.anUpdatePlacementStatusResponse = exports.anUpdatePlacementStatusRequest = void 0;
/* tslint:disable */
var types_1 = require("./types");
var UnassignedValue = Symbol('empty builder value');
var someBoolean = function () { return Math.random() > 0.5; };
var someDateObject = function () { return new Date(Math.floor(Math.random() * Date.now())); };
var someDateString = function () { return new Date(Math.floor(Math.random() * Date.now())).toISOString(); };
var emptyObject = function () { return ({}); };
var someGuid = function () { return 'xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, function (c) { return '0123456789abcdef'[Math.floor(Math.random() * 16)]; }); };
var someInt = function () { return Math.floor(Math.random() * 1000000); };
var jsonMapOf = function (valueGenerator) {
    return new Array(exports.builderConfig.minArraySize + Math.round(Math.random() * (exports.builderConfig.maxArraySize - exports.builderConfig.minArraySize)))
        .fill(null)
        .map(function () { return [someString(), valueGenerator()]; })
        .reduce(function (jsonMap, _d) {
        var _e;
        var key = _d[0], val = _d[1];
        return (__assign(__assign({}, jsonMap), (_e = {}, _e[key] = val, _e)));
    }, {});
};
var manyOf = function (valueGenerator) {
    return new Array(exports.builderConfig.minArraySize + Math.round(Math.random() * (exports.builderConfig.maxArraySize - exports.builderConfig.minArraySize))).fill(null).map(function () { return valueGenerator(); });
};
var maybe = function (value) {
    var disableOptionals = readConfig('disabledOptionals');
    if (disableOptionals) {
        return value;
    }
    return Math.random() > 0.5 ? value : null;
};
var createNull = function () { return null; };
var someNumber = function () { return Math.random() * 1000000; };
var oneOf = function (valuesArray) { return valuesArray[Math.floor(Math.random() * valuesArray.length)]; };
var readConfig = function (value) {
    var _a, _b, _c;
    var packageJsonPath = process.cwd() + '/package.json';
    try {
        var packageJson = require(packageJsonPath);
        return (_c = (_b = (_a = packageJson) === null || _a === void 0 ? void 0 : _a.ambassador) === null || _b === void 0 ? void 0 : _b.builderConfig) === null || _c === void 0
            ? void 0
            : _c[value];
    }
    catch (e) {
        console.warn('Failed to find ' + packageJsonPath + ", that means you can't use " + value + ' property.');
    }
};
var someString = function () {
    return new Array(Math.round(Math.random() * 32))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_'[Math.floor(Math.random() * 64)]; })
        .join('');
};
var tupleOf = function () {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return items;
};
var someUrl = function () {
    var createString = function (len) {
        return new Array(len)
            .fill(null)
            .map(function () { return 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; })
            .join('');
    };
    return "http" + (Math.random() > 0.5 ? 's' : '') + "://" + createString(2 + Math.round(Math.random() * 8)) + "." + createString(2 + Math.round(Math.random() * 2));
};
var boundedString = function (minLength, maxLength) {
    return new Array(minLength + Math.round(Math.random() * (maxLength - minLength)))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_'[Math.floor(Math.random() * 64)]; })
        .join('');
};
var boundedAToZString = function (minLength, maxLength) {
    return new Array(minLength + Math.round(Math.random() * (maxLength - minLength)))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 62)]; })
        .join('');
};
var emailString = function () { return boundedString(3, 18) + '@' + hostNameString(); };
var hostNameString = function () { return (boundedAToZString(1, 63) + '.' + boundedAToZString(1, 63) + '.' + boundedAToZString(1, 63)).toLowerCase(); };
var iPv4String = function () { return randomInt(120, 255).toString() + '.' + randomInt(0, 255).toString() + '.' + randomInt(0, 255).toString() + '.' + randomInt(0, 255).toString(); };
var iPv6String = function () {
    return randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16);
};
var phoneNumberString = function () { return randomInt(10, 99) + '-' + randomInt(1000, 9999) + '-' + randomInt(1000, 9999); };
var creditCardString = function () {
    var cardsOptions = [
        '4024007144802344',
        '4024007137343835',
        '4024007182408316904',
        '5319296635899189',
        '5313659704319460',
        '5239821231883506',
        '344185148936416',
        '376838602387168',
        '342988587028815',
        '6011063572203257',
        '6011897568342235',
        '6011688334523054321',
        '3532544447293430',
        '3541328171991545',
        '3543520126410292049',
        '5428157918095416',
        '5585210966718113',
        '5421059548115043',
        '30478533536597',
        '30520785757304',
        '30593479645481',
        '36041989673001',
        '36271989122390',
        '36385649757047',
        '6762419374462387',
        '6763799905488186',
        '5018087262076918',
        '4913766714630021',
        '4175006834432617',
        '4913034771805246',
        '6376711457713472',
        '6372692747824846',
        '6397824752439852',
    ];
    return cardsOptions[Math.floor(Math.random() * 32)];
};
var countryString = function () {
    var countryCodes = [
        'AF',
        'AX',
        'AL',
        'DZ',
        'AS',
        'AD',
        'AO',
        'AI',
        'AQ',
        'AG',
        'AR',
        'AM',
        'AW',
        'AU',
        'AT',
        'AZ',
        'BS',
        'BH',
        'BD',
        'BB',
        'BY',
        'BE',
        'BZ',
        'BJ',
        'BM',
        'BT',
        'BO',
        'BQ',
        'BA',
        'BW',
        'BV',
        'BR',
        'IO',
        'BN',
        'BG',
        'BF',
        'BI',
        'KH',
        'CM',
        'CA',
        'CV',
        'KY',
        'CF',
        'TD',
        'CL',
        'CN',
        'CX',
        'CC',
        'CO',
        'KM',
        'CG',
        'CD',
        'CK',
        'CR',
        'CI',
        'HR',
        'CU',
        'CW',
        'CY',
        'CZ',
        'DK',
        'DJ',
        'DM',
        'DO',
        'EC',
        'EG',
        'SV',
        'GQ',
        'ER',
        'EE',
        'ET',
        'FK',
        'FO',
        'FJ',
        'FI',
        'FR',
        'GF',
        'PF',
        'TF',
        'GA',
        'GM',
        'GE',
        'DE',
        'GH',
        'GI',
        'GR',
        'GL',
        'GD',
        'GP',
        'GU',
        'GT',
        'GG',
        'GN',
        'GW',
        'GY',
        'HT',
        'HM',
        'VA',
        'HN',
        'HK',
        'HU',
        'IS',
        'IN',
        'ID',
        'IR',
        'IQ',
        'IE',
        'IM',
        'IL',
        'IT',
        'JM',
        'JP',
        'JE',
        'JO',
        'KZ',
        'KE',
        'KI',
        'KP',
        'KR',
        'KW',
        'KG',
        'LA',
        'LV',
        'LB',
        'LS',
        'LR',
        'LY',
        'LI',
        'LT',
        'LU',
        'MO',
        'MK',
        'MG',
        'MW',
        'MY',
        'MV',
        'ML',
        'MT',
        'MH',
        'MQ',
        'MR',
        'MU',
        'YT',
        'MX',
        'FM',
        'MD',
        'MC',
        'MN',
        'ME',
        'MS',
        'MA',
        'MZ',
        'MM',
        'NA',
        'NR',
        'NP',
        'NL',
        'NC',
        'NZ',
        'NI',
        'NE',
        'NG',
        'NU',
        'NF',
        'MP',
        'NO',
        'OM',
        'PK',
        'PW',
        'PS',
        'PA',
        'PG',
        'PY',
        'PE',
        'PH',
        'PN',
        'PL',
        'PT',
        'PR',
        'QA',
        'RE',
        'RO',
        'RU',
        'RW',
        'BL',
        'SH',
        'KN',
        'LC',
        'MF',
        'PM',
        'VC',
        'WS',
        'SM',
        'ST',
        'SA',
        'SN',
        'RS',
        'SC',
        'SL',
        'SG',
        'SX',
        'SK',
        'SI',
        'SB',
        'SO',
        'ZA',
        'GS',
        'SS',
        'ES',
        'LK',
        'SD',
        'SR',
        'SJ',
        'SZ',
        'SE',
        'CH',
        'SY',
        'TW',
        'TJ',
        'TZ',
        'TH',
        'TL',
        'TG',
        'TK',
        'TO',
        'TT',
        'TN',
        'TR',
        'TM',
        'TC',
        'TV',
        'UG',
        'UA',
        'AE',
        'GB',
        'US',
        'UM',
        'UY',
        'UZ',
        'VU',
        'VE',
        'VN',
        'VG',
        'VI',
        'WF',
        'EH',
        'YE',
        'ZM',
        'ZW',
    ];
    return countryCodes[Math.floor(Math.random() * countryCodes.length)];
};
var languageString = function () {
    var languageCodes = [
        'aa',
        'ab',
        'ae',
        'af',
        'ak',
        'am',
        'an',
        'ar',
        'as',
        'av',
        'ay',
        'az',
        'ba',
        'be',
        'bg',
        'bh',
        'bm',
        'bi',
        'bn',
        'bo',
        'br',
        'bs',
        'ca',
        'ce',
        'ch',
        'co',
        'cr',
        'cs',
        'cu',
        'cv',
        'cy',
        'da',
        'de',
        'dv',
        'dz',
        'ee',
        'el',
        'en',
        'eo',
        'es',
        'et',
        'eu',
        'fa',
        'ff',
        'fi',
        'fj',
        'fo',
        'fr',
        'fy',
        'ga',
        'gd',
        'gl',
        'gn',
        'gu',
        'gv',
        'ha',
        'he',
        'hi',
        'ho',
        'hr',
        'ht',
        'hu',
        'hy',
        'hz',
        'ia',
        'id',
        'ie',
        'ig',
        'ii',
        'ik',
        'io',
        'is',
        'it',
        'iu',
        'ja',
        'jv',
        'ka',
        'kg',
        'ki',
        'kj',
        'kk',
        'kl',
        'km',
        'kn',
        'ko',
        'kr',
        'ks',
        'ku',
        'kv',
        'kw',
        'ky',
        'la',
        'lb',
        'lg',
        'li',
        'ln',
        'lo',
        'lt',
        'lu',
        'lv',
        'mg',
        'mh',
        'mi',
        'mk',
        'ml',
        'mn',
        'mr',
        'ms',
        'mt',
        'my',
        'na',
        'nb',
        'nd',
        'ne',
        'ng',
        'nl',
        'nn',
        'no',
        'nr',
        'nv',
        'ny',
        'oc',
        'oj',
        'om',
        'or',
        'os',
        'pa',
        'pi',
        'pl',
        'ps',
        'pt',
        'qu',
        'rm',
        'rn',
        'ro',
        'ru',
        'rw',
        'sa',
        'sc',
        'sd',
        'se',
        'sg',
        'si',
        'sk',
        'sl',
        'sm',
        'sn',
        'so',
        'sq',
        'sr',
        'ss',
        'st',
        'su',
        'sv',
        'sw',
        'ta',
        'te',
        'tg',
        'th',
        'ti',
        'tk',
        'tl',
        'tn',
        'to',
        'tr',
        'ts',
        'tt',
        'tw',
        'ty',
        'ug',
        'uk',
        'ur',
        'uz',
        've',
        'vi',
        'vo',
        'wa',
        'wo',
        'xh',
        'yi',
        'yo',
        'za',
        'zh',
        'zu',
    ];
    return languageCodes[Math.floor(Math.random() * languageCodes.length)];
};
var uriString = function () { return someUrl(); };
var webUrlString = function () { return someUrl(); };
var currencyString = function () {
    var currenciesArray = [
        'AFN',
        'EUR',
        'ALL',
        'DZD',
        'USD',
        'EUR',
        'AOA',
        'XCD',
        'XCD',
        'ARS',
        'AMD',
        'AWG',
        'AUD',
        'EUR',
        'AZN',
        'BSD',
        'BHD',
        'BDT',
        'BBD',
        'BYN',
        'EUR',
        'BZD',
        'XOF',
        'BMD',
        'INR',
        'BTN',
        'BOB',
        'BOV',
        'USD',
        'BAM',
        'BWP',
        'NOK',
        'BRL',
        'USD',
        'BND',
        'BGN',
        'XOF',
        'BIF',
        'CVE',
        'KHR',
        'XAF',
        'CAD',
        'KYD',
        'XAF',
        'XAF',
        'CLP',
        'CLF',
        'CNY',
        'AUD',
        'AUD',
        'COP',
        'COU',
        'KMF',
        'CDF',
        'XAF',
        'NZD',
        'CRC',
        'XOF',
        'HRK',
        'CUP',
        'CUC',
        'ANG',
        'EUR',
        'CZK',
        'DKK',
        'DJF',
        'XCD',
        'DOP',
        'USD',
        'EGP',
        'SVC',
        'USD',
        'XAF',
        'ERN',
        'EUR',
        'ETB',
        'EUR',
        'FKP',
        'DKK',
        'FJD',
        'EUR',
        'EUR',
        'EUR',
        'XPF',
        'EUR',
        'XAF',
        'GMD',
        'GEL',
        'EUR',
        'GHS',
        'GIP',
        'EUR',
        'DKK',
        'XCD',
        'EUR',
        'USD',
        'GTQ',
        'GBP',
        'GNF',
        'XOF',
        'GYD',
        'HTG',
        'USD',
        'AUD',
        'EUR',
        'HNL',
        'HKD',
        'HUF',
        'ISK',
        'INR',
        'IDR',
        'XDR',
    ];
    return currenciesArray[Math.floor(Math.random() * currenciesArray.length)];
};
var decimalValueString = function () { return randomNumber(0, 100000); };
var colorHexString = function () { return '#' + randomHexString(6).toUpperCase(); };
var randomHexString = function (length) {
    return new Array(length)
        .fill(null)
        .map(function () { return 'abcdef0123456789'[Math.floor(Math.random() * 16)]; })
        .join('');
};
var randomInt = function (min, max) { return Math.floor(Math.random() * (max - min)) + min; };
var randomNumber = function (min, max) { return Math.random() * (max - min) + min; };
var boundedManyOf = function (min, max, valueGenerator) { return new Array(randomInt(min, max)).fill(null).map(function () { return valueGenerator(); }); };
var boundedDecimalString = function (min, gt, max, lt, scale) {
    var rand = randomNumber(min, max).toFixed(scale);
    if (gt || lt) {
        if (rand === min.toFixed(scale) || rand === max.toFixed(scale))
            return randomNumber(min, max).toFixed(scale);
    }
    return rand;
};
exports.defaultMaxArraySize = 3;
exports.defaultMinArraySize = 0;
exports.builderConfig = {
    maxArraySize: exports.defaultMaxArraySize,
    minArraySize: exports.defaultMinArraySize,
};
function resetBuilderConfig() {
    exports.builderConfig.maxArraySize = readConfig('maxArraySize') || exports.defaultMaxArraySize;
    exports.builderConfig.minArraySize = readConfig('minArraySize') || exports.defaultMinArraySize;
}
exports.resetBuilderConfig = resetBuilderConfig;
resetBuilderConfig();
var createDefaultBuildInput = function () { return ({ buildersVisited: {} }); };
var increaseVisit = function (_a) {
    var caseClassName = _a.caseClassName, buildersVisited = _a.buildersVisited;
    // When we recursive building entities, we don't mind that more builders of that kind will be built in our layer (for ex: if some want's an array of that entity).
    // Therefore I change the reference of visitedMap (clone), and only layers beneath this builder will stop if we stuck in a circle.
    // We allow 2 vists in the same node. any deeper building will need manual handling.
    buildersVisited = Object.assign({}, buildersVisited);
    if (!buildersVisited[caseClassName]) {
        buildersVisited[caseClassName] = 1;
    }
    else {
        buildersVisited[caseClassName]++;
    }
    if (buildersVisited[caseClassName] > 2) {
        buildersVisited._isDone = true;
    }
    return buildersVisited;
};
var ABCTRConfigDTOBuilder = /** @class */ (function () {
    function ABCTRConfigDTOBuilder() {
        this._specName = UnassignedValue;
    }
    ABCTRConfigDTOBuilder.prototype.withSpecName = function (_specName) {
        this._specName = _specName;
        return this;
    };
    ABCTRConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ABCTRConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            specName: this._specName !== UnassignedValue ? this._specName : maybe(someString()),
        };
    };
    return ABCTRConfigDTOBuilder;
}());
exports.ABCTRConfigDTOBuilder = ABCTRConfigDTOBuilder;
var AccountDataDTOBuilder = /** @class */ (function () {
    function AccountDataDTOBuilder() {
        this._accountId = UnassignedValue;
    }
    AccountDataDTOBuilder.prototype.withAccountId = function (_accountId) {
        this._accountId = _accountId;
        return this;
    };
    AccountDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AccountData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            accountId: this._accountId !== UnassignedValue ? this._accountId : maybe(someString()),
        };
    };
    return AccountDataDTOBuilder;
}());
exports.AccountDataDTOBuilder = AccountDataDTOBuilder;
var AccountIdInContextDTOBuilder = /** @class */ (function () {
    function AccountIdInContextDTOBuilder() {
        this._targetAccountId = UnassignedValue;
    }
    AccountIdInContextDTOBuilder.prototype.withTargetAccountId = function (_targetAccountId) {
        this._targetAccountId = _targetAccountId;
        return this;
    };
    AccountIdInContextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AccountIdInContext', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            targetAccountId: this._targetAccountId !== UnassignedValue ? this._targetAccountId : maybe(someGuid()),
        };
    };
    return AccountIdInContextDTOBuilder;
}());
exports.AccountIdInContextDTOBuilder = AccountIdInContextDTOBuilder;
var AdvicesDTOBuilder = /** @class */ (function () {
    function AdvicesDTOBuilder() {
        this._advices = UnassignedValue;
    }
    AdvicesDTOBuilder.prototype.withAdvices = function (_advices) {
        this._advices = _advices;
        return this;
    };
    AdvicesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Advices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            advices: this._advices !== UnassignedValue ? this._advices : maybe(manyOf(function () { return someString(); })),
        };
    };
    return AdvicesDTOBuilder;
}());
exports.AdvicesDTOBuilder = AdvicesDTOBuilder;
var AdvicesConfigDTOBuilder = /** @class */ (function () {
    function AdvicesConfigDTOBuilder() {
        this._advices = UnassignedValue;
        this._fallbackStrategy = UnassignedValue;
        this._vespaThreshold = UnassignedValue;
        this._whatsNextCustomParams = UnassignedValue;
    }
    AdvicesConfigDTOBuilder.prototype.withVespaThreshold = function (_vespaThreshold) {
        this._vespaThreshold = _vespaThreshold;
        return this;
    };
    AdvicesConfigDTOBuilder.prototype.withFallbackStrategy = function (_fallbackStrategy) {
        this._fallbackStrategy = _fallbackStrategy;
        return this;
    };
    AdvicesConfigDTOBuilder.prototype.withWhatsNextCustomParams = function (_whatsNextCustomParams) {
        this._whatsNextCustomParams = _whatsNextCustomParams;
        this._advices = UnassignedValue;
        return this;
    };
    AdvicesConfigDTOBuilder.prototype.withAdvices = function (_advices) {
        this._advices = _advices;
        this._whatsNextCustomParams = UnassignedValue;
        return this;
    };
    AdvicesConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AdvicesConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._whatsNextCustomParams === UnassignedValue && this._advices === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['whatsNextCustomParams', 'advices'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                advices: assignRandomOneOf('advices', maybe(exports.anAdvices().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                fallbackStrategy: this._fallbackStrategy !== UnassignedValue ? this._fallbackStrategy : maybe(exports.aPrioritizationStrategy().build({ buildersVisited: buildersVisited })),
                vespaThreshold: this._vespaThreshold !== UnassignedValue ? this._vespaThreshold : maybe(someString()),
                whatsNextCustomParams: assignRandomOneOf('whatsNextCustomParams', maybe(exports.aWhatsNextConfiguration().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            advices: this._advices === UnassignedValue ? undefined : this._advices,
            fallbackStrategy: this._fallbackStrategy !== UnassignedValue ? this._fallbackStrategy : maybe(exports.aPrioritizationStrategy().build({ buildersVisited: buildersVisited })),
            vespaThreshold: this._vespaThreshold !== UnassignedValue ? this._vespaThreshold : maybe(someString()),
            whatsNextCustomParams: this._whatsNextCustomParams === UnassignedValue ? undefined : this._whatsNextCustomParams,
        };
    };
    return AdvicesConfigDTOBuilder;
}());
exports.AdvicesConfigDTOBuilder = AdvicesConfigDTOBuilder;
var AlignedWithEnumDTOBuilder = /** @class */ (function () {
    function AlignedWithEnumDTOBuilder() {
        this._field = UnassignedValue;
        this._suffix = UnassignedValue;
    }
    AlignedWithEnumDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    AlignedWithEnumDTOBuilder.prototype.withSuffix = function (_suffix) {
        this._suffix = _suffix;
        return this;
    };
    AlignedWithEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AlignedWithEnum', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(someString()),
            suffix: this._suffix !== UnassignedValue ? this._suffix : maybe(someString()),
        };
    };
    return AlignedWithEnumDTOBuilder;
}());
exports.AlignedWithEnumDTOBuilder = AlignedWithEnumDTOBuilder;
var AnnotationDTOBuilder = /** @class */ (function () {
    function AnnotationDTOBuilder() {
        this._begin = UnassignedValue;
        this._end = UnassignedValue;
        this._path = UnassignedValue;
        this._sourceFile = UnassignedValue;
    }
    AnnotationDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    AnnotationDTOBuilder.prototype.withSourceFile = function (_sourceFile) {
        this._sourceFile = _sourceFile;
        return this;
    };
    AnnotationDTOBuilder.prototype.withBegin = function (_begin) {
        this._begin = _begin;
        return this;
    };
    AnnotationDTOBuilder.prototype.withEnd = function (_end) {
        this._end = _end;
        return this;
    };
    AnnotationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Annotation', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            begin: this._begin !== UnassignedValue ? this._begin : maybe(someInt()),
            end: this._end !== UnassignedValue ? this._end : maybe(someInt()),
            path: this._path !== UnassignedValue ? this._path : maybe(manyOf(function () { return someInt(); })),
            sourceFile: this._sourceFile !== UnassignedValue ? this._sourceFile : maybe(someString()),
        };
    };
    return AnnotationDTOBuilder;
}());
exports.AnnotationDTOBuilder = AnnotationDTOBuilder;
var ApiErrorDTOBuilder = /** @class */ (function () {
    function ApiErrorDTOBuilder() {
        this._applicationCode = UnassignedValue;
        this._data = UnassignedValue;
        this._httpCode = UnassignedValue;
    }
    ApiErrorDTOBuilder.prototype.withHttpCode = function (_httpCode) {
        this._httpCode = _httpCode;
        return this;
    };
    ApiErrorDTOBuilder.prototype.withApplicationCode = function (_applicationCode) {
        this._applicationCode = _applicationCode;
        return this;
    };
    ApiErrorDTOBuilder.prototype.withData = function (_data) {
        this._data = _data;
        return this;
    };
    ApiErrorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApiError', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            applicationCode: this._applicationCode !== UnassignedValue ? this._applicationCode : maybe(someString()),
            data: this._data !== UnassignedValue ? this._data : maybe(someString()),
            httpCode: this._httpCode !== UnassignedValue ? this._httpCode : maybe(exports.aStatusCodesHttpStatusCode().build({ buildersVisited: buildersVisited })),
        };
    };
    return ApiErrorDTOBuilder;
}());
exports.ApiErrorDTOBuilder = ApiErrorDTOBuilder;
var AppScopeDTOBuilder = /** @class */ (function () {
    function AppScopeDTOBuilder() {
        this._appDefId = UnassignedValue;
        this._appVersion = UnassignedValue;
    }
    AppScopeDTOBuilder.prototype.withAppDefId = function (_appDefId) {
        this._appDefId = _appDefId;
        return this;
    };
    AppScopeDTOBuilder.prototype.withAppVersion = function (_appVersion) {
        this._appVersion = _appVersion;
        return this;
    };
    AppScopeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AppScope', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
            appVersion: this._appVersion !== UnassignedValue ? this._appVersion : maybe(someString()),
        };
    };
    return AppScopeDTOBuilder;
}());
exports.AppScopeDTOBuilder = AppScopeDTOBuilder;
var ApplyFilterListRequestDTOBuilder = /** @class */ (function () {
    function ApplyFilterListRequestDTOBuilder() {
        this._criteriaList = UnassignedValue;
    }
    ApplyFilterListRequestDTOBuilder.prototype.withCriteriaList = function (_criteriaList) {
        this._criteriaList = _criteriaList;
        return this;
    };
    ApplyFilterListRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplyFilterListRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            criteriaList: this._criteriaList !== UnassignedValue ? this._criteriaList : maybe(manyOf(function () { return exports.anExternalFilterCriteria().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ApplyFilterListRequestDTOBuilder;
}());
exports.ApplyFilterListRequestDTOBuilder = ApplyFilterListRequestDTOBuilder;
var ApplyFilterListResponseDTOBuilder = /** @class */ (function () {
    function ApplyFilterListResponseDTOBuilder() {
        this._applyFiltersResult = UnassignedValue;
    }
    ApplyFilterListResponseDTOBuilder.prototype.withApplyFiltersResult = function (_applyFiltersResult) {
        this._applyFiltersResult = _applyFiltersResult;
        return this;
    };
    ApplyFilterListResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplyFilterListResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            applyFiltersResult: this._applyFiltersResult !== UnassignedValue ? this._applyFiltersResult : maybe(manyOf(function () { return exports.anApplyFilterResult().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ApplyFilterListResponseDTOBuilder;
}());
exports.ApplyFilterListResponseDTOBuilder = ApplyFilterListResponseDTOBuilder;
var ApplyFilterRequestDTOBuilder = /** @class */ (function () {
    function ApplyFilterRequestDTOBuilder() {
        this._criteria = UnassignedValue;
    }
    ApplyFilterRequestDTOBuilder.prototype.withCriteria = function (_criteria) {
        this._criteria = _criteria;
        return this;
    };
    ApplyFilterRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplyFilterRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            criteria: this._criteria !== UnassignedValue ? this._criteria : maybe(exports.anExternalFilterCriteria().build({ buildersVisited: buildersVisited })),
        };
    };
    return ApplyFilterRequestDTOBuilder;
}());
exports.ApplyFilterRequestDTOBuilder = ApplyFilterRequestDTOBuilder;
var ApplyFilterResponseDTOBuilder = /** @class */ (function () {
    function ApplyFilterResponseDTOBuilder() {
        this._isApplicable = UnassignedValue;
    }
    ApplyFilterResponseDTOBuilder.prototype.withIsApplicable = function (_isApplicable) {
        this._isApplicable = _isApplicable;
        return this;
    };
    ApplyFilterResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplyFilterResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            isApplicable: this._isApplicable !== UnassignedValue ? this._isApplicable : maybe(someBoolean()),
        };
    };
    return ApplyFilterResponseDTOBuilder;
}());
exports.ApplyFilterResponseDTOBuilder = ApplyFilterResponseDTOBuilder;
var ApplyFilterResultDTOBuilder = /** @class */ (function () {
    function ApplyFilterResultDTOBuilder() {
        this._id = UnassignedValue;
        this._isApplicable = UnassignedValue;
    }
    ApplyFilterResultDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    ApplyFilterResultDTOBuilder.prototype.withIsApplicable = function (_isApplicable) {
        this._isApplicable = _isApplicable;
        return this;
    };
    ApplyFilterResultDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplyFilterResult', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            id: this._id !== UnassignedValue ? this._id : maybe(someGuid()),
            isApplicable: this._isApplicable !== UnassignedValue ? this._isApplicable : maybe(someBoolean()),
        };
    };
    return ApplyFilterResultDTOBuilder;
}());
exports.ApplyFilterResultDTOBuilder = ApplyFilterResultDTOBuilder;
var AssetDTOBuilder = /** @class */ (function () {
    function AssetDTOBuilder() {
        this._creative = UnassignedValue;
        this._dynamicParams = UnassignedValue;
        this._localizedData = UnassignedValue;
        this._payloadJson = UnassignedValue;
    }
    AssetDTOBuilder.prototype.withPayloadJson = function (_payloadJson) {
        this._payloadJson = _payloadJson;
        return this;
    };
    AssetDTOBuilder.prototype.withDynamicParams = function (_dynamicParams) {
        this._dynamicParams = _dynamicParams;
        return this;
    };
    AssetDTOBuilder.prototype.withLocalizedData = function (_localizedData) {
        this._localizedData = _localizedData;
        return this;
    };
    AssetDTOBuilder.prototype.withCreative = function (_creative) {
        this._creative = _creative;
        return this;
    };
    AssetDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Asset', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            creative: this._creative !== UnassignedValue ? this._creative : maybe(jsonMapOf(function () { return createNull(); })),
            dynamicParams: this._dynamicParams !== UnassignedValue ? this._dynamicParams : maybe(jsonMapOf(function () { return someString(); })),
            localizedData: this._localizedData !== UnassignedValue ? this._localizedData : maybe(exports.aLocalizedData().build({ buildersVisited: buildersVisited })),
            payloadJson: this._payloadJson !== UnassignedValue ? this._payloadJson : maybe(someString()),
        };
    };
    return AssetDTOBuilder;
}());
exports.AssetDTOBuilder = AssetDTOBuilder;
var BrandDTOBuilder = /** @class */ (function () {
    function BrandDTOBuilder() {
    }
    BrandDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Brand.UNKNOWN, types_1.Brand.WIX, types_1.Brand.EDITORX, types_1.Brand.DAYFUL, types_1.Brand.STUDIO]);
    };
    return BrandDTOBuilder;
}());
exports.BrandDTOBuilder = BrandDTOBuilder;
var BrandsCriteriaDTOBuilder = /** @class */ (function () {
    function BrandsCriteriaDTOBuilder() {
        this._included = UnassignedValue;
        this._values = UnassignedValue;
    }
    BrandsCriteriaDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    BrandsCriteriaDTOBuilder.prototype.withIncluded = function (_included) {
        this._included = _included;
        return this;
    };
    BrandsCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BrandsCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            included: this._included !== UnassignedValue ? this._included : maybe(someBoolean()),
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return exports.aBrand().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return BrandsCriteriaDTOBuilder;
}());
exports.BrandsCriteriaDTOBuilder = BrandsCriteriaDTOBuilder;
var BulkCreateMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkCreateMethodOptionsDTOBuilder() {
        this._itemField = UnassignedValue;
    }
    BulkCreateMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    BulkCreateMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkCreateMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return BulkCreateMethodOptionsDTOBuilder;
}());
exports.BulkCreateMethodOptionsDTOBuilder = BulkCreateMethodOptionsDTOBuilder;
var BulkDeleteByFilterMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkDeleteByFilterMethodOptionsDTOBuilder() {
        this._filterField = UnassignedValue;
    }
    BulkDeleteByFilterMethodOptionsDTOBuilder.prototype.withFilterField = function (_filterField) {
        this._filterField = _filterField;
        return this;
    };
    BulkDeleteByFilterMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkDeleteByFilterMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            filterField: this._filterField !== UnassignedValue ? this._filterField : maybe(someString()),
        };
    };
    return BulkDeleteByFilterMethodOptionsDTOBuilder;
}());
exports.BulkDeleteByFilterMethodOptionsDTOBuilder = BulkDeleteByFilterMethodOptionsDTOBuilder;
var BulkDeleteMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkDeleteMethodOptionsDTOBuilder() {
        this._idsField = UnassignedValue;
    }
    BulkDeleteMethodOptionsDTOBuilder.prototype.withIdsField = function (_idsField) {
        this._idsField = _idsField;
        return this;
    };
    BulkDeleteMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkDeleteMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idsField: this._idsField !== UnassignedValue ? this._idsField : maybe(someString()),
        };
    };
    return BulkDeleteMethodOptionsDTOBuilder;
}());
exports.BulkDeleteMethodOptionsDTOBuilder = BulkDeleteMethodOptionsDTOBuilder;
var BulkUpdateByFilterMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkUpdateByFilterMethodOptionsDTOBuilder() {
        this._fieldmaskField = UnassignedValue;
        this._filterField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    BulkUpdateByFilterMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    BulkUpdateByFilterMethodOptionsDTOBuilder.prototype.withFieldmaskField = function (_fieldmaskField) {
        this._fieldmaskField = _fieldmaskField;
        return this;
    };
    BulkUpdateByFilterMethodOptionsDTOBuilder.prototype.withFilterField = function (_filterField) {
        this._filterField = _filterField;
        return this;
    };
    BulkUpdateByFilterMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkUpdateByFilterMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fieldmaskField: this._fieldmaskField !== UnassignedValue ? this._fieldmaskField : maybe(someString()),
            filterField: this._filterField !== UnassignedValue ? this._filterField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return BulkUpdateByFilterMethodOptionsDTOBuilder;
}());
exports.BulkUpdateByFilterMethodOptionsDTOBuilder = BulkUpdateByFilterMethodOptionsDTOBuilder;
var BulkUpdateMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkUpdateMethodOptionsDTOBuilder() {
        this._fieldmaskField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    BulkUpdateMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    BulkUpdateMethodOptionsDTOBuilder.prototype.withFieldmaskField = function (_fieldmaskField) {
        this._fieldmaskField = _fieldmaskField;
        return this;
    };
    BulkUpdateMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkUpdateMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fieldmaskField: this._fieldmaskField !== UnassignedValue ? this._fieldmaskField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return BulkUpdateMethodOptionsDTOBuilder;
}());
exports.BulkUpdateMethodOptionsDTOBuilder = BulkUpdateMethodOptionsDTOBuilder;
var BulkUpsertMethodOptionsDTOBuilder = /** @class */ (function () {
    function BulkUpsertMethodOptionsDTOBuilder() {
        this._fieldmaskField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    BulkUpsertMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    BulkUpsertMethodOptionsDTOBuilder.prototype.withFieldmaskField = function (_fieldmaskField) {
        this._fieldmaskField = _fieldmaskField;
        return this;
    };
    BulkUpsertMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BulkUpsertMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fieldmaskField: this._fieldmaskField !== UnassignedValue ? this._fieldmaskField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return BulkUpsertMethodOptionsDTOBuilder;
}());
exports.BulkUpsertMethodOptionsDTOBuilder = BulkUpsertMethodOptionsDTOBuilder;
var BytesValueDTOBuilder = /** @class */ (function () {
    function BytesValueDTOBuilder() {
        this._value = UnassignedValue;
    }
    BytesValueDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    BytesValueDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BytesValue', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(someString()),
        };
    };
    return BytesValueDTOBuilder;
}());
exports.BytesValueDTOBuilder = BytesValueDTOBuilder;
var CTypeDTOBuilder = /** @class */ (function () {
    function CTypeDTOBuilder() {
    }
    CTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CType.STRING, types_1.CType.CORD, types_1.CType.STRING_PIECE]);
    };
    return CTypeDTOBuilder;
}());
exports.CTypeDTOBuilder = CTypeDTOBuilder;
var CacheDTOBuilder = /** @class */ (function () {
    function CacheDTOBuilder() {
    }
    CacheDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Cache', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return CacheDTOBuilder;
}());
exports.CacheDTOBuilder = CacheDTOBuilder;
var CacheSettingsDTOBuilder = /** @class */ (function () {
    function CacheSettingsDTOBuilder() {
        this._maxAgeSeconds = UnassignedValue;
    }
    CacheSettingsDTOBuilder.prototype.withMaxAgeSeconds = function (_maxAgeSeconds) {
        this._maxAgeSeconds = _maxAgeSeconds;
        return this;
    };
    CacheSettingsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CacheSettings', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            maxAgeSeconds: this._maxAgeSeconds !== UnassignedValue ? this._maxAgeSeconds : maybe(someInt()),
        };
    };
    return CacheSettingsDTOBuilder;
}());
exports.CacheSettingsDTOBuilder = CacheSettingsDTOBuilder;
var CallbackDTOBuilder = /** @class */ (function () {
    function CallbackDTOBuilder() {
        this._eventType = UnassignedValue;
        this._exposure = UnassignedValue;
        this._maturity = UnassignedValue;
        this._payload = UnassignedValue;
        this._permission = UnassignedValue;
        this._segment = UnassignedValue;
        this._topic = UnassignedValue;
    }
    CallbackDTOBuilder.prototype.withTopic = function (_topic) {
        this._topic = _topic;
        return this;
    };
    CallbackDTOBuilder.prototype.withSegment = function (_segment) {
        this._segment = _segment;
        return this;
    };
    CallbackDTOBuilder.prototype.withPayload = function (_payload) {
        this._payload = _payload;
        return this;
    };
    CallbackDTOBuilder.prototype.withPermission = function (_permission) {
        this._permission = _permission;
        return this;
    };
    CallbackDTOBuilder.prototype.withEventType = function (_eventType) {
        this._eventType = _eventType;
        return this;
    };
    CallbackDTOBuilder.prototype.withExposure = function (_exposure) {
        this._exposure = _exposure;
        return this;
    };
    CallbackDTOBuilder.prototype.withMaturity = function (_maturity) {
        this._maturity = _maturity;
        return this;
    };
    CallbackDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Callback', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventType: this._eventType !== UnassignedValue ? this._eventType : maybe(exports.aCallbackEventType().build({ buildersVisited: buildersVisited })),
            exposure: this._exposure !== UnassignedValue ? this._exposure : maybe(exports.anExposure().build({ buildersVisited: buildersVisited })),
            maturity: this._maturity !== UnassignedValue ? this._maturity : maybe(exports.aMaturity().build({ buildersVisited: buildersVisited })),
            payload: this._payload !== UnassignedValue ? this._payload : maybe(someString()),
            permission: this._permission !== UnassignedValue ? this._permission : maybe(someString()),
            segment: this._segment !== UnassignedValue ? this._segment : maybe(exports.aSegmentName().build({ buildersVisited: buildersVisited })),
            topic: this._topic !== UnassignedValue ? this._topic : maybe(someString()),
        };
    };
    return CallbackDTOBuilder;
}());
exports.CallbackDTOBuilder = CallbackDTOBuilder;
var CallbackDeprecationDTOBuilder = /** @class */ (function () {
    function CallbackDeprecationDTOBuilder() {
        this._customSlug = UnassignedValue;
        this._eventType = UnassignedValue;
        this._payload = UnassignedValue;
        this._replacedBy = UnassignedValue;
        this._targetRemovalDate = UnassignedValue;
    }
    CallbackDeprecationDTOBuilder.prototype.withReplacedBy = function (_replacedBy) {
        this._replacedBy = _replacedBy;
        return this;
    };
    CallbackDeprecationDTOBuilder.prototype.withTargetRemovalDate = function (_targetRemovalDate) {
        this._targetRemovalDate = _targetRemovalDate;
        return this;
    };
    CallbackDeprecationDTOBuilder.prototype.withEventType = function (_eventType) {
        this._eventType = _eventType;
        return this;
    };
    CallbackDeprecationDTOBuilder.prototype.withCustomSlug = function (_customSlug) {
        this._customSlug = _customSlug;
        return this;
    };
    CallbackDeprecationDTOBuilder.prototype.withPayload = function (_payload) {
        this._payload = _payload;
        return this;
    };
    CallbackDeprecationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CallbackDeprecation', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customSlug: this._customSlug !== UnassignedValue ? this._customSlug : maybe(someString()),
            eventType: this._eventType !== UnassignedValue ? this._eventType : maybe(exports.aCallbackEventType().build({ buildersVisited: buildersVisited })),
            payload: this._payload !== UnassignedValue ? this._payload : maybe(someString()),
            replacedBy: this._replacedBy !== UnassignedValue ? this._replacedBy : maybe(someString()),
            targetRemovalDate: this._targetRemovalDate !== UnassignedValue ? this._targetRemovalDate : maybe(someString()),
        };
    };
    return CallbackDeprecationDTOBuilder;
}());
exports.CallbackDeprecationDTOBuilder = CallbackDeprecationDTOBuilder;
var CallbackEventTypeDTOBuilder = /** @class */ (function () {
    function CallbackEventTypeDTOBuilder() {
    }
    CallbackEventTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CallbackEventType.UNKNOWN, types_1.CallbackEventType.CREATED, types_1.CallbackEventType.UPDATED, types_1.CallbackEventType.DELETED, types_1.CallbackEventType.ACTION]);
    };
    return CallbackEventTypeDTOBuilder;
}());
exports.CallbackEventTypeDTOBuilder = CallbackEventTypeDTOBuilder;
var ComparatorTypeDTOBuilder = /** @class */ (function () {
    function ComparatorTypeDTOBuilder() {
    }
    ComparatorTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ComparatorType', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return ComparatorTypeDTOBuilder;
}());
exports.ComparatorTypeDTOBuilder = ComparatorTypeDTOBuilder;
var ComparatorTypeEnumDTOBuilder = /** @class */ (function () {
    function ComparatorTypeEnumDTOBuilder() {
    }
    ComparatorTypeEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ComparatorTypeEnum.UNKNOWN,
            types_1.ComparatorTypeEnum.EQUAL,
            types_1.ComparatorTypeEnum.CONTAINED_IN,
            types_1.ComparatorTypeEnum.CONTAINS_SOME,
            types_1.ComparatorTypeEnum.CONTAINS_NONE,
            types_1.ComparatorTypeEnum.NOT_CONTAINS,
            types_1.ComparatorTypeEnum.NOT_CONTAINED_IN,
            types_1.ComparatorTypeEnum.BE_NOTHING,
            types_1.ComparatorTypeEnum.EXISTS,
            types_1.ComparatorTypeEnum.MORE_THAN_DAYS,
            types_1.ComparatorTypeEnum.WITHIN_DAYS,
            types_1.ComparatorTypeEnum.LESS,
            types_1.ComparatorTypeEnum.LESS_EQUAL,
            types_1.ComparatorTypeEnum.GREATER,
            types_1.ComparatorTypeEnum.GREATER_EQUAL,
            types_1.ComparatorTypeEnum.SIZE_LESS_EQUAL,
            types_1.ComparatorTypeEnum.SIZE_GREATER_EQUAL,
            types_1.ComparatorTypeEnum.NOT_EQUAL,
        ]);
    };
    return ComparatorTypeEnumDTOBuilder;
}());
exports.ComparatorTypeEnumDTOBuilder = ComparatorTypeEnumDTOBuilder;
var CompoundCriteriaDTOBuilder = /** @class */ (function () {
    function CompoundCriteriaDTOBuilder() {
        this._children = UnassignedValue;
        this._operator = UnassignedValue;
    }
    CompoundCriteriaDTOBuilder.prototype.withOperator = function (_operator) {
        this._operator = _operator;
        return this;
    };
    CompoundCriteriaDTOBuilder.prototype.withChildren = function (_children) {
        this._children = _children;
        return this;
    };
    CompoundCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CompoundCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            children: this._children !== UnassignedValue ? this._children : maybe(manyOf(function () { return exports.aTargeting().build({ buildersVisited: buildersVisited }); })),
            operator: this._operator !== UnassignedValue ? this._operator : maybe(exports.aCompoundCriteriaOperator().build({ buildersVisited: buildersVisited })),
        };
    };
    return CompoundCriteriaDTOBuilder;
}());
exports.CompoundCriteriaDTOBuilder = CompoundCriteriaDTOBuilder;
var CompoundCriteriaOperatorDTOBuilder = /** @class */ (function () {
    function CompoundCriteriaOperatorDTOBuilder() {
    }
    CompoundCriteriaOperatorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CompoundCriteriaOperator.UNKNOWN, types_1.CompoundCriteriaOperator.OR, types_1.CompoundCriteriaOperator.AND]);
    };
    return CompoundCriteriaOperatorDTOBuilder;
}());
exports.CompoundCriteriaOperatorDTOBuilder = CompoundCriteriaOperatorDTOBuilder;
var ConditionalDTOBuilder = /** @class */ (function () {
    function ConditionalDTOBuilder() {
        this._permission = UnassignedValue;
        this._requestedField = UnassignedValue;
    }
    ConditionalDTOBuilder.prototype.withPermission = function (_permission) {
        this._permission = _permission;
        return this;
    };
    ConditionalDTOBuilder.prototype.withRequestedField = function (_requestedField) {
        this._requestedField = _requestedField;
        return this;
    };
    ConditionalDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Conditional', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            permission: this._permission !== UnassignedValue ? this._permission : maybe(someString()),
            requestedField: this._requestedField !== UnassignedValue ? this._requestedField : maybe(someString()),
        };
    };
    return ConditionalDTOBuilder;
}());
exports.ConditionalDTOBuilder = ConditionalDTOBuilder;
var ConditionsDTOBuilder = /** @class */ (function () {
    function ConditionsDTOBuilder() {
        this._closes = UnassignedValue;
        this._mainCtaClicks = UnassignedValue;
        this._showLater = UnassignedValue;
        this._skips = UnassignedValue;
        this._views = UnassignedValue;
    }
    ConditionsDTOBuilder.prototype.withViews = function (_views) {
        this._views = _views;
        return this;
    };
    ConditionsDTOBuilder.prototype.withMainCtaClicks = function (_mainCtaClicks) {
        this._mainCtaClicks = _mainCtaClicks;
        return this;
    };
    ConditionsDTOBuilder.prototype.withSkips = function (_skips) {
        this._skips = _skips;
        return this;
    };
    ConditionsDTOBuilder.prototype.withCloses = function (_closes) {
        this._closes = _closes;
        return this;
    };
    ConditionsDTOBuilder.prototype.withShowLater = function (_showLater) {
        this._showLater = _showLater;
        return this;
    };
    ConditionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Conditions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            closes: this._closes !== UnassignedValue ? this._closes : maybe(exports.anEventsCountLimit().build({ buildersVisited: buildersVisited })),
            mainCtaClicks: this._mainCtaClicks !== UnassignedValue ? this._mainCtaClicks : maybe(exports.anEventsCountLimit().build({ buildersVisited: buildersVisited })),
            showLater: this._showLater !== UnassignedValue ? this._showLater : maybe(exports.aLastEventLimit().build({ buildersVisited: buildersVisited })),
            skips: this._skips !== UnassignedValue ? this._skips : maybe(exports.anEventsCountLimit().build({ buildersVisited: buildersVisited })),
            views: this._views !== UnassignedValue ? this._views : maybe(exports.anEventsCountLimit().build({ buildersVisited: buildersVisited })),
        };
    };
    return ConditionsDTOBuilder;
}());
exports.ConditionsDTOBuilder = ConditionsDTOBuilder;
var ConnectedDomainCriteriaDTOBuilder = /** @class */ (function () {
    function ConnectedDomainCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    ConnectedDomainCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    ConnectedDomainCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ConnectedDomainCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aConnectedDomainCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return ConnectedDomainCriteriaDTOBuilder;
}());
exports.ConnectedDomainCriteriaDTOBuilder = ConnectedDomainCriteriaDTOBuilder;
var ConnectedDomainCriteriaEnumDTOBuilder = /** @class */ (function () {
    function ConnectedDomainCriteriaEnumDTOBuilder() {
    }
    ConnectedDomainCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.ConnectedDomainCriteriaEnum.UNKNOWN, types_1.ConnectedDomainCriteriaEnum.CONNECTED, types_1.ConnectedDomainCriteriaEnum.NOT_CONNECTED]);
    };
    return ConnectedDomainCriteriaEnumDTOBuilder;
}());
exports.ConnectedDomainCriteriaEnumDTOBuilder = ConnectedDomainCriteriaEnumDTOBuilder;
var ContextDTOBuilder = /** @class */ (function () {
    function ContextDTOBuilder() {
        this._appDefId = UnassignedValue;
        this._appScope = UnassignedValue;
        this._instanceId = UnassignedValue;
        this._metasiteId = UnassignedValue;
        this._parentAccount = UnassignedValue;
        this._siteMemberId = UnassignedValue;
        this._targetAccountId = UnassignedValue;
        this._visitorId = UnassignedValue;
    }
    ContextDTOBuilder.prototype.withAppDefId = function (_appDefId) {
        this._appDefId = _appDefId;
        return this;
    };
    ContextDTOBuilder.prototype.withInstanceId = function (_instanceId) {
        this._instanceId = _instanceId;
        return this;
    };
    ContextDTOBuilder.prototype.withMetasiteId = function (_metasiteId) {
        this._metasiteId = _metasiteId;
        return this;
    };
    ContextDTOBuilder.prototype.withSiteMemberId = function (_siteMemberId) {
        this._siteMemberId = _siteMemberId;
        return this;
    };
    ContextDTOBuilder.prototype.withTargetAccountId = function (_targetAccountId) {
        this._targetAccountId = _targetAccountId;
        return this;
    };
    ContextDTOBuilder.prototype.withVisitorId = function (_visitorId) {
        this._visitorId = _visitorId;
        return this;
    };
    ContextDTOBuilder.prototype.withAppScope = function (_appScope) {
        this._appScope = _appScope;
        return this;
    };
    ContextDTOBuilder.prototype.withParentAccount = function (_parentAccount) {
        this._parentAccount = _parentAccount;
        return this;
    };
    ContextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Context', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
            appScope: this._appScope !== UnassignedValue ? this._appScope : maybe(exports.anAppScope().build({ buildersVisited: buildersVisited })),
            instanceId: this._instanceId !== UnassignedValue ? this._instanceId : maybe(someString()),
            metasiteId: this._metasiteId !== UnassignedValue ? this._metasiteId : maybe(someString()),
            parentAccount: this._parentAccount !== UnassignedValue ? this._parentAccount : maybe(exports.aParentAccount().build({ buildersVisited: buildersVisited })),
            siteMemberId: this._siteMemberId !== UnassignedValue ? this._siteMemberId : maybe(someString()),
            targetAccountId: this._targetAccountId !== UnassignedValue ? this._targetAccountId : maybe(someString()),
            visitorId: this._visitorId !== UnassignedValue ? this._visitorId : maybe(someString()),
        };
    };
    return ContextDTOBuilder;
}());
exports.ContextDTOBuilder = ContextDTOBuilder;
var CountOptionsDTOBuilder = /** @class */ (function () {
    function CountOptionsDTOBuilder() {
        this._inheritWqlFrom = UnassignedValue;
    }
    CountOptionsDTOBuilder.prototype.withInheritWqlFrom = function (_inheritWqlFrom) {
        this._inheritWqlFrom = _inheritWqlFrom;
        return this;
    };
    CountOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CountOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            inheritWqlFrom: this._inheritWqlFrom !== UnassignedValue ? this._inheritWqlFrom : maybe(someString()),
        };
    };
    return CountOptionsDTOBuilder;
}());
exports.CountOptionsDTOBuilder = CountOptionsDTOBuilder;
var CountTypeDTOBuilder = /** @class */ (function () {
    function CountTypeDTOBuilder() {
    }
    CountTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CountType.UNKNOWN, types_1.CountType.TOTAL, types_1.CountType.DAYS]);
    };
    return CountTypeDTOBuilder;
}());
exports.CountTypeDTOBuilder = CountTypeDTOBuilder;
var CreateMethodOptionsDTOBuilder = /** @class */ (function () {
    function CreateMethodOptionsDTOBuilder() {
        this._itemField = UnassignedValue;
    }
    CreateMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    CreateMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreateMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return CreateMethodOptionsDTOBuilder;
}());
exports.CreateMethodOptionsDTOBuilder = CreateMethodOptionsDTOBuilder;
var CreatePlacementRequestDTOBuilder = /** @class */ (function () {
    function CreatePlacementRequestDTOBuilder() {
        this._placement = UnassignedValue;
    }
    CreatePlacementRequestDTOBuilder.prototype.withPlacement = function (_placement) {
        this._placement = _placement;
        return this;
    };
    CreatePlacementRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreatePlacementRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placement: this._placement !== UnassignedValue ? this._placement : maybe(exports.aPlacement().build({ buildersVisited: buildersVisited })),
        };
    };
    return CreatePlacementRequestDTOBuilder;
}());
exports.CreatePlacementRequestDTOBuilder = CreatePlacementRequestDTOBuilder;
var CreatePlacementResponseDTOBuilder = /** @class */ (function () {
    function CreatePlacementResponseDTOBuilder() {
        this._placement = UnassignedValue;
    }
    CreatePlacementResponseDTOBuilder.prototype.withPlacement = function (_placement) {
        this._placement = _placement;
        return this;
    };
    CreatePlacementResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreatePlacementResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placement: this._placement !== UnassignedValue ? this._placement : maybe(exports.aPlacement().build({ buildersVisited: buildersVisited })),
        };
    };
    return CreatePlacementResponseDTOBuilder;
}());
exports.CreatePlacementResponseDTOBuilder = CreatePlacementResponseDTOBuilder;
var CriteriaMetaDataDTOBuilder = /** @class */ (function () {
    function CriteriaMetaDataDTOBuilder() {
        this._label = UnassignedValue;
    }
    CriteriaMetaDataDTOBuilder.prototype.withLabel = function (_label) {
        this._label = _label;
        return this;
    };
    CriteriaMetaDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CriteriaMetaData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            label: this._label !== UnassignedValue ? this._label : maybe(someString()),
        };
    };
    return CriteriaMetaDataDTOBuilder;
}());
exports.CriteriaMetaDataDTOBuilder = CriteriaMetaDataDTOBuilder;
var CriteriaTypeDTOBuilder = /** @class */ (function () {
    function CriteriaTypeDTOBuilder() {
    }
    CriteriaTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.CriteriaType.UNKNOWN,
            types_1.CriteriaType.COMPOUND,
            types_1.CriteriaType.CUSTOM,
            types_1.CriteriaType.GEO,
            types_1.CriteriaType.LANGUAGE,
            types_1.CriteriaType.USER_ROLE,
            types_1.CriteriaType.USER_STATUS,
            types_1.CriteriaType.USER_COLORS,
            types_1.CriteriaType.USER_GUIDS,
            types_1.CriteriaType.TEMPLATE_GUIDS,
            types_1.CriteriaType.POST_REG,
            types_1.CriteriaType.CONNECTED_DOMAIN,
            types_1.CriteriaType.PREMIUM_PLAN,
            types_1.CriteriaType.EXCLUDE_IN_SALE,
            types_1.CriteriaType.MAILBOX,
            types_1.CriteriaType.CONNECTED_OFFERING_GROUP,
            types_1.CriteriaType.INSTALLED_APPS,
            types_1.CriteriaType.PRODUCT_GROUPS,
            types_1.CriteriaType.DOMAIN_LENGTH,
            types_1.CriteriaType.MAILBOX_SALE,
            types_1.CriteriaType.VOUCHERS,
            types_1.CriteriaType.FREE_SITE,
            types_1.CriteriaType.BRAND,
            types_1.CriteriaType.EXPERIMENT,
            types_1.CriteriaType.CUSTOM_PARAM,
            types_1.CriteriaType.AUDIENCE,
            types_1.CriteriaType.PREMIUM_LANDING_TAB,
            types_1.CriteriaType.PREMIUM_ACCOUNT,
            types_1.CriteriaType.ELIGIBLE_FOR_SALE,
            types_1.CriteriaType.EXTERNAL_CRITERIA,
            types_1.CriteriaType.SITE_TYPE_CRITERIA,
        ]);
    };
    return CriteriaTypeDTOBuilder;
}());
exports.CriteriaTypeDTOBuilder = CriteriaTypeDTOBuilder;
var CrudDTOBuilder = /** @class */ (function () {
    function CrudDTOBuilder() {
        this._bulkCreateOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        this._createOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._method = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
    }
    CrudDTOBuilder.prototype.withMethod = function (_method) {
        this._method = _method;
        return this;
    };
    CrudDTOBuilder.prototype.withCreateOptions = function (_createOptions) {
        this._createOptions = _createOptions;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withGetOptions = function (_getOptions) {
        this._getOptions = _getOptions;
        this._createOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withUpdateOptions = function (_updateOptions) {
        this._updateOptions = _updateOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withDeleteOptions = function (_deleteOptions) {
        this._deleteOptions = _deleteOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withListOptions = function (_listOptions) {
        this._listOptions = _listOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withQueryOptions = function (_queryOptions) {
        this._queryOptions = _queryOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withSearchOptions = function (_searchOptions) {
        this._searchOptions = _searchOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkCreateOptions = function (_bulkCreateOptions) {
        this._bulkCreateOptions = _bulkCreateOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkUpdateOptions = function (_bulkUpdateOptions) {
        this._bulkUpdateOptions = _bulkUpdateOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkUpdateByFilterOptions = function (_bulkUpdateByFilterOptions) {
        this._bulkUpdateByFilterOptions = _bulkUpdateByFilterOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkDeleteOptions = function (_bulkDeleteOptions) {
        this._bulkDeleteOptions = _bulkDeleteOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkDeleteByFilterOptions = function (_bulkDeleteByFilterOptions) {
        this._bulkDeleteByFilterOptions = _bulkDeleteByFilterOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withUpsertOptions = function (_upsertOptions) {
        this._upsertOptions = _upsertOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withBulkUpsertOptions = function (_bulkUpsertOptions) {
        this._bulkUpsertOptions = _bulkUpsertOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withListDeletedOptions = function (_listDeletedOptions) {
        this._listDeletedOptions = _listDeletedOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withGetDeletedOptions = function (_getDeletedOptions) {
        this._getDeletedOptions = _getDeletedOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withRestoreFromTrashbinOptions = function (_restoreFromTrashbinOptions) {
        this._restoreFromTrashbinOptions = _restoreFromTrashbinOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withRemoveFromTrashbinOptions = function (_removeFromTrashbinOptions) {
        this._removeFromTrashbinOptions = _removeFromTrashbinOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._countOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.withCountOptions = function (_countOptions) {
        this._countOptions = _countOptions;
        this._createOptions = UnassignedValue;
        this._getOptions = UnassignedValue;
        this._updateOptions = UnassignedValue;
        this._deleteOptions = UnassignedValue;
        this._listOptions = UnassignedValue;
        this._queryOptions = UnassignedValue;
        this._searchOptions = UnassignedValue;
        this._bulkCreateOptions = UnassignedValue;
        this._bulkUpdateOptions = UnassignedValue;
        this._bulkUpdateByFilterOptions = UnassignedValue;
        this._bulkDeleteOptions = UnassignedValue;
        this._bulkDeleteByFilterOptions = UnassignedValue;
        this._upsertOptions = UnassignedValue;
        this._bulkUpsertOptions = UnassignedValue;
        this._listDeletedOptions = UnassignedValue;
        this._getDeletedOptions = UnassignedValue;
        this._restoreFromTrashbinOptions = UnassignedValue;
        this._removeFromTrashbinOptions = UnassignedValue;
        return this;
    };
    CrudDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Crud', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._createOptions === UnassignedValue &&
            this._getOptions === UnassignedValue &&
            this._updateOptions === UnassignedValue &&
            this._deleteOptions === UnassignedValue &&
            this._listOptions === UnassignedValue &&
            this._queryOptions === UnassignedValue &&
            this._searchOptions === UnassignedValue &&
            this._bulkCreateOptions === UnassignedValue &&
            this._bulkUpdateOptions === UnassignedValue &&
            this._bulkUpdateByFilterOptions === UnassignedValue &&
            this._bulkDeleteOptions === UnassignedValue &&
            this._bulkDeleteByFilterOptions === UnassignedValue &&
            this._upsertOptions === UnassignedValue &&
            this._bulkUpsertOptions === UnassignedValue &&
            this._listDeletedOptions === UnassignedValue &&
            this._getDeletedOptions === UnassignedValue &&
            this._restoreFromTrashbinOptions === UnassignedValue &&
            this._removeFromTrashbinOptions === UnassignedValue &&
            this._countOptions === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = [
                'createOptions',
                'getOptions',
                'updateOptions',
                'deleteOptions',
                'listOptions',
                'queryOptions',
                'searchOptions',
                'bulkCreateOptions',
                'bulkUpdateOptions',
                'bulkUpdateByFilterOptions',
                'bulkDeleteOptions',
                'bulkDeleteByFilterOptions',
                'upsertOptions',
                'bulkUpsertOptions',
                'listDeletedOptions',
                'getDeletedOptions',
                'restoreFromTrashbinOptions',
                'removeFromTrashbinOptions',
                'countOptions',
            ];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 19), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                bulkCreateOptions: assignRandomOneOf('bulkCreateOptions', maybe(exports.aBulkCreateMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                bulkDeleteByFilterOptions: assignRandomOneOf('bulkDeleteByFilterOptions', maybe(exports.aBulkDeleteByFilterMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                bulkDeleteOptions: assignRandomOneOf('bulkDeleteOptions', maybe(exports.aBulkDeleteMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                bulkUpdateByFilterOptions: assignRandomOneOf('bulkUpdateByFilterOptions', maybe(exports.aBulkUpdateByFilterMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                bulkUpdateOptions: assignRandomOneOf('bulkUpdateOptions', maybe(exports.aBulkUpdateMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                bulkUpsertOptions: assignRandomOneOf('bulkUpsertOptions', maybe(exports.aBulkUpsertMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                countOptions: assignRandomOneOf('countOptions', maybe(exports.aCountOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                createOptions: assignRandomOneOf('createOptions', maybe(exports.aCreateMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                deleteOptions: assignRandomOneOf('deleteOptions', maybe(exports.aDeleteMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                getDeletedOptions: assignRandomOneOf('getDeletedOptions', maybe(exports.aGetDeletedMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                getOptions: assignRandomOneOf('getOptions', maybe(exports.aGetItemMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                listDeletedOptions: assignRandomOneOf('listDeletedOptions', maybe(exports.aListDeletedMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                listOptions: assignRandomOneOf('listOptions', maybe(exports.aListMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                method: this._method !== UnassignedValue ? this._method : maybe(exports.aMethod().build({ buildersVisited: buildersVisited })),
                queryOptions: assignRandomOneOf('queryOptions', maybe(exports.aQueryMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                removeFromTrashbinOptions: assignRandomOneOf('removeFromTrashbinOptions', maybe(exports.aRemoveFromTrashbinMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                restoreFromTrashbinOptions: assignRandomOneOf('restoreFromTrashbinOptions', maybe(exports.aRestoreFromTrashbinMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                searchOptions: assignRandomOneOf('searchOptions', maybe(exports.aSearchMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                updateOptions: assignRandomOneOf('updateOptions', maybe(exports.anUpdateMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                upsertOptions: assignRandomOneOf('upsertOptions', maybe(exports.anUpsertMethodOptions().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            bulkCreateOptions: this._bulkCreateOptions === UnassignedValue ? undefined : this._bulkCreateOptions,
            bulkDeleteByFilterOptions: this._bulkDeleteByFilterOptions === UnassignedValue ? undefined : this._bulkDeleteByFilterOptions,
            bulkDeleteOptions: this._bulkDeleteOptions === UnassignedValue ? undefined : this._bulkDeleteOptions,
            bulkUpdateByFilterOptions: this._bulkUpdateByFilterOptions === UnassignedValue ? undefined : this._bulkUpdateByFilterOptions,
            bulkUpdateOptions: this._bulkUpdateOptions === UnassignedValue ? undefined : this._bulkUpdateOptions,
            bulkUpsertOptions: this._bulkUpsertOptions === UnassignedValue ? undefined : this._bulkUpsertOptions,
            countOptions: this._countOptions === UnassignedValue ? undefined : this._countOptions,
            createOptions: this._createOptions === UnassignedValue ? undefined : this._createOptions,
            deleteOptions: this._deleteOptions === UnassignedValue ? undefined : this._deleteOptions,
            getDeletedOptions: this._getDeletedOptions === UnassignedValue ? undefined : this._getDeletedOptions,
            getOptions: this._getOptions === UnassignedValue ? undefined : this._getOptions,
            listDeletedOptions: this._listDeletedOptions === UnassignedValue ? undefined : this._listDeletedOptions,
            listOptions: this._listOptions === UnassignedValue ? undefined : this._listOptions,
            method: this._method !== UnassignedValue ? this._method : maybe(exports.aMethod().build({ buildersVisited: buildersVisited })),
            queryOptions: this._queryOptions === UnassignedValue ? undefined : this._queryOptions,
            removeFromTrashbinOptions: this._removeFromTrashbinOptions === UnassignedValue ? undefined : this._removeFromTrashbinOptions,
            restoreFromTrashbinOptions: this._restoreFromTrashbinOptions === UnassignedValue ? undefined : this._restoreFromTrashbinOptions,
            searchOptions: this._searchOptions === UnassignedValue ? undefined : this._searchOptions,
            updateOptions: this._updateOptions === UnassignedValue ? undefined : this._updateOptions,
            upsertOptions: this._upsertOptions === UnassignedValue ? undefined : this._upsertOptions,
        };
    };
    return CrudDTOBuilder;
}());
exports.CrudDTOBuilder = CrudDTOBuilder;
var CustomFilterCriteriaDTOBuilder = /** @class */ (function () {
    function CustomFilterCriteriaDTOBuilder() {
        this._dataSource = UnassignedValue;
        this._fieldId = UnassignedValue;
        this._listRestriction = UnassignedValue;
        this._operator = UnassignedValue;
    }
    CustomFilterCriteriaDTOBuilder.prototype.withFieldId = function (_fieldId) {
        this._fieldId = _fieldId;
        return this;
    };
    CustomFilterCriteriaDTOBuilder.prototype.withDataSource = function (_dataSource) {
        this._dataSource = _dataSource;
        return this;
    };
    CustomFilterCriteriaDTOBuilder.prototype.withOperator = function (_operator) {
        this._operator = _operator;
        return this;
    };
    CustomFilterCriteriaDTOBuilder.prototype.withListRestriction = function (_listRestriction) {
        this._listRestriction = _listRestriction;
        return this;
    };
    CustomFilterCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomFilterCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            dataSource: this._dataSource !== UnassignedValue ? this._dataSource : maybe(exports.aCustomFilterDataSource().build({ buildersVisited: buildersVisited })),
            fieldId: this._fieldId !== UnassignedValue ? this._fieldId : maybe(someString()),
            listRestriction: this._listRestriction !== UnassignedValue ? this._listRestriction : maybe(exports.aCustomFilterOperator().build({ buildersVisited: buildersVisited })),
            operator: this._operator !== UnassignedValue ? this._operator : maybe(exports.aCustomFilterOperator().build({ buildersVisited: buildersVisited })),
        };
    };
    return CustomFilterCriteriaDTOBuilder;
}());
exports.CustomFilterCriteriaDTOBuilder = CustomFilterCriteriaDTOBuilder;
var CustomFilterDataSourceDTOBuilder = /** @class */ (function () {
    function CustomFilterDataSourceDTOBuilder() {
    }
    CustomFilterDataSourceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CustomFilterDataSource.UNKNOWN, types_1.CustomFilterDataSource.USER_PROFILE, types_1.CustomFilterDataSource.SITE_PROFILE]);
    };
    return CustomFilterDataSourceDTOBuilder;
}());
exports.CustomFilterDataSourceDTOBuilder = CustomFilterDataSourceDTOBuilder;
var CustomFilterOperatorDTOBuilder = /** @class */ (function () {
    function CustomFilterOperatorDTOBuilder() {
        this._comparator = UnassignedValue;
        this._expectedValue = UnassignedValue;
        this._valueType = UnassignedValue;
    }
    CustomFilterOperatorDTOBuilder.prototype.withValueType = function (_valueType) {
        this._valueType = _valueType;
        return this;
    };
    CustomFilterOperatorDTOBuilder.prototype.withExpectedValue = function (_expectedValue) {
        this._expectedValue = _expectedValue;
        return this;
    };
    CustomFilterOperatorDTOBuilder.prototype.withComparator = function (_comparator) {
        this._comparator = _comparator;
        return this;
    };
    CustomFilterOperatorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomFilterOperator', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            comparator: this._comparator !== UnassignedValue ? this._comparator : maybe(exports.aComparatorTypeEnum().build({ buildersVisited: buildersVisited })),
            expectedValue: this._expectedValue !== UnassignedValue ? this._expectedValue : maybe(someString()),
            valueType: this._valueType !== UnassignedValue ? this._valueType : maybe(exports.anOperatorValueTypeEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return CustomFilterOperatorDTOBuilder;
}());
exports.CustomFilterOperatorDTOBuilder = CustomFilterOperatorDTOBuilder;
var CustomHttpPatternDTOBuilder = /** @class */ (function () {
    function CustomHttpPatternDTOBuilder() {
        this._kind = UnassignedValue;
        this._path = UnassignedValue;
    }
    CustomHttpPatternDTOBuilder.prototype.withKind = function (_kind) {
        this._kind = _kind;
        return this;
    };
    CustomHttpPatternDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    CustomHttpPatternDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomHttpPattern', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            kind: this._kind !== UnassignedValue ? this._kind : maybe(someString()),
            path: this._path !== UnassignedValue ? this._path : maybe(someString()),
        };
    };
    return CustomHttpPatternDTOBuilder;
}());
exports.CustomHttpPatternDTOBuilder = CustomHttpPatternDTOBuilder;
var CustomParamDTOBuilder = /** @class */ (function () {
    function CustomParamDTOBuilder() {
        this._key = UnassignedValue;
        this._values = UnassignedValue;
    }
    CustomParamDTOBuilder.prototype.withKey = function (_key) {
        this._key = _key;
        return this;
    };
    CustomParamDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    CustomParamDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomParam', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            key: this._key !== UnassignedValue ? this._key : maybe(someString()),
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return someString(); })),
        };
    };
    return CustomParamDTOBuilder;
}());
exports.CustomParamDTOBuilder = CustomParamDTOBuilder;
var CustomParamCriteriaDTOBuilder = /** @class */ (function () {
    function CustomParamCriteriaDTOBuilder() {
        this._criteriaMetaData = UnassignedValue;
        this._key = UnassignedValue;
        this._operator = UnassignedValue;
        this._values = UnassignedValue;
    }
    CustomParamCriteriaDTOBuilder.prototype.withOperator = function (_operator) {
        this._operator = _operator;
        return this;
    };
    CustomParamCriteriaDTOBuilder.prototype.withKey = function (_key) {
        this._key = _key;
        return this;
    };
    CustomParamCriteriaDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    CustomParamCriteriaDTOBuilder.prototype.withCriteriaMetaData = function (_criteriaMetaData) {
        this._criteriaMetaData = _criteriaMetaData;
        return this;
    };
    CustomParamCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomParamCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            criteriaMetaData: this._criteriaMetaData !== UnassignedValue ? this._criteriaMetaData : maybe(exports.aCriteriaMetaData().build({ buildersVisited: buildersVisited })),
            key: this._key !== UnassignedValue ? this._key : maybe(someString()),
            operator: this._operator !== UnassignedValue ? this._operator : maybe(exports.aCustomParamOperator().build({ buildersVisited: buildersVisited })),
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return someString(); })),
        };
    };
    return CustomParamCriteriaDTOBuilder;
}());
exports.CustomParamCriteriaDTOBuilder = CustomParamCriteriaDTOBuilder;
var CustomParamOperatorDTOBuilder = /** @class */ (function () {
    function CustomParamOperatorDTOBuilder() {
    }
    CustomParamOperatorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.CustomParamOperator.UNKNOWN,
            types_1.CustomParamOperator.EQUALS,
            types_1.CustomParamOperator.NOT_EQUALS,
            types_1.CustomParamOperator.CONTAINS_ALL,
            types_1.CustomParamOperator.NOT_CONTAINS_ALL,
            types_1.CustomParamOperator.CONTAINS_ANY,
            types_1.CustomParamOperator.NOT_CONTAINS_ANY,
            types_1.CustomParamOperator.EXISTS,
            types_1.CustomParamOperator.NOT_EXISTS,
        ]);
    };
    return CustomParamOperatorDTOBuilder;
}());
exports.CustomParamOperatorDTOBuilder = CustomParamOperatorDTOBuilder;
var CustomValidationErrorDTOBuilder = /** @class */ (function () {
    function CustomValidationErrorDTOBuilder() {
        this._data = UnassignedValue;
        this._ruleName = UnassignedValue;
    }
    CustomValidationErrorDTOBuilder.prototype.withRuleName = function (_ruleName) {
        this._ruleName = _ruleName;
        return this;
    };
    CustomValidationErrorDTOBuilder.prototype.withData = function (_data) {
        this._data = _data;
        return this;
    };
    CustomValidationErrorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CustomValidationError', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            data: this._data !== UnassignedValue ? this._data : maybe(someString()),
            ruleName: this._ruleName !== UnassignedValue ? this._ruleName : maybe(someString()),
        };
    };
    return CustomValidationErrorDTOBuilder;
}());
exports.CustomValidationErrorDTOBuilder = CustomValidationErrorDTOBuilder;
var DateUnitDTOBuilder = /** @class */ (function () {
    function DateUnitDTOBuilder() {
        this._days = UnassignedValue;
    }
    DateUnitDTOBuilder.prototype.withDays = function (_days) {
        this._days = _days;
        return this;
    };
    DateUnitDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DateUnit', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            days: this._days !== UnassignedValue ? this._days : maybe(someInt()),
        };
    };
    return DateUnitDTOBuilder;
}());
exports.DateUnitDTOBuilder = DateUnitDTOBuilder;
var DebugOfferRequestDTOBuilder = /** @class */ (function () {
    function DebugOfferRequestDTOBuilder() {
        this._context = UnassignedValue;
        this._customParams = UnassignedValue;
        this._offerId = UnassignedValue;
    }
    DebugOfferRequestDTOBuilder.prototype.withOfferId = function (_offerId) {
        this._offerId = _offerId;
        return this;
    };
    DebugOfferRequestDTOBuilder.prototype.withContext = function (_context) {
        this._context = _context;
        return this;
    };
    DebugOfferRequestDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    DebugOfferRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DebugOfferRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            context: this._context !== UnassignedValue ? this._context : maybe(exports.aRequestContext().build({ buildersVisited: buildersVisited })),
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(manyOf(function () { return exports.aCustomParam().build({ buildersVisited: buildersVisited }); })),
            offerId: this._offerId !== UnassignedValue ? this._offerId : maybe(someString()),
        };
    };
    return DebugOfferRequestDTOBuilder;
}());
exports.DebugOfferRequestDTOBuilder = DebugOfferRequestDTOBuilder;
var DebugOfferResponseDTOBuilder = /** @class */ (function () {
    function DebugOfferResponseDTOBuilder() {
        this._frequencyCapsExecutionResult = UnassignedValue;
        this._offer = UnassignedValue;
        this._releaseAudience = UnassignedValue;
        this._targeting = UnassignedValue;
    }
    DebugOfferResponseDTOBuilder.prototype.withOffer = function (_offer) {
        this._offer = _offer;
        return this;
    };
    DebugOfferResponseDTOBuilder.prototype.withTargeting = function (_targeting) {
        this._targeting = _targeting;
        return this;
    };
    DebugOfferResponseDTOBuilder.prototype.withReleaseAudience = function (_releaseAudience) {
        this._releaseAudience = _releaseAudience;
        return this;
    };
    DebugOfferResponseDTOBuilder.prototype.withFrequencyCapsExecutionResult = function (_frequencyCapsExecutionResult) {
        this._frequencyCapsExecutionResult = _frequencyCapsExecutionResult;
        return this;
    };
    DebugOfferResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DebugOfferResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            frequencyCapsExecutionResult: this._frequencyCapsExecutionResult !== UnassignedValue ? this._frequencyCapsExecutionResult : maybe(exports.aFrequencyCapsExecutionResult().build({ buildersVisited: buildersVisited })),
            offer: this._offer !== UnassignedValue ? this._offer : maybe(exports.anOffer().build({ buildersVisited: buildersVisited })),
            releaseAudience: this._releaseAudience !== UnassignedValue ? this._releaseAudience : maybe(exports.aReleaseAudience().build({ buildersVisited: buildersVisited })),
            targeting: this._targeting !== UnassignedValue ? this._targeting : maybe(exports.aTargeting().build({ buildersVisited: buildersVisited })),
        };
    };
    return DebugOfferResponseDTOBuilder;
}());
exports.DebugOfferResponseDTOBuilder = DebugOfferResponseDTOBuilder;
var DecimalValueOptionsDTOBuilder = /** @class */ (function () {
    function DecimalValueOptionsDTOBuilder() {
        this._gt = UnassignedValue;
        this._gte = UnassignedValue;
        this._lt = UnassignedValue;
        this._lte = UnassignedValue;
        this._maxScale = UnassignedValue;
    }
    DecimalValueOptionsDTOBuilder.prototype.withLte = function (_lte) {
        this._lte = _lte;
        return this;
    };
    DecimalValueOptionsDTOBuilder.prototype.withGte = function (_gte) {
        this._gte = _gte;
        return this;
    };
    DecimalValueOptionsDTOBuilder.prototype.withLt = function (_lt) {
        this._lt = _lt;
        return this;
    };
    DecimalValueOptionsDTOBuilder.prototype.withGt = function (_gt) {
        this._gt = _gt;
        return this;
    };
    DecimalValueOptionsDTOBuilder.prototype.withMaxScale = function (_maxScale) {
        this._maxScale = _maxScale;
        return this;
    };
    DecimalValueOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DecimalValueOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            gt: this._gt !== UnassignedValue ? this._gt : maybe(someString()),
            gte: this._gte !== UnassignedValue ? this._gte : maybe(someString()),
            lt: this._lt !== UnassignedValue ? this._lt : maybe(someString()),
            lte: this._lte !== UnassignedValue ? this._lte : maybe(someString()),
            maxScale: this._maxScale !== UnassignedValue ? this._maxScale : maybe(someInt()),
        };
    };
    return DecimalValueOptionsDTOBuilder;
}());
exports.DecimalValueOptionsDTOBuilder = DecimalValueOptionsDTOBuilder;
var DeleteMethodOptionsDTOBuilder = /** @class */ (function () {
    function DeleteMethodOptionsDTOBuilder() {
        this._idField = UnassignedValue;
    }
    DeleteMethodOptionsDTOBuilder.prototype.withIdField = function (_idField) {
        this._idField = _idField;
        return this;
    };
    DeleteMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DeleteMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idField: this._idField !== UnassignedValue ? this._idField : maybe(someString()),
        };
    };
    return DeleteMethodOptionsDTOBuilder;
}());
exports.DeleteMethodOptionsDTOBuilder = DeleteMethodOptionsDTOBuilder;
var DeprecatedDTOBuilder = /** @class */ (function () {
    function DeprecatedDTOBuilder() {
        this._replacedBy = UnassignedValue;
        this._targetRemovalDate = UnassignedValue;
    }
    DeprecatedDTOBuilder.prototype.withReplacedBy = function (_replacedBy) {
        this._replacedBy = _replacedBy;
        return this;
    };
    DeprecatedDTOBuilder.prototype.withTargetRemovalDate = function (_targetRemovalDate) {
        this._targetRemovalDate = _targetRemovalDate;
        return this;
    };
    DeprecatedDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Deprecated', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            replacedBy: this._replacedBy !== UnassignedValue ? this._replacedBy : maybe(someString()),
            targetRemovalDate: this._targetRemovalDate !== UnassignedValue ? this._targetRemovalDate : maybe(someString()),
        };
    };
    return DeprecatedDTOBuilder;
}());
exports.DeprecatedDTOBuilder = DeprecatedDTOBuilder;
var DescriptorProtoDTOBuilder = /** @class */ (function () {
    function DescriptorProtoDTOBuilder() {
        this._enumType = UnassignedValue;
        this._extension = UnassignedValue;
        this._extensionRange = UnassignedValue;
        this._field = UnassignedValue;
        this._name = UnassignedValue;
        this._nestedType = UnassignedValue;
        this._oneofDecl = UnassignedValue;
        this._options = UnassignedValue;
        this._reservedName = UnassignedValue;
        this._reservedRange = UnassignedValue;
    }
    DescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withExtension = function (_extension) {
        this._extension = _extension;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withNestedType = function (_nestedType) {
        this._nestedType = _nestedType;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withEnumType = function (_enumType) {
        this._enumType = _enumType;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withExtensionRange = function (_extensionRange) {
        this._extensionRange = _extensionRange;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withOneofDecl = function (_oneofDecl) {
        this._oneofDecl = _oneofDecl;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withReservedRange = function (_reservedRange) {
        this._reservedRange = _reservedRange;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.withReservedName = function (_reservedName) {
        this._reservedName = _reservedName;
        return this;
    };
    DescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            enumType: this._enumType !== UnassignedValue ? this._enumType : maybe(manyOf(function () { return exports.anEnumDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            extension: this._extension !== UnassignedValue ? this._extension : maybe(manyOf(function () { return exports.aFieldDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            extensionRange: this._extensionRange !== UnassignedValue ? this._extensionRange : maybe(manyOf(function () { return exports.anExtensionRange().build({ buildersVisited: buildersVisited }); })),
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return exports.aFieldDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            nestedType: this._nestedType !== UnassignedValue ? this._nestedType : maybe(manyOf(function () { return exports.aDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            oneofDecl: this._oneofDecl !== UnassignedValue ? this._oneofDecl : maybe(manyOf(function () { return exports.anOneofDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.aMessageOptions().build({ buildersVisited: buildersVisited })),
            reservedName: this._reservedName !== UnassignedValue ? this._reservedName : maybe(manyOf(function () { return someString(); })),
            reservedRange: this._reservedRange !== UnassignedValue ? this._reservedRange : maybe(manyOf(function () { return exports.aReservedRange().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return DescriptorProtoDTOBuilder;
}());
exports.DescriptorProtoDTOBuilder = DescriptorProtoDTOBuilder;
var DomainEventDTOBuilder = /** @class */ (function () {
    function DomainEventDTOBuilder() {
        this._actionMessageFqn = UnassignedValue;
        this._eventType = UnassignedValue;
        this._exposure = UnassignedValue;
        this._maturity = UnassignedValue;
        this._webhookPermissionOverride = UnassignedValue;
    }
    DomainEventDTOBuilder.prototype.withActionMessageFqn = function (_actionMessageFqn) {
        this._actionMessageFqn = _actionMessageFqn;
        return this;
    };
    DomainEventDTOBuilder.prototype.withWebhookPermissionOverride = function (_webhookPermissionOverride) {
        this._webhookPermissionOverride = _webhookPermissionOverride;
        return this;
    };
    DomainEventDTOBuilder.prototype.withEventType = function (_eventType) {
        this._eventType = _eventType;
        return this;
    };
    DomainEventDTOBuilder.prototype.withExposure = function (_exposure) {
        this._exposure = _exposure;
        return this;
    };
    DomainEventDTOBuilder.prototype.withMaturity = function (_maturity) {
        this._maturity = _maturity;
        return this;
    };
    DomainEventDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DomainEvent', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            actionMessageFqn: this._actionMessageFqn !== UnassignedValue ? this._actionMessageFqn : maybe(someString()),
            eventType: this._eventType !== UnassignedValue ? this._eventType : maybe(exports.aDomainEventEventType().build({ buildersVisited: buildersVisited })),
            exposure: this._exposure !== UnassignedValue ? this._exposure : maybe(exports.anExposure().build({ buildersVisited: buildersVisited })),
            maturity: this._maturity !== UnassignedValue ? this._maturity : maybe(exports.aMaturity().build({ buildersVisited: buildersVisited })),
            webhookPermissionOverride: this._webhookPermissionOverride !== UnassignedValue ? this._webhookPermissionOverride : maybe(someString()),
        };
    };
    return DomainEventDTOBuilder;
}());
exports.DomainEventDTOBuilder = DomainEventDTOBuilder;
var DomainEventEventTypeDTOBuilder = /** @class */ (function () {
    function DomainEventEventTypeDTOBuilder() {
    }
    DomainEventEventTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.DomainEventEventType.UNKNOWN, types_1.DomainEventEventType.CREATED, types_1.DomainEventEventType.UPDATED, types_1.DomainEventEventType.DELETED, types_1.DomainEventEventType.ACTION]);
    };
    return DomainEventEventTypeDTOBuilder;
}());
exports.DomainEventEventTypeDTOBuilder = DomainEventEventTypeDTOBuilder;
var DomainEventOptionsDTOBuilder = /** @class */ (function () {
    function DomainEventOptionsDTOBuilder() {
        this._eventSequenceNumber = UnassignedValue;
    }
    DomainEventOptionsDTOBuilder.prototype.withEventSequenceNumber = function (_eventSequenceNumber) {
        this._eventSequenceNumber = _eventSequenceNumber;
        return this;
    };
    DomainEventOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DomainEventOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventSequenceNumber: this._eventSequenceNumber !== UnassignedValue ? this._eventSequenceNumber : maybe(someBoolean()),
        };
    };
    return DomainEventOptionsDTOBuilder;
}());
exports.DomainEventOptionsDTOBuilder = DomainEventOptionsDTOBuilder;
var DomainLengthCriteriaDTOBuilder = /** @class */ (function () {
    function DomainLengthCriteriaDTOBuilder() {
        this._length = UnassignedValue;
        this._shorterOrEqual = UnassignedValue;
    }
    DomainLengthCriteriaDTOBuilder.prototype.withLength = function (_length) {
        this._length = _length;
        return this;
    };
    DomainLengthCriteriaDTOBuilder.prototype.withShorterOrEqual = function (_shorterOrEqual) {
        this._shorterOrEqual = _shorterOrEqual;
        return this;
    };
    DomainLengthCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DomainLengthCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            length: this._length !== UnassignedValue ? this._length : maybe(someInt()),
            shorterOrEqual: this._shorterOrEqual !== UnassignedValue ? this._shorterOrEqual : maybe(someBoolean()),
        };
    };
    return DomainLengthCriteriaDTOBuilder;
}());
exports.DomainLengthCriteriaDTOBuilder = DomainLengthCriteriaDTOBuilder;
var EligibleForSaleCriteriaDTOBuilder = /** @class */ (function () {
    function EligibleForSaleCriteriaDTOBuilder() {
        this._customSale = UnassignedValue;
        this._productTypeId = UnassignedValue;
        this._value = UnassignedValue;
    }
    EligibleForSaleCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    EligibleForSaleCriteriaDTOBuilder.prototype.withCustomSale = function (_customSale) {
        this._customSale = _customSale;
        return this;
    };
    EligibleForSaleCriteriaDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    EligibleForSaleCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EligibleForSaleCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customSale: this._customSale !== UnassignedValue ? this._customSale : maybe(someString()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
            value: this._value !== UnassignedValue ? this._value : maybe(exports.anEligibleForSaleCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return EligibleForSaleCriteriaDTOBuilder;
}());
exports.EligibleForSaleCriteriaDTOBuilder = EligibleForSaleCriteriaDTOBuilder;
var EligibleForSaleCriteriaEnumDTOBuilder = /** @class */ (function () {
    function EligibleForSaleCriteriaEnumDTOBuilder() {
    }
    EligibleForSaleCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.EligibleForSaleCriteriaEnum.UNKNOWN,
            types_1.EligibleForSaleCriteriaEnum.NONE,
            types_1.EligibleForSaleCriteriaEnum.SEASONAL,
            types_1.EligibleForSaleCriteriaEnum.PERSONAL,
            types_1.EligibleForSaleCriteriaEnum.CUSTOM,
        ]);
    };
    return EligibleForSaleCriteriaEnumDTOBuilder;
}());
exports.EligibleForSaleCriteriaEnumDTOBuilder = EligibleForSaleCriteriaEnumDTOBuilder;
var EmitsDTOBuilder = /** @class */ (function () {
    function EmitsDTOBuilder() {
        this._actionMessageFqn = UnassignedValue;
        this._eventType = UnassignedValue;
    }
    EmitsDTOBuilder.prototype.withEventType = function (_eventType) {
        this._eventType = _eventType;
        return this;
    };
    EmitsDTOBuilder.prototype.withActionMessageFqn = function (_actionMessageFqn) {
        this._actionMessageFqn = _actionMessageFqn;
        return this;
    };
    EmitsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Emits', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            actionMessageFqn: this._actionMessageFqn !== UnassignedValue ? this._actionMessageFqn : maybe(someString()),
            eventType: this._eventType !== UnassignedValue ? this._eventType : maybe(exports.aDomainEventEventType().build({ buildersVisited: buildersVisited })),
        };
    };
    return EmitsDTOBuilder;
}());
exports.EmitsDTOBuilder = EmitsDTOBuilder;
var EntityDTOBuilder = /** @class */ (function () {
    function EntityDTOBuilder() {
        this._appDefId = UnassignedValue;
        this._appendixFiles = UnassignedValue;
        this._domainEvents = UnassignedValue;
        this._domainEventsReadPermission = UnassignedValue;
        this._exposure = UnassignedValue;
        this._extensible = UnassignedValue;
        this._fqdn = UnassignedValue;
        this._implements = UnassignedValue;
        this._oldFqdnForBackwardsCompatibility = UnassignedValue;
        this._plural = UnassignedValue;
        this._segment = UnassignedValue;
        this._trashbin = UnassignedValue;
    }
    EntityDTOBuilder.prototype.withFqdn = function (_fqdn) {
        this._fqdn = _fqdn;
        return this;
    };
    EntityDTOBuilder.prototype.withExposure = function (_exposure) {
        this._exposure = _exposure;
        return this;
    };
    EntityDTOBuilder.prototype.withAppendixFiles = function (_appendixFiles) {
        this._appendixFiles = _appendixFiles;
        return this;
    };
    EntityDTOBuilder.prototype.withOldFqdnForBackwardsCompatibility = function (_oldFqdnForBackwardsCompatibility) {
        this._oldFqdnForBackwardsCompatibility = _oldFqdnForBackwardsCompatibility;
        return this;
    };
    EntityDTOBuilder.prototype.withSegment = function (_segment) {
        this._segment = _segment;
        return this;
    };
    EntityDTOBuilder.prototype.withImplements = function (_implements) {
        this._implements = _implements;
        return this;
    };
    EntityDTOBuilder.prototype.withExtensible = function (_extensible) {
        this._extensible = _extensible;
        return this;
    };
    EntityDTOBuilder.prototype.withTrashbin = function (_trashbin) {
        this._trashbin = _trashbin;
        return this;
    };
    EntityDTOBuilder.prototype.withPlural = function (_plural) {
        this._plural = _plural;
        return this;
    };
    EntityDTOBuilder.prototype.withDomainEventsReadPermission = function (_domainEventsReadPermission) {
        this._domainEventsReadPermission = _domainEventsReadPermission;
        return this;
    };
    EntityDTOBuilder.prototype.withAppDefId = function (_appDefId) {
        this._appDefId = _appDefId;
        return this;
    };
    EntityDTOBuilder.prototype.withDomainEvents = function (_domainEvents) {
        this._domainEvents = _domainEvents;
        return this;
    };
    EntityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Entity', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
            appendixFiles: this._appendixFiles !== UnassignedValue ? this._appendixFiles : maybe(manyOf(function () { return exports.aMessageAppendix().build({ buildersVisited: buildersVisited }); })),
            domainEvents: this._domainEvents !== UnassignedValue ? this._domainEvents : maybe(exports.aDomainEventOptions().build({ buildersVisited: buildersVisited })),
            domainEventsReadPermission: this._domainEventsReadPermission !== UnassignedValue ? this._domainEventsReadPermission : maybe(someString()),
            exposure: this._exposure !== UnassignedValue ? this._exposure : maybe(exports.anExposure().build({ buildersVisited: buildersVisited })),
            extensible: this._extensible !== UnassignedValue ? this._extensible : maybe(exports.anExtensible().build({ buildersVisited: buildersVisited })),
            fqdn: this._fqdn !== UnassignedValue ? this._fqdn : maybe(someString()),
            implements: this._implements !== UnassignedValue ? this._implements : maybe(manyOf(function () { return someString(); })),
            oldFqdnForBackwardsCompatibility: this._oldFqdnForBackwardsCompatibility !== UnassignedValue ? this._oldFqdnForBackwardsCompatibility : maybe(someString()),
            plural: this._plural !== UnassignedValue ? this._plural : maybe(someString()),
            segment: this._segment !== UnassignedValue ? this._segment : maybe(exports.aSegmentName().build({ buildersVisited: buildersVisited })),
            trashbin: this._trashbin !== UnassignedValue ? this._trashbin : maybe(someBoolean()),
        };
    };
    return EntityDTOBuilder;
}());
exports.EntityDTOBuilder = EntityDTOBuilder;
var EnumDescriptorProtoDTOBuilder = /** @class */ (function () {
    function EnumDescriptorProtoDTOBuilder() {
        this._name = UnassignedValue;
        this._options = UnassignedValue;
        this._reservedName = UnassignedValue;
        this._reservedRange = UnassignedValue;
        this._value = UnassignedValue;
    }
    EnumDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    EnumDescriptorProtoDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    EnumDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    EnumDescriptorProtoDTOBuilder.prototype.withReservedRange = function (_reservedRange) {
        this._reservedRange = _reservedRange;
        return this;
    };
    EnumDescriptorProtoDTOBuilder.prototype.withReservedName = function (_reservedName) {
        this._reservedName = _reservedName;
        return this;
    };
    EnumDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EnumDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.anEnumOptions().build({ buildersVisited: buildersVisited })),
            reservedName: this._reservedName !== UnassignedValue ? this._reservedName : maybe(manyOf(function () { return someString(); })),
            reservedRange: this._reservedRange !== UnassignedValue ? this._reservedRange : maybe(manyOf(function () { return exports.anEnumReservedRange().build({ buildersVisited: buildersVisited }); })),
            value: this._value !== UnassignedValue ? this._value : maybe(manyOf(function () { return exports.anEnumValueDescriptorProto().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return EnumDescriptorProtoDTOBuilder;
}());
exports.EnumDescriptorProtoDTOBuilder = EnumDescriptorProtoDTOBuilder;
var EnumOptionsDTOBuilder = /** @class */ (function () {
    function EnumOptionsDTOBuilder() {
        this._allowAlias = UnassignedValue;
        this._deprecated = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    EnumOptionsDTOBuilder.prototype.withAllowAlias = function (_allowAlias) {
        this._allowAlias = _allowAlias;
        return this;
    };
    EnumOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    EnumOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    EnumOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EnumOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            allowAlias: this._allowAlias !== UnassignedValue ? this._allowAlias : maybe(someBoolean()),
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return EnumOptionsDTOBuilder;
}());
exports.EnumOptionsDTOBuilder = EnumOptionsDTOBuilder;
var EnumReservedRangeDTOBuilder = /** @class */ (function () {
    function EnumReservedRangeDTOBuilder() {
        this._end = UnassignedValue;
        this._start = UnassignedValue;
    }
    EnumReservedRangeDTOBuilder.prototype.withStart = function (_start) {
        this._start = _start;
        return this;
    };
    EnumReservedRangeDTOBuilder.prototype.withEnd = function (_end) {
        this._end = _end;
        return this;
    };
    EnumReservedRangeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EnumReservedRange', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            end: this._end !== UnassignedValue ? this._end : maybe(someInt()),
            start: this._start !== UnassignedValue ? this._start : maybe(someInt()),
        };
    };
    return EnumReservedRangeDTOBuilder;
}());
exports.EnumReservedRangeDTOBuilder = EnumReservedRangeDTOBuilder;
var EnumValueDescriptorProtoDTOBuilder = /** @class */ (function () {
    function EnumValueDescriptorProtoDTOBuilder() {
        this._name = UnassignedValue;
        this._number = UnassignedValue;
        this._options = UnassignedValue;
    }
    EnumValueDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    EnumValueDescriptorProtoDTOBuilder.prototype.withNumber = function (_number) {
        this._number = _number;
        return this;
    };
    EnumValueDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    EnumValueDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EnumValueDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            number: this._number !== UnassignedValue ? this._number : maybe(someInt()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.anEnumValueOptions().build({ buildersVisited: buildersVisited })),
        };
    };
    return EnumValueDescriptorProtoDTOBuilder;
}());
exports.EnumValueDescriptorProtoDTOBuilder = EnumValueDescriptorProtoDTOBuilder;
var EnumValueOptionsDTOBuilder = /** @class */ (function () {
    function EnumValueOptionsDTOBuilder() {
        this._deprecated = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    EnumValueOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    EnumValueOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    EnumValueOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EnumValueOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return EnumValueOptionsDTOBuilder;
}());
exports.EnumValueOptionsDTOBuilder = EnumValueOptionsDTOBuilder;
var EventDTOBuilder = /** @class */ (function () {
    function EventDTOBuilder() {
        this._methodName = UnassignedValue;
    }
    EventDTOBuilder.prototype.withMethodName = function (_methodName) {
        this._methodName = _methodName;
        return this;
    };
    EventDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Event', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            methodName: this._methodName !== UnassignedValue ? this._methodName : maybe(someString()),
        };
    };
    return EventDTOBuilder;
}());
exports.EventDTOBuilder = EventDTOBuilder;
var EventsCountLimitDTOBuilder = /** @class */ (function () {
    function EventsCountLimitDTOBuilder() {
        this._limit = UnassignedValue;
        this._type = UnassignedValue;
    }
    EventsCountLimitDTOBuilder.prototype.withLimit = function (_limit) {
        this._limit = _limit;
        return this;
    };
    EventsCountLimitDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    EventsCountLimitDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EventsCountLimit', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            limit: this._limit !== UnassignedValue ? this._limit : maybe(someInt()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aCountType().build({ buildersVisited: buildersVisited })),
        };
    };
    return EventsCountLimitDTOBuilder;
}());
exports.EventsCountLimitDTOBuilder = EventsCountLimitDTOBuilder;
var ExecutionResultDTOBuilder = /** @class */ (function () {
    function ExecutionResultDTOBuilder() {
        this._currentValue = UnassignedValue;
        this._success = UnassignedValue;
    }
    ExecutionResultDTOBuilder.prototype.withSuccess = function (_success) {
        this._success = _success;
        return this;
    };
    ExecutionResultDTOBuilder.prototype.withCurrentValue = function (_currentValue) {
        this._currentValue = _currentValue;
        return this;
    };
    ExecutionResultDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExecutionResult', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currentValue: this._currentValue !== UnassignedValue ? this._currentValue : maybe(someString()),
            success: this._success !== UnassignedValue ? this._success : maybe(someBoolean()),
        };
    };
    return ExecutionResultDTOBuilder;
}());
exports.ExecutionResultDTOBuilder = ExecutionResultDTOBuilder;
var ExperimentCriteriaDTOBuilder = /** @class */ (function () {
    function ExperimentCriteriaDTOBuilder() {
        this._spec = UnassignedValue;
        this._value = UnassignedValue;
    }
    ExperimentCriteriaDTOBuilder.prototype.withSpec = function (_spec) {
        this._spec = _spec;
        return this;
    };
    ExperimentCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    ExperimentCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExperimentCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            spec: this._spec !== UnassignedValue ? this._spec : maybe(someString()),
            value: this._value !== UnassignedValue ? this._value : maybe(someString()),
        };
    };
    return ExperimentCriteriaDTOBuilder;
}());
exports.ExperimentCriteriaDTOBuilder = ExperimentCriteriaDTOBuilder;
var ExposureDTOBuilder = /** @class */ (function () {
    function ExposureDTOBuilder() {
    }
    ExposureDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Exposure.PRIVATE, types_1.Exposure.INTERNAL, types_1.Exposure.PUBLIC]);
    };
    return ExposureDTOBuilder;
}());
exports.ExposureDTOBuilder = ExposureDTOBuilder;
var ExtendedFieldsDTOBuilder = /** @class */ (function () {
    function ExtendedFieldsDTOBuilder() {
        this._namespaces = UnassignedValue;
    }
    ExtendedFieldsDTOBuilder.prototype.withNamespaces = function (_namespaces) {
        this._namespaces = _namespaces;
        return this;
    };
    ExtendedFieldsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExtendedFields', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            namespaces: this._namespaces !== UnassignedValue ? this._namespaces : maybe(jsonMapOf(function () { return emptyObject(); })),
        };
    };
    return ExtendedFieldsDTOBuilder;
}());
exports.ExtendedFieldsDTOBuilder = ExtendedFieldsDTOBuilder;
var ExtensibleDTOBuilder = /** @class */ (function () {
    function ExtensibleDTOBuilder() {
        this._nestedExtensionFieldPath = UnassignedValue;
    }
    ExtensibleDTOBuilder.prototype.withNestedExtensionFieldPath = function (_nestedExtensionFieldPath) {
        this._nestedExtensionFieldPath = _nestedExtensionFieldPath;
        return this;
    };
    ExtensibleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Extensible', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            nestedExtensionFieldPath: this._nestedExtensionFieldPath !== UnassignedValue ? this._nestedExtensionFieldPath : maybe(someString()),
        };
    };
    return ExtensibleDTOBuilder;
}());
exports.ExtensibleDTOBuilder = ExtensibleDTOBuilder;
var ExtensionRangeDTOBuilder = /** @class */ (function () {
    function ExtensionRangeDTOBuilder() {
        this._end = UnassignedValue;
        this._options = UnassignedValue;
        this._start = UnassignedValue;
    }
    ExtensionRangeDTOBuilder.prototype.withStart = function (_start) {
        this._start = _start;
        return this;
    };
    ExtensionRangeDTOBuilder.prototype.withEnd = function (_end) {
        this._end = _end;
        return this;
    };
    ExtensionRangeDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    ExtensionRangeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExtensionRange', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            end: this._end !== UnassignedValue ? this._end : maybe(someInt()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.anExtensionRangeOptions().build({ buildersVisited: buildersVisited })),
            start: this._start !== UnassignedValue ? this._start : maybe(someInt()),
        };
    };
    return ExtensionRangeDTOBuilder;
}());
exports.ExtensionRangeDTOBuilder = ExtensionRangeDTOBuilder;
var ExtensionRangeOptionsDTOBuilder = /** @class */ (function () {
    function ExtensionRangeOptionsDTOBuilder() {
        this._uninterpretedOption = UnassignedValue;
    }
    ExtensionRangeOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    ExtensionRangeOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExtensionRangeOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ExtensionRangeOptionsDTOBuilder;
}());
exports.ExtensionRangeOptionsDTOBuilder = ExtensionRangeOptionsDTOBuilder;
var ExternalAppDTOBuilder = /** @class */ (function () {
    function ExternalAppDTOBuilder() {
        this._accountData = UnassignedValue;
        this._appDefId = UnassignedValue;
        this._extraAttributes = UnassignedValue;
        this._permissions = UnassignedValue;
        this._siteData = UnassignedValue;
        this._userData = UnassignedValue;
        this._wixGlobalData = UnassignedValue;
    }
    ExternalAppDTOBuilder.prototype.withAppDefId = function (_appDefId) {
        this._appDefId = _appDefId;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withPermissions = function (_permissions) {
        this._permissions = _permissions;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withUserData = function (_userData) {
        this._userData = _userData;
        this._siteData = UnassignedValue;
        this._wixGlobalData = UnassignedValue;
        this._accountData = UnassignedValue;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withSiteData = function (_siteData) {
        this._siteData = _siteData;
        this._userData = UnassignedValue;
        this._wixGlobalData = UnassignedValue;
        this._accountData = UnassignedValue;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withWixGlobalData = function (_wixGlobalData) {
        this._wixGlobalData = _wixGlobalData;
        this._userData = UnassignedValue;
        this._siteData = UnassignedValue;
        this._accountData = UnassignedValue;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withAccountData = function (_accountData) {
        this._accountData = _accountData;
        this._userData = UnassignedValue;
        this._siteData = UnassignedValue;
        this._wixGlobalData = UnassignedValue;
        return this;
    };
    ExternalAppDTOBuilder.prototype.withExtraAttributes = function (_extraAttributes) {
        this._extraAttributes = _extraAttributes;
        return this;
    };
    ExternalAppDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalApp', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._userData === UnassignedValue && this._siteData === UnassignedValue && this._wixGlobalData === UnassignedValue && this._accountData === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['userData', 'siteData', 'wixGlobalData', 'accountData'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 4), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                accountData: assignRandomOneOf('accountData', maybe(exports.anAccountData().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
                extraAttributes: this._extraAttributes !== UnassignedValue ? this._extraAttributes : maybe(jsonMapOf(function () { return someString(); })),
                permissions: this._permissions !== UnassignedValue ? this._permissions : maybe(manyOf(function () { return someString(); })),
                siteData: assignRandomOneOf('siteData', maybe(exports.aSiteData().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                userData: assignRandomOneOf('userData', maybe(exports.anUserData().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                wixGlobalData: assignRandomOneOf('wixGlobalData', maybe(exports.aWixGlobalData().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            accountData: this._accountData === UnassignedValue ? undefined : this._accountData,
            appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
            extraAttributes: this._extraAttributes !== UnassignedValue ? this._extraAttributes : maybe(jsonMapOf(function () { return someString(); })),
            permissions: this._permissions !== UnassignedValue ? this._permissions : maybe(manyOf(function () { return someString(); })),
            siteData: this._siteData === UnassignedValue ? undefined : this._siteData,
            userData: this._userData === UnassignedValue ? undefined : this._userData,
            wixGlobalData: this._wixGlobalData === UnassignedValue ? undefined : this._wixGlobalData,
        };
    };
    return ExternalAppDTOBuilder;
}());
exports.ExternalAppDTOBuilder = ExternalAppDTOBuilder;
var ExternalCriteriaDTOBuilder = /** @class */ (function () {
    function ExternalCriteriaDTOBuilder() {
        this._additionalParams = UnassignedValue;
        this._artifactName = UnassignedValue;
        this._conditionType = UnassignedValue;
        this._expectedValue = UnassignedValue;
    }
    ExternalCriteriaDTOBuilder.prototype.withArtifactName = function (_artifactName) {
        this._artifactName = _artifactName;
        return this;
    };
    ExternalCriteriaDTOBuilder.prototype.withConditionType = function (_conditionType) {
        this._conditionType = _conditionType;
        return this;
    };
    ExternalCriteriaDTOBuilder.prototype.withExpectedValue = function (_expectedValue) {
        this._expectedValue = _expectedValue;
        return this;
    };
    ExternalCriteriaDTOBuilder.prototype.withAdditionalParams = function (_additionalParams) {
        this._additionalParams = _additionalParams;
        return this;
    };
    ExternalCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            additionalParams: this._additionalParams !== UnassignedValue ? this._additionalParams : maybe(jsonMapOf(function () { return createNull(); })),
            artifactName: this._artifactName !== UnassignedValue ? this._artifactName : maybe(someString()),
            conditionType: this._conditionType !== UnassignedValue ? this._conditionType : maybe(createNull()),
            expectedValue: this._expectedValue !== UnassignedValue ? this._expectedValue : maybe(createNull()),
        };
    };
    return ExternalCriteriaDTOBuilder;
}());
exports.ExternalCriteriaDTOBuilder = ExternalCriteriaDTOBuilder;
var ExternalCriteriaConditionTypeDTOBuilder = /** @class */ (function () {
    function ExternalCriteriaConditionTypeDTOBuilder() {
    }
    ExternalCriteriaConditionTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalCriteriaConditionType', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return ExternalCriteriaConditionTypeDTOBuilder;
}());
exports.ExternalCriteriaConditionTypeDTOBuilder = ExternalCriteriaConditionTypeDTOBuilder;
var ExternalCriteriaConditionTypeEnumDTOBuilder = /** @class */ (function () {
    function ExternalCriteriaConditionTypeEnumDTOBuilder() {
    }
    ExternalCriteriaConditionTypeEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ExternalCriteriaConditionTypeEnum.UNKNOWN,
            types_1.ExternalCriteriaConditionTypeEnum.EQUAL,
            types_1.ExternalCriteriaConditionTypeEnum.GREATER_THAN,
            types_1.ExternalCriteriaConditionTypeEnum.SMALLER_THAN,
        ]);
    };
    return ExternalCriteriaConditionTypeEnumDTOBuilder;
}());
exports.ExternalCriteriaConditionTypeEnumDTOBuilder = ExternalCriteriaConditionTypeEnumDTOBuilder;
var ExternalFilterCriteriaDTOBuilder = /** @class */ (function () {
    function ExternalFilterCriteriaDTOBuilder() {
        this._additionalParams = UnassignedValue;
        this._conditionType = UnassignedValue;
        this._expectedValue = UnassignedValue;
        this._id = UnassignedValue;
    }
    ExternalFilterCriteriaDTOBuilder.prototype.withConditionType = function (_conditionType) {
        this._conditionType = _conditionType;
        return this;
    };
    ExternalFilterCriteriaDTOBuilder.prototype.withExpectedValue = function (_expectedValue) {
        this._expectedValue = _expectedValue;
        return this;
    };
    ExternalFilterCriteriaDTOBuilder.prototype.withAdditionalParams = function (_additionalParams) {
        this._additionalParams = _additionalParams;
        return this;
    };
    ExternalFilterCriteriaDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    ExternalFilterCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalFilterCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            additionalParams: this._additionalParams !== UnassignedValue ? this._additionalParams : maybe(jsonMapOf(function () { return createNull(); })),
            conditionType: this._conditionType !== UnassignedValue ? this._conditionType : maybe(createNull()),
            expectedValue: this._expectedValue !== UnassignedValue ? this._expectedValue : maybe(createNull()),
            id: this._id !== UnassignedValue ? this._id : maybe(someString()),
        };
    };
    return ExternalFilterCriteriaDTOBuilder;
}());
exports.ExternalFilterCriteriaDTOBuilder = ExternalFilterCriteriaDTOBuilder;
var ExternalFilterCriteriaConditionTypeDTOBuilder = /** @class */ (function () {
    function ExternalFilterCriteriaConditionTypeDTOBuilder() {
    }
    ExternalFilterCriteriaConditionTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalFilterCriteriaConditionType', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return ExternalFilterCriteriaConditionTypeDTOBuilder;
}());
exports.ExternalFilterCriteriaConditionTypeDTOBuilder = ExternalFilterCriteriaConditionTypeDTOBuilder;
var ExternalFilterCriteriaConditionTypeEnumDTOBuilder = /** @class */ (function () {
    function ExternalFilterCriteriaConditionTypeEnumDTOBuilder() {
    }
    ExternalFilterCriteriaConditionTypeEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ExternalFilterCriteriaConditionTypeEnum.UNKNOWN,
            types_1.ExternalFilterCriteriaConditionTypeEnum.EQUAL,
            types_1.ExternalFilterCriteriaConditionTypeEnum.GREATER_THAN,
            types_1.ExternalFilterCriteriaConditionTypeEnum.SMALLER_THAN,
            types_1.ExternalFilterCriteriaConditionTypeEnum.CONTAINS_ALL,
            types_1.ExternalFilterCriteriaConditionTypeEnum.CONTAINS_SOME,
            types_1.ExternalFilterCriteriaConditionTypeEnum.NOT_CONTAINS_SOME,
            types_1.ExternalFilterCriteriaConditionTypeEnum.NOT_CONTAINS_ALL,
            types_1.ExternalFilterCriteriaConditionTypeEnum.BE_NOTHING,
            types_1.ExternalFilterCriteriaConditionTypeEnum.EXISTS,
            types_1.ExternalFilterCriteriaConditionTypeEnum.MORE_THAN_DAYS,
            types_1.ExternalFilterCriteriaConditionTypeEnum.WITHIN_DAYS,
            types_1.ExternalFilterCriteriaConditionTypeEnum.NOT_EQUAL,
        ]);
    };
    return ExternalFilterCriteriaConditionTypeEnumDTOBuilder;
}());
exports.ExternalFilterCriteriaConditionTypeEnumDTOBuilder = ExternalFilterCriteriaConditionTypeEnumDTOBuilder;
var ExternalFilterProviderConfigDTOBuilder = /** @class */ (function () {
    function ExternalFilterProviderConfigDTOBuilder() {
        this._baseUri = UnassignedValue;
        this._toggleExtendApplyFilterList = UnassignedValue;
    }
    ExternalFilterProviderConfigDTOBuilder.prototype.withBaseUri = function (_baseUri) {
        this._baseUri = _baseUri;
        return this;
    };
    ExternalFilterProviderConfigDTOBuilder.prototype.withToggleExtendApplyFilterList = function (_toggleExtendApplyFilterList) {
        this._toggleExtendApplyFilterList = _toggleExtendApplyFilterList;
        return this;
    };
    ExternalFilterProviderConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ExternalFilterProviderConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            baseUri: this._baseUri !== UnassignedValue ? this._baseUri : maybe(someString()),
            toggleExtendApplyFilterList: this._toggleExtendApplyFilterList !== UnassignedValue ? this._toggleExtendApplyFilterList : maybe(someBoolean()),
        };
    };
    return ExternalFilterProviderConfigDTOBuilder;
}());
exports.ExternalFilterProviderConfigDTOBuilder = ExternalFilterProviderConfigDTOBuilder;
var FieldDescriptorProtoDTOBuilder = /** @class */ (function () {
    function FieldDescriptorProtoDTOBuilder() {
        this._defaultValue = UnassignedValue;
        this._extendee = UnassignedValue;
        this._jsonName = UnassignedValue;
        this._label = UnassignedValue;
        this._name = UnassignedValue;
        this._number = UnassignedValue;
        this._oneofIndex = UnassignedValue;
        this._options = UnassignedValue;
        this._proto3Optional = UnassignedValue;
        this._type = UnassignedValue;
        this._typeName = UnassignedValue;
    }
    FieldDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withNumber = function (_number) {
        this._number = _number;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withLabel = function (_label) {
        this._label = _label;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withTypeName = function (_typeName) {
        this._typeName = _typeName;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withExtendee = function (_extendee) {
        this._extendee = _extendee;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withDefaultValue = function (_defaultValue) {
        this._defaultValue = _defaultValue;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withOneofIndex = function (_oneofIndex) {
        this._oneofIndex = _oneofIndex;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withJsonName = function (_jsonName) {
        this._jsonName = _jsonName;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.withProto3Optional = function (_proto3Optional) {
        this._proto3Optional = _proto3Optional;
        return this;
    };
    FieldDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FieldDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            defaultValue: this._defaultValue !== UnassignedValue ? this._defaultValue : maybe(someString()),
            extendee: this._extendee !== UnassignedValue ? this._extendee : maybe(someString()),
            jsonName: this._jsonName !== UnassignedValue ? this._jsonName : maybe(someString()),
            label: this._label !== UnassignedValue ? this._label : maybe(exports.aLabel().build({ buildersVisited: buildersVisited })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            number: this._number !== UnassignedValue ? this._number : maybe(someInt()),
            oneofIndex: this._oneofIndex !== UnassignedValue ? this._oneofIndex : maybe(someInt()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.aFieldOptions().build({ buildersVisited: buildersVisited })),
            proto3Optional: this._proto3Optional !== UnassignedValue ? this._proto3Optional : maybe(someBoolean()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aFieldDescriptorProtoType().build({ buildersVisited: buildersVisited })),
            typeName: this._typeName !== UnassignedValue ? this._typeName : maybe(someString()),
        };
    };
    return FieldDescriptorProtoDTOBuilder;
}());
exports.FieldDescriptorProtoDTOBuilder = FieldDescriptorProtoDTOBuilder;
var FieldDescriptorProtoTypeDTOBuilder = /** @class */ (function () {
    function FieldDescriptorProtoTypeDTOBuilder() {
    }
    FieldDescriptorProtoTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.FieldDescriptorProtoType.TYPE_DOUBLE,
            types_1.FieldDescriptorProtoType.TYPE_FLOAT,
            types_1.FieldDescriptorProtoType.TYPE_INT64,
            types_1.FieldDescriptorProtoType.TYPE_UINT64,
            types_1.FieldDescriptorProtoType.TYPE_INT32,
            types_1.FieldDescriptorProtoType.TYPE_FIXED64,
            types_1.FieldDescriptorProtoType.TYPE_FIXED32,
            types_1.FieldDescriptorProtoType.TYPE_BOOL,
            types_1.FieldDescriptorProtoType.TYPE_STRING,
            types_1.FieldDescriptorProtoType.TYPE_GROUP,
            types_1.FieldDescriptorProtoType.TYPE_MESSAGE,
            types_1.FieldDescriptorProtoType.TYPE_BYTES,
            types_1.FieldDescriptorProtoType.TYPE_UINT32,
            types_1.FieldDescriptorProtoType.TYPE_ENUM,
            types_1.FieldDescriptorProtoType.TYPE_SFIXED32,
            types_1.FieldDescriptorProtoType.TYPE_SFIXED64,
            types_1.FieldDescriptorProtoType.TYPE_SINT32,
            types_1.FieldDescriptorProtoType.TYPE_SINT64,
        ]);
    };
    return FieldDescriptorProtoTypeDTOBuilder;
}());
exports.FieldDescriptorProtoTypeDTOBuilder = FieldDescriptorProtoTypeDTOBuilder;
var FieldOptionsDTOBuilder = /** @class */ (function () {
    function FieldOptionsDTOBuilder() {
        this._ctype = UnassignedValue;
        this._deprecated = UnassignedValue;
        this._jstype = UnassignedValue;
        this._lazy = UnassignedValue;
        this._packed = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
        this._weak = UnassignedValue;
    }
    FieldOptionsDTOBuilder.prototype.withCtype = function (_ctype) {
        this._ctype = _ctype;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withPacked = function (_packed) {
        this._packed = _packed;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withJstype = function (_jstype) {
        this._jstype = _jstype;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withLazy = function (_lazy) {
        this._lazy = _lazy;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withWeak = function (_weak) {
        this._weak = _weak;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    FieldOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FieldOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            ctype: this._ctype !== UnassignedValue ? this._ctype : maybe(exports.aCType().build({ buildersVisited: buildersVisited })),
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            jstype: this._jstype !== UnassignedValue ? this._jstype : maybe(exports.aJSType().build({ buildersVisited: buildersVisited })),
            lazy: this._lazy !== UnassignedValue ? this._lazy : maybe(someBoolean()),
            packed: this._packed !== UnassignedValue ? this._packed : maybe(someBoolean()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
            weak: this._weak !== UnassignedValue ? this._weak : maybe(someBoolean()),
        };
    };
    return FieldOptionsDTOBuilder;
}());
exports.FieldOptionsDTOBuilder = FieldOptionsDTOBuilder;
var FieldSetDTOBuilder = /** @class */ (function () {
    function FieldSetDTOBuilder() {
        this._field = UnassignedValue;
    }
    FieldSetDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    FieldSetDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FieldSet', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return someString(); })),
        };
    };
    return FieldSetDTOBuilder;
}());
exports.FieldSetDTOBuilder = FieldSetDTOBuilder;
var FileDescriptorSetDTOBuilder = /** @class */ (function () {
    function FileDescriptorSetDTOBuilder() {
        this._file = UnassignedValue;
    }
    FileDescriptorSetDTOBuilder.prototype.withFile = function (_file) {
        this._file = _file;
        return this;
    };
    FileDescriptorSetDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FileDescriptorSet', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            file: this._file !== UnassignedValue ? this._file : maybe(manyOf(function () { return createNull(); })),
        };
    };
    return FileDescriptorSetDTOBuilder;
}());
exports.FileDescriptorSetDTOBuilder = FileDescriptorSetDTOBuilder;
var FileOptionsDTOBuilder = /** @class */ (function () {
    function FileOptionsDTOBuilder() {
        this._ccEnableArenas = UnassignedValue;
        this._ccGenericServices = UnassignedValue;
        this._csharpNamespace = UnassignedValue;
        this._deprecated = UnassignedValue;
        this._goPackage = UnassignedValue;
        this._javaGenerateEqualsAndHash = UnassignedValue;
        this._javaGenericServices = UnassignedValue;
        this._javaMultipleFiles = UnassignedValue;
        this._javaOuterClassname = UnassignedValue;
        this._javaPackage = UnassignedValue;
        this._javaStringCheckUtf8 = UnassignedValue;
        this._objcClassPrefix = UnassignedValue;
        this._optimizeFor = UnassignedValue;
        this._phpClassPrefix = UnassignedValue;
        this._phpGenericServices = UnassignedValue;
        this._phpMetadataNamespace = UnassignedValue;
        this._phpNamespace = UnassignedValue;
        this._pyGenericServices = UnassignedValue;
        this._rubyPackage = UnassignedValue;
        this._swiftPrefix = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    FileOptionsDTOBuilder.prototype.withJavaPackage = function (_javaPackage) {
        this._javaPackage = _javaPackage;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withJavaOuterClassname = function (_javaOuterClassname) {
        this._javaOuterClassname = _javaOuterClassname;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withJavaMultipleFiles = function (_javaMultipleFiles) {
        this._javaMultipleFiles = _javaMultipleFiles;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withJavaGenerateEqualsAndHash = function (_javaGenerateEqualsAndHash) {
        this._javaGenerateEqualsAndHash = _javaGenerateEqualsAndHash;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withJavaStringCheckUtf8 = function (_javaStringCheckUtf8) {
        this._javaStringCheckUtf8 = _javaStringCheckUtf8;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withOptimizeFor = function (_optimizeFor) {
        this._optimizeFor = _optimizeFor;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withGoPackage = function (_goPackage) {
        this._goPackage = _goPackage;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withCcGenericServices = function (_ccGenericServices) {
        this._ccGenericServices = _ccGenericServices;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withJavaGenericServices = function (_javaGenericServices) {
        this._javaGenericServices = _javaGenericServices;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withPyGenericServices = function (_pyGenericServices) {
        this._pyGenericServices = _pyGenericServices;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withPhpGenericServices = function (_phpGenericServices) {
        this._phpGenericServices = _phpGenericServices;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withCcEnableArenas = function (_ccEnableArenas) {
        this._ccEnableArenas = _ccEnableArenas;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withObjcClassPrefix = function (_objcClassPrefix) {
        this._objcClassPrefix = _objcClassPrefix;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withCsharpNamespace = function (_csharpNamespace) {
        this._csharpNamespace = _csharpNamespace;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withSwiftPrefix = function (_swiftPrefix) {
        this._swiftPrefix = _swiftPrefix;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withPhpClassPrefix = function (_phpClassPrefix) {
        this._phpClassPrefix = _phpClassPrefix;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withPhpNamespace = function (_phpNamespace) {
        this._phpNamespace = _phpNamespace;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withPhpMetadataNamespace = function (_phpMetadataNamespace) {
        this._phpMetadataNamespace = _phpMetadataNamespace;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withRubyPackage = function (_rubyPackage) {
        this._rubyPackage = _rubyPackage;
        return this;
    };
    FileOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    FileOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FileOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            ccEnableArenas: this._ccEnableArenas !== UnassignedValue ? this._ccEnableArenas : maybe(someBoolean()),
            ccGenericServices: this._ccGenericServices !== UnassignedValue ? this._ccGenericServices : maybe(someBoolean()),
            csharpNamespace: this._csharpNamespace !== UnassignedValue ? this._csharpNamespace : maybe(someString()),
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            goPackage: this._goPackage !== UnassignedValue ? this._goPackage : maybe(someString()),
            javaGenerateEqualsAndHash: this._javaGenerateEqualsAndHash !== UnassignedValue ? this._javaGenerateEqualsAndHash : maybe(someBoolean()),
            javaGenericServices: this._javaGenericServices !== UnassignedValue ? this._javaGenericServices : maybe(someBoolean()),
            javaMultipleFiles: this._javaMultipleFiles !== UnassignedValue ? this._javaMultipleFiles : maybe(someBoolean()),
            javaOuterClassname: this._javaOuterClassname !== UnassignedValue ? this._javaOuterClassname : maybe(someString()),
            javaPackage: this._javaPackage !== UnassignedValue ? this._javaPackage : maybe(someString()),
            javaStringCheckUtf8: this._javaStringCheckUtf8 !== UnassignedValue ? this._javaStringCheckUtf8 : maybe(someBoolean()),
            objcClassPrefix: this._objcClassPrefix !== UnassignedValue ? this._objcClassPrefix : maybe(someString()),
            optimizeFor: this._optimizeFor !== UnassignedValue ? this._optimizeFor : maybe(exports.anOptimizeMode().build({ buildersVisited: buildersVisited })),
            phpClassPrefix: this._phpClassPrefix !== UnassignedValue ? this._phpClassPrefix : maybe(someString()),
            phpGenericServices: this._phpGenericServices !== UnassignedValue ? this._phpGenericServices : maybe(someBoolean()),
            phpMetadataNamespace: this._phpMetadataNamespace !== UnassignedValue ? this._phpMetadataNamespace : maybe(someString()),
            phpNamespace: this._phpNamespace !== UnassignedValue ? this._phpNamespace : maybe(someString()),
            pyGenericServices: this._pyGenericServices !== UnassignedValue ? this._pyGenericServices : maybe(someBoolean()),
            rubyPackage: this._rubyPackage !== UnassignedValue ? this._rubyPackage : maybe(someString()),
            swiftPrefix: this._swiftPrefix !== UnassignedValue ? this._swiftPrefix : maybe(someString()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return FileOptionsDTOBuilder;
}());
exports.FileOptionsDTOBuilder = FileOptionsDTOBuilder;
var FixedItemDTOBuilder = /** @class */ (function () {
    function FixedItemDTOBuilder() {
        this._itemId = UnassignedValue;
        this._priority = UnassignedValue;
    }
    FixedItemDTOBuilder.prototype.withItemId = function (_itemId) {
        this._itemId = _itemId;
        return this;
    };
    FixedItemDTOBuilder.prototype.withPriority = function (_priority) {
        this._priority = _priority;
        return this;
    };
    FixedItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FixedItem', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemId: this._itemId !== UnassignedValue ? this._itemId : maybe(someGuid()),
            priority: this._priority !== UnassignedValue ? this._priority : maybe(someInt()),
        };
    };
    return FixedItemDTOBuilder;
}());
exports.FixedItemDTOBuilder = FixedItemDTOBuilder;
var FormatDTOBuilder = /** @class */ (function () {
    function FormatDTOBuilder() {
    }
    FormatDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.Format.EMAIL,
            types_1.Format.HOSTNAME,
            types_1.Format.IPV4,
            types_1.Format.IPV6,
            types_1.Format.URI,
            types_1.Format.WEB_URL,
            types_1.Format.PHONE,
            types_1.Format.CREDIT_CARD,
            types_1.Format.GUID,
            types_1.Format.COUNTRY,
            types_1.Format.LANGUAGE,
            types_1.Format.DECIMAL_VALUE,
            types_1.Format.CURRENCY,
            types_1.Format.LANGUAGE_TAG,
            types_1.Format.COLOR_HEX,
            types_1.Format.LOCAL_DATE,
            types_1.Format.LOCAL_TIME,
            types_1.Format.LOCAL_DATE_TIME,
            types_1.Format.URL_SLUG,
            types_1.Format.SYSTEM_SLUG,
        ]);
    };
    return FormatDTOBuilder;
}());
exports.FormatDTOBuilder = FormatDTOBuilder;
var FreeSiteCriteriaDTOBuilder = /** @class */ (function () {
    function FreeSiteCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    FreeSiteCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    FreeSiteCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FreeSiteCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aFreeSiteCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return FreeSiteCriteriaDTOBuilder;
}());
exports.FreeSiteCriteriaDTOBuilder = FreeSiteCriteriaDTOBuilder;
var FreeSiteCriteriaEnumDTOBuilder = /** @class */ (function () {
    function FreeSiteCriteriaEnumDTOBuilder() {
    }
    FreeSiteCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.FreeSiteCriteriaEnum.UNKNOWN, types_1.FreeSiteCriteriaEnum.HAS_FREE, types_1.FreeSiteCriteriaEnum.NO_FREE]);
    };
    return FreeSiteCriteriaEnumDTOBuilder;
}());
exports.FreeSiteCriteriaEnumDTOBuilder = FreeSiteCriteriaEnumDTOBuilder;
var FrequencyCapsDTOBuilder = /** @class */ (function () {
    function FrequencyCapsDTOBuilder() {
        this._conditions = UnassignedValue;
        this._countWithRelatedOffers = UnassignedValue;
    }
    FrequencyCapsDTOBuilder.prototype.withCountWithRelatedOffers = function (_countWithRelatedOffers) {
        this._countWithRelatedOffers = _countWithRelatedOffers;
        return this;
    };
    FrequencyCapsDTOBuilder.prototype.withConditions = function (_conditions) {
        this._conditions = _conditions;
        return this;
    };
    FrequencyCapsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCaps', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            conditions: this._conditions !== UnassignedValue ? this._conditions : maybe(exports.aConditions().build({ buildersVisited: buildersVisited })),
            countWithRelatedOffers: this._countWithRelatedOffers !== UnassignedValue ? this._countWithRelatedOffers : maybe(someBoolean()),
        };
    };
    return FrequencyCapsDTOBuilder;
}());
exports.FrequencyCapsDTOBuilder = FrequencyCapsDTOBuilder;
var FrequencyCapsConditionsResultDTOBuilder = /** @class */ (function () {
    function FrequencyCapsConditionsResultDTOBuilder() {
        this._closes = UnassignedValue;
        this._mainCtaClicks = UnassignedValue;
        this._showLater = UnassignedValue;
        this._skips = UnassignedValue;
        this._views = UnassignedValue;
    }
    FrequencyCapsConditionsResultDTOBuilder.prototype.withViews = function (_views) {
        this._views = _views;
        return this;
    };
    FrequencyCapsConditionsResultDTOBuilder.prototype.withMainCtaClicks = function (_mainCtaClicks) {
        this._mainCtaClicks = _mainCtaClicks;
        return this;
    };
    FrequencyCapsConditionsResultDTOBuilder.prototype.withSkips = function (_skips) {
        this._skips = _skips;
        return this;
    };
    FrequencyCapsConditionsResultDTOBuilder.prototype.withCloses = function (_closes) {
        this._closes = _closes;
        return this;
    };
    FrequencyCapsConditionsResultDTOBuilder.prototype.withShowLater = function (_showLater) {
        this._showLater = _showLater;
        return this;
    };
    FrequencyCapsConditionsResultDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCapsConditionsResult', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            closes: this._closes !== UnassignedValue ? this._closes : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            mainCtaClicks: this._mainCtaClicks !== UnassignedValue ? this._mainCtaClicks : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            showLater: this._showLater !== UnassignedValue ? this._showLater : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            skips: this._skips !== UnassignedValue ? this._skips : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            views: this._views !== UnassignedValue ? this._views : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
        };
    };
    return FrequencyCapsConditionsResultDTOBuilder;
}());
exports.FrequencyCapsConditionsResultDTOBuilder = FrequencyCapsConditionsResultDTOBuilder;
var FrequencyCapsConfigDTOBuilder = /** @class */ (function () {
    function FrequencyCapsConfigDTOBuilder() {
        this._frequencyCaps = UnassignedValue;
        this._supportedEvents = UnassignedValue;
    }
    FrequencyCapsConfigDTOBuilder.prototype.withFrequencyCaps = function (_frequencyCaps) {
        this._frequencyCaps = _frequencyCaps;
        return this;
    };
    FrequencyCapsConfigDTOBuilder.prototype.withSupportedEvents = function (_supportedEvents) {
        this._supportedEvents = _supportedEvents;
        return this;
    };
    FrequencyCapsConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCapsConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            frequencyCaps: this._frequencyCaps !== UnassignedValue ? this._frequencyCaps : maybe(exports.aFrequencyCaps().build({ buildersVisited: buildersVisited })),
            supportedEvents: this._supportedEvents !== UnassignedValue ? this._supportedEvents : maybe(exports.aFrequencyCapsEvents().build({ buildersVisited: buildersVisited })),
        };
    };
    return FrequencyCapsConfigDTOBuilder;
}());
exports.FrequencyCapsConfigDTOBuilder = FrequencyCapsConfigDTOBuilder;
var FrequencyCapsEventTypeDTOBuilder = /** @class */ (function () {
    function FrequencyCapsEventTypeDTOBuilder() {
    }
    FrequencyCapsEventTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.FrequencyCapsEventType.UNKNOWN,
            types_1.FrequencyCapsEventType.VIEW,
            types_1.FrequencyCapsEventType.MAIN_CTA_CLICK,
            types_1.FrequencyCapsEventType.SKIP,
            types_1.FrequencyCapsEventType.UNSKIP,
            types_1.FrequencyCapsEventType.CLOSE,
            types_1.FrequencyCapsEventType.SHOW_LATER,
        ]);
    };
    return FrequencyCapsEventTypeDTOBuilder;
}());
exports.FrequencyCapsEventTypeDTOBuilder = FrequencyCapsEventTypeDTOBuilder;
var FrequencyCapsEventsDTOBuilder = /** @class */ (function () {
    function FrequencyCapsEventsDTOBuilder() {
        this._events = UnassignedValue;
    }
    FrequencyCapsEventsDTOBuilder.prototype.withEvents = function (_events) {
        this._events = _events;
        return this;
    };
    FrequencyCapsEventsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCapsEvents', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            events: this._events !== UnassignedValue ? this._events : maybe(manyOf(function () { return exports.aFrequencyCapsEventType().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return FrequencyCapsEventsDTOBuilder;
}());
exports.FrequencyCapsEventsDTOBuilder = FrequencyCapsEventsDTOBuilder;
var FrequencyCapsExecutionResultDTOBuilder = /** @class */ (function () {
    function FrequencyCapsExecutionResultDTOBuilder() {
        this._conditionsExecutionResult = UnassignedValue;
        this._frequencyCaps = UnassignedValue;
        this._offerEligible = UnassignedValue;
    }
    FrequencyCapsExecutionResultDTOBuilder.prototype.withOfferEligible = function (_offerEligible) {
        this._offerEligible = _offerEligible;
        return this;
    };
    FrequencyCapsExecutionResultDTOBuilder.prototype.withFrequencyCaps = function (_frequencyCaps) {
        this._frequencyCaps = _frequencyCaps;
        return this;
    };
    FrequencyCapsExecutionResultDTOBuilder.prototype.withConditionsExecutionResult = function (_conditionsExecutionResult) {
        this._conditionsExecutionResult = _conditionsExecutionResult;
        return this;
    };
    FrequencyCapsExecutionResultDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCapsExecutionResult', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            conditionsExecutionResult: this._conditionsExecutionResult !== UnassignedValue ? this._conditionsExecutionResult : maybe(exports.aFrequencyCapsConditionsResult().build({ buildersVisited: buildersVisited })),
            frequencyCaps: this._frequencyCaps !== UnassignedValue ? this._frequencyCaps : maybe(exports.aFrequencyCaps().build({ buildersVisited: buildersVisited })),
            offerEligible: this._offerEligible !== UnassignedValue ? this._offerEligible : maybe(someBoolean()),
        };
    };
    return FrequencyCapsExecutionResultDTOBuilder;
}());
exports.FrequencyCapsExecutionResultDTOBuilder = FrequencyCapsExecutionResultDTOBuilder;
var FrequencyCapsOverridesTypeDTOBuilder = /** @class */ (function () {
    function FrequencyCapsOverridesTypeDTOBuilder() {
    }
    FrequencyCapsOverridesTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.FrequencyCapsOverridesType.UNKNOWN, types_1.FrequencyCapsOverridesType.PLACEMENT_LEVEL, types_1.FrequencyCapsOverridesType.OFFER_LEVEL]);
    };
    return FrequencyCapsOverridesTypeDTOBuilder;
}());
exports.FrequencyCapsOverridesTypeDTOBuilder = FrequencyCapsOverridesTypeDTOBuilder;
var FrequencyCapsRequestOverridesDTOBuilder = /** @class */ (function () {
    function FrequencyCapsRequestOverridesDTOBuilder() {
        this._conditions = UnassignedValue;
        this._type = UnassignedValue;
    }
    FrequencyCapsRequestOverridesDTOBuilder.prototype.withConditions = function (_conditions) {
        this._conditions = _conditions;
        return this;
    };
    FrequencyCapsRequestOverridesDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    FrequencyCapsRequestOverridesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FrequencyCapsRequestOverrides', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            conditions: this._conditions !== UnassignedValue ? this._conditions : maybe(exports.aConditions().build({ buildersVisited: buildersVisited })),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aFrequencyCapsOverridesType().build({ buildersVisited: buildersVisited })),
        };
    };
    return FrequencyCapsRequestOverridesDTOBuilder;
}());
exports.FrequencyCapsRequestOverridesDTOBuilder = FrequencyCapsRequestOverridesDTOBuilder;
var GeneratedCodeInfoDTOBuilder = /** @class */ (function () {
    function GeneratedCodeInfoDTOBuilder() {
        this._annotation = UnassignedValue;
    }
    GeneratedCodeInfoDTOBuilder.prototype.withAnnotation = function (_annotation) {
        this._annotation = _annotation;
        return this;
    };
    GeneratedCodeInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GeneratedCodeInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            annotation: this._annotation !== UnassignedValue ? this._annotation : maybe(manyOf(function () { return exports.anAnnotation().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return GeneratedCodeInfoDTOBuilder;
}());
exports.GeneratedCodeInfoDTOBuilder = GeneratedCodeInfoDTOBuilder;
var GetDeletedMethodOptionsDTOBuilder = /** @class */ (function () {
    function GetDeletedMethodOptionsDTOBuilder() {
        this._idField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    GetDeletedMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    GetDeletedMethodOptionsDTOBuilder.prototype.withIdField = function (_idField) {
        this._idField = _idField;
        return this;
    };
    GetDeletedMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetDeletedMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idField: this._idField !== UnassignedValue ? this._idField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return GetDeletedMethodOptionsDTOBuilder;
}());
exports.GetDeletedMethodOptionsDTOBuilder = GetDeletedMethodOptionsDTOBuilder;
var GetItemMethodOptionsDTOBuilder = /** @class */ (function () {
    function GetItemMethodOptionsDTOBuilder() {
        this._idField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    GetItemMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    GetItemMethodOptionsDTOBuilder.prototype.withIdField = function (_idField) {
        this._idField = _idField;
        return this;
    };
    GetItemMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetItemMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idField: this._idField !== UnassignedValue ? this._idField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return GetItemMethodOptionsDTOBuilder;
}());
exports.GetItemMethodOptionsDTOBuilder = GetItemMethodOptionsDTOBuilder;
var GetOfferRequestDTOBuilder = /** @class */ (function () {
    function GetOfferRequestDTOBuilder() {
        this._context = UnassignedValue;
        this._offerId = UnassignedValue;
    }
    GetOfferRequestDTOBuilder.prototype.withOfferId = function (_offerId) {
        this._offerId = _offerId;
        return this;
    };
    GetOfferRequestDTOBuilder.prototype.withContext = function (_context) {
        this._context = _context;
        return this;
    };
    GetOfferRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetOfferRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            context: this._context !== UnassignedValue ? this._context : maybe(exports.aRequestContext().build({ buildersVisited: buildersVisited })),
            offerId: this._offerId !== UnassignedValue ? this._offerId : maybe(someString()),
        };
    };
    return GetOfferRequestDTOBuilder;
}());
exports.GetOfferRequestDTOBuilder = GetOfferRequestDTOBuilder;
var GetOfferResponseDTOBuilder = /** @class */ (function () {
    function GetOfferResponseDTOBuilder() {
        this._offer = UnassignedValue;
    }
    GetOfferResponseDTOBuilder.prototype.withOffer = function (_offer) {
        this._offer = _offer;
        return this;
    };
    GetOfferResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetOfferResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            offer: this._offer !== UnassignedValue ? this._offer : maybe(exports.anOffer().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetOfferResponseDTOBuilder;
}());
exports.GetOfferResponseDTOBuilder = GetOfferResponseDTOBuilder;
var GetPlacementRequestDTOBuilder = /** @class */ (function () {
    function GetPlacementRequestDTOBuilder() {
        this._placementId = UnassignedValue;
    }
    GetPlacementRequestDTOBuilder.prototype.withPlacementId = function (_placementId) {
        this._placementId = _placementId;
        return this;
    };
    GetPlacementRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPlacementRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placementId: this._placementId !== UnassignedValue ? this._placementId : maybe(someGuid()),
        };
    };
    return GetPlacementRequestDTOBuilder;
}());
exports.GetPlacementRequestDTOBuilder = GetPlacementRequestDTOBuilder;
var GetPlacementResponseDTOBuilder = /** @class */ (function () {
    function GetPlacementResponseDTOBuilder() {
        this._placement = UnassignedValue;
    }
    GetPlacementResponseDTOBuilder.prototype.withPlacement = function (_placement) {
        this._placement = _placement;
        return this;
    };
    GetPlacementResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPlacementResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placement: this._placement !== UnassignedValue ? this._placement : maybe(exports.aPlacement().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetPlacementResponseDTOBuilder;
}());
exports.GetPlacementResponseDTOBuilder = GetPlacementResponseDTOBuilder;
var GetPlacementsBulkRequestDTOBuilder = /** @class */ (function () {
    function GetPlacementsBulkRequestDTOBuilder() {
        this._placementIds = UnassignedValue;
    }
    GetPlacementsBulkRequestDTOBuilder.prototype.withPlacementIds = function (_placementIds) {
        this._placementIds = _placementIds;
        return this;
    };
    GetPlacementsBulkRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPlacementsBulkRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placementIds: this._placementIds !== UnassignedValue ? this._placementIds : maybe(manyOf(function () { return someGuid(); })),
        };
    };
    return GetPlacementsBulkRequestDTOBuilder;
}());
exports.GetPlacementsBulkRequestDTOBuilder = GetPlacementsBulkRequestDTOBuilder;
var GetPlacementsBulkResponseDTOBuilder = /** @class */ (function () {
    function GetPlacementsBulkResponseDTOBuilder() {
        this._placements = UnassignedValue;
    }
    GetPlacementsBulkResponseDTOBuilder.prototype.withPlacements = function (_placements) {
        this._placements = _placements;
        return this;
    };
    GetPlacementsBulkResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPlacementsBulkResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placements: this._placements !== UnassignedValue ? this._placements : maybe(manyOf(function () { return exports.aPlacement().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return GetPlacementsBulkResponseDTOBuilder;
}());
exports.GetPlacementsBulkResponseDTOBuilder = GetPlacementsBulkResponseDTOBuilder;
var HookableDTOBuilder = /** @class */ (function () {
    function HookableDTOBuilder() {
    }
    HookableDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Hookable', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return HookableDTOBuilder;
}());
exports.HookableDTOBuilder = HookableDTOBuilder;
var HttpDTOBuilder = /** @class */ (function () {
    function HttpDTOBuilder() {
        this._rules = UnassignedValue;
    }
    HttpDTOBuilder.prototype.withRules = function (_rules) {
        this._rules = _rules;
        return this;
    };
    HttpDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Http', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            rules: this._rules !== UnassignedValue ? this._rules : maybe(manyOf(function () { return createNull(); })),
        };
    };
    return HttpDTOBuilder;
}());
exports.HttpDTOBuilder = HttpDTOBuilder;
var IdempotencyLevelDTOBuilder = /** @class */ (function () {
    function IdempotencyLevelDTOBuilder() {
    }
    IdempotencyLevelDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.IdempotencyLevel.IDEMPOTENCY_UNKNOWN, types_1.IdempotencyLevel.NO_SIDE_EFFECTS, types_1.IdempotencyLevel.IDEMPOTENT]);
    };
    return IdempotencyLevelDTOBuilder;
}());
exports.IdempotencyLevelDTOBuilder = IdempotencyLevelDTOBuilder;
var Identification2ServiceDTOBuilder = /** @class */ (function () {
    function Identification2ServiceDTOBuilder() {
        this._appDefId = UnassignedValue;
    }
    Identification2ServiceDTOBuilder.prototype.withAppDefId = function (_appDefId) {
        this._appDefId = _appDefId;
        return this;
    };
    Identification2ServiceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Identification2Service', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefId: this._appDefId !== UnassignedValue ? this._appDefId : maybe(someString()),
        };
    };
    return Identification2ServiceDTOBuilder;
}());
exports.Identification2ServiceDTOBuilder = Identification2ServiceDTOBuilder;
var IdentificationDataDTOBuilder = /** @class */ (function () {
    function IdentificationDataDTOBuilder() {
        this._context = UnassignedValue;
        this._identities = UnassignedValue;
    }
    IdentificationDataDTOBuilder.prototype.withContext = function (_context) {
        this._context = _context;
        return this;
    };
    IdentificationDataDTOBuilder.prototype.withIdentities = function (_identities) {
        this._identities = _identities;
        return this;
    };
    IdentificationDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'IdentificationData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            context: this._context !== UnassignedValue ? this._context : maybe(exports.aContext().build({ buildersVisited: buildersVisited })),
            identities: this._identities !== UnassignedValue ? this._identities : maybe(manyOf(function () { return exports.anIdentity().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return IdentificationDataDTOBuilder;
}());
exports.IdentificationDataDTOBuilder = IdentificationDataDTOBuilder;
var IdentityDTOBuilder = /** @class */ (function () {
    function IdentityDTOBuilder() {
        this._cache = UnassignedValue;
        this._externalApp = UnassignedValue;
        this._person = UnassignedValue;
        this._service = UnassignedValue;
    }
    IdentityDTOBuilder.prototype.withPerson = function (_person) {
        this._person = _person;
        this._service = UnassignedValue;
        this._externalApp = UnassignedValue;
        this._cache = UnassignedValue;
        return this;
    };
    IdentityDTOBuilder.prototype.withService = function (_service) {
        this._service = _service;
        this._person = UnassignedValue;
        this._externalApp = UnassignedValue;
        this._cache = UnassignedValue;
        return this;
    };
    IdentityDTOBuilder.prototype.withExternalApp = function (_externalApp) {
        this._externalApp = _externalApp;
        this._person = UnassignedValue;
        this._service = UnassignedValue;
        this._cache = UnassignedValue;
        return this;
    };
    IdentityDTOBuilder.prototype.withCache = function (_cache) {
        this._cache = _cache;
        this._person = UnassignedValue;
        this._service = UnassignedValue;
        this._externalApp = UnassignedValue;
        return this;
    };
    IdentityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Identity', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._person === UnassignedValue && this._service === UnassignedValue && this._externalApp === UnassignedValue && this._cache === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['person', 'service', 'externalApp', 'cache'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 4), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                cache: assignRandomOneOf('cache', maybe(exports.aCache().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                externalApp: assignRandomOneOf('externalApp', maybe(exports.anExternalApp().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                person: assignRandomOneOf('person', maybe(exports.aPerson().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                service: assignRandomOneOf('service', maybe(exports.anIdentification2Service().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            cache: this._cache === UnassignedValue ? undefined : this._cache,
            externalApp: this._externalApp === UnassignedValue ? undefined : this._externalApp,
            person: this._person === UnassignedValue ? undefined : this._person,
            service: this._service === UnassignedValue ? undefined : this._service,
        };
    };
    return IdentityDTOBuilder;
}());
exports.IdentityDTOBuilder = IdentityDTOBuilder;
var IdentityRequestDTOBuilder = /** @class */ (function () {
    function IdentityRequestDTOBuilder() {
        this._sessions = UnassignedValue;
    }
    IdentityRequestDTOBuilder.prototype.withSessions = function (_sessions) {
        this._sessions = _sessions;
        return this;
    };
    IdentityRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'IdentityRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            sessions: this._sessions !== UnassignedValue ? this._sessions : maybe(jsonMapOf(function () { return someString(); })),
        };
    };
    return IdentityRequestDTOBuilder;
}());
exports.IdentityRequestDTOBuilder = IdentityRequestDTOBuilder;
var IdentityRequestWithExplicitContextDTOBuilder = /** @class */ (function () {
    function IdentityRequestWithExplicitContextDTOBuilder() {
        this._accountIdInContext = UnassignedValue;
        this._metaSiteIdInContext = UnassignedValue;
        this._originalIdentityRequest = UnassignedValue;
        this._originalIdentityResponse = UnassignedValue;
        this._signedInstance = UnassignedValue;
    }
    IdentityRequestWithExplicitContextDTOBuilder.prototype.withOriginalIdentityResponse = function (_originalIdentityResponse) {
        this._originalIdentityResponse = _originalIdentityResponse;
        this._originalIdentityRequest = UnassignedValue;
        return this;
    };
    IdentityRequestWithExplicitContextDTOBuilder.prototype.withOriginalIdentityRequest = function (_originalIdentityRequest) {
        this._originalIdentityRequest = _originalIdentityRequest;
        this._originalIdentityResponse = UnassignedValue;
        return this;
    };
    IdentityRequestWithExplicitContextDTOBuilder.prototype.withAccountIdInContext = function (_accountIdInContext) {
        this._accountIdInContext = _accountIdInContext;
        this._metaSiteIdInContext = UnassignedValue;
        this._signedInstance = UnassignedValue;
        return this;
    };
    IdentityRequestWithExplicitContextDTOBuilder.prototype.withMetaSiteIdInContext = function (_metaSiteIdInContext) {
        this._metaSiteIdInContext = _metaSiteIdInContext;
        this._accountIdInContext = UnassignedValue;
        this._signedInstance = UnassignedValue;
        return this;
    };
    IdentityRequestWithExplicitContextDTOBuilder.prototype.withSignedInstance = function (_signedInstance) {
        this._signedInstance = _signedInstance;
        this._accountIdInContext = UnassignedValue;
        this._metaSiteIdInContext = UnassignedValue;
        return this;
    };
    IdentityRequestWithExplicitContextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'IdentityRequestWithExplicitContext', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._originalIdentityResponse === UnassignedValue &&
            this._originalIdentityRequest === UnassignedValue &&
            this._accountIdInContext === UnassignedValue &&
            this._metaSiteIdInContext === UnassignedValue &&
            this._signedInstance === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['originalIdentityResponse', 'originalIdentityRequest', 'accountIdInContext', 'metaSiteIdInContext', 'signedInstance'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 5), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                accountIdInContext: assignRandomOneOf('accountIdInContext', maybe(exports.anAccountIdInContext().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                metaSiteIdInContext: assignRandomOneOf('metaSiteIdInContext', maybe(exports.aMetaSiteIdInContext().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                originalIdentityRequest: assignRandomOneOf('originalIdentityRequest', maybe(exports.anIdentityRequest().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                originalIdentityResponse: assignRandomOneOf('originalIdentityResponse', maybe(exports.anIdentityResponse().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                signedInstance: assignRandomOneOf('signedInstance', maybe(someString()), oneOfFieldsToUnAssign),
            };
        }
        return {
            accountIdInContext: this._accountIdInContext === UnassignedValue ? undefined : this._accountIdInContext,
            metaSiteIdInContext: this._metaSiteIdInContext === UnassignedValue ? undefined : this._metaSiteIdInContext,
            originalIdentityRequest: this._originalIdentityRequest === UnassignedValue ? undefined : this._originalIdentityRequest,
            originalIdentityResponse: this._originalIdentityResponse === UnassignedValue ? undefined : this._originalIdentityResponse,
            signedInstance: this._signedInstance === UnassignedValue ? undefined : this._signedInstance,
        };
    };
    return IdentityRequestWithExplicitContextDTOBuilder;
}());
exports.IdentityRequestWithExplicitContextDTOBuilder = IdentityRequestWithExplicitContextDTOBuilder;
var IdentityRequestWithServerSignerDTOBuilder = /** @class */ (function () {
    function IdentityRequestWithServerSignerDTOBuilder() {
        this._originalIdentityRequest = UnassignedValue;
        this._originalIdentityResponse = UnassignedValue;
        this._serverSignerToken = UnassignedValue;
    }
    IdentityRequestWithServerSignerDTOBuilder.prototype.withOriginalIdentityRequest = function (_originalIdentityRequest) {
        this._originalIdentityRequest = _originalIdentityRequest;
        return this;
    };
    IdentityRequestWithServerSignerDTOBuilder.prototype.withOriginalIdentityResponse = function (_originalIdentityResponse) {
        this._originalIdentityResponse = _originalIdentityResponse;
        return this;
    };
    IdentityRequestWithServerSignerDTOBuilder.prototype.withServerSignerToken = function (_serverSignerToken) {
        this._serverSignerToken = _serverSignerToken;
        return this;
    };
    IdentityRequestWithServerSignerDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'IdentityRequestWithServerSigner', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            originalIdentityRequest: this._originalIdentityRequest !== UnassignedValue ? this._originalIdentityRequest : maybe(exports.anIdentityRequest().build({ buildersVisited: buildersVisited })),
            originalIdentityResponse: this._originalIdentityResponse !== UnassignedValue ? this._originalIdentityResponse : maybe(exports.anIdentityResponse().build({ buildersVisited: buildersVisited })),
            serverSignerToken: this._serverSignerToken !== UnassignedValue ? this._serverSignerToken : maybe(someString()),
        };
    };
    return IdentityRequestWithServerSignerDTOBuilder;
}());
exports.IdentityRequestWithServerSignerDTOBuilder = IdentityRequestWithServerSignerDTOBuilder;
var IdentityResponseDTOBuilder = /** @class */ (function () {
    function IdentityResponseDTOBuilder() {
        this._identificationData = UnassignedValue;
        this._signedToken = UnassignedValue;
    }
    IdentityResponseDTOBuilder.prototype.withIdentificationData = function (_identificationData) {
        this._identificationData = _identificationData;
        return this;
    };
    IdentityResponseDTOBuilder.prototype.withSignedToken = function (_signedToken) {
        this._signedToken = _signedToken;
        return this;
    };
    IdentityResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'IdentityResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            identificationData: this._identificationData !== UnassignedValue ? this._identificationData : maybe(exports.anIdentificationData().build({ buildersVisited: buildersVisited })),
            signedToken: this._signedToken !== UnassignedValue ? this._signedToken : maybe(someString()),
        };
    };
    return IdentityResponseDTOBuilder;
}());
exports.IdentityResponseDTOBuilder = IdentityResponseDTOBuilder;
var InheritCrudErrorsDTOBuilder = /** @class */ (function () {
    function InheritCrudErrorsDTOBuilder() {
        this._method = UnassignedValue;
    }
    InheritCrudErrorsDTOBuilder.prototype.withMethod = function (_method) {
        this._method = _method;
        return this;
    };
    InheritCrudErrorsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'InheritCrudErrors', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            method: this._method !== UnassignedValue ? this._method : maybe(exports.aMethod().build({ buildersVisited: buildersVisited })),
        };
    };
    return InheritCrudErrorsDTOBuilder;
}());
exports.InheritCrudErrorsDTOBuilder = InheritCrudErrorsDTOBuilder;
var ItemPrioritizedDTOBuilder = /** @class */ (function () {
    function ItemPrioritizedDTOBuilder() {
        this._itemId = UnassignedValue;
        this._metadata = UnassignedValue;
        this._priority = UnassignedValue;
    }
    ItemPrioritizedDTOBuilder.prototype.withItemId = function (_itemId) {
        this._itemId = _itemId;
        return this;
    };
    ItemPrioritizedDTOBuilder.prototype.withPriority = function (_priority) {
        this._priority = _priority;
        return this;
    };
    ItemPrioritizedDTOBuilder.prototype.withMetadata = function (_metadata) {
        this._metadata = _metadata;
        return this;
    };
    ItemPrioritizedDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ItemPrioritized', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemId: this._itemId !== UnassignedValue ? this._itemId : maybe(someGuid()),
            metadata: this._metadata !== UnassignedValue ? this._metadata : maybe(jsonMapOf(function () { return createNull(); })),
            priority: this._priority !== UnassignedValue ? this._priority : maybe(someInt()),
        };
    };
    return ItemPrioritizedDTOBuilder;
}());
exports.ItemPrioritizedDTOBuilder = ItemPrioritizedDTOBuilder;
var JSTypeDTOBuilder = /** @class */ (function () {
    function JSTypeDTOBuilder() {
    }
    JSTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.JSType.JS_NORMAL, types_1.JSType.JS_STRING, types_1.JSType.JS_NUMBER]);
    };
    return JSTypeDTOBuilder;
}());
exports.JSTypeDTOBuilder = JSTypeDTOBuilder;
var LabelDTOBuilder = /** @class */ (function () {
    function LabelDTOBuilder() {
    }
    LabelDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Label.LABEL_OPTIONAL, types_1.Label.LABEL_REQUIRED, types_1.Label.LABEL_REPEATED]);
    };
    return LabelDTOBuilder;
}());
exports.LabelDTOBuilder = LabelDTOBuilder;
var LastEventLimitDTOBuilder = /** @class */ (function () {
    function LastEventLimitDTOBuilder() {
        this._limit = UnassignedValue;
    }
    LastEventLimitDTOBuilder.prototype.withLimit = function (_limit) {
        this._limit = _limit;
        return this;
    };
    LastEventLimitDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'LastEventLimit', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            limit: this._limit !== UnassignedValue ? this._limit : maybe(someInt()),
        };
    };
    return LastEventLimitDTOBuilder;
}());
exports.LastEventLimitDTOBuilder = LastEventLimitDTOBuilder;
var LevelDTOBuilder = /** @class */ (function () {
    function LevelDTOBuilder() {
        this._value = UnassignedValue;
    }
    LevelDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    LevelDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Level', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aLevelEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return LevelDTOBuilder;
}());
exports.LevelDTOBuilder = LevelDTOBuilder;
var LevelEnumDTOBuilder = /** @class */ (function () {
    function LevelEnumDTOBuilder() {
    }
    LevelEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.LevelEnum.UNKNOWN, types_1.LevelEnum.USER, types_1.LevelEnum.SITE]);
    };
    return LevelEnumDTOBuilder;
}());
exports.LevelEnumDTOBuilder = LevelEnumDTOBuilder;
var ListCriteriaDTOBuilder = /** @class */ (function () {
    function ListCriteriaDTOBuilder() {
        this._included = UnassignedValue;
        this._values = UnassignedValue;
    }
    ListCriteriaDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    ListCriteriaDTOBuilder.prototype.withIncluded = function (_included) {
        this._included = _included;
        return this;
    };
    ListCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            included: this._included !== UnassignedValue ? this._included : maybe(someBoolean()),
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return someString(); })),
        };
    };
    return ListCriteriaDTOBuilder;
}());
exports.ListCriteriaDTOBuilder = ListCriteriaDTOBuilder;
var ListDeletedMethodOptionsDTOBuilder = /** @class */ (function () {
    function ListDeletedMethodOptionsDTOBuilder() {
        this._idsField = UnassignedValue;
        this._itemsField = UnassignedValue;
        this._meAliasableField = UnassignedValue;
        this._paging = UnassignedValue;
    }
    ListDeletedMethodOptionsDTOBuilder.prototype.withIdsField = function (_idsField) {
        this._idsField = _idsField;
        return this;
    };
    ListDeletedMethodOptionsDTOBuilder.prototype.withItemsField = function (_itemsField) {
        this._itemsField = _itemsField;
        return this;
    };
    ListDeletedMethodOptionsDTOBuilder.prototype.withPaging = function (_paging) {
        this._paging = _paging;
        return this;
    };
    ListDeletedMethodOptionsDTOBuilder.prototype.withMeAliasableField = function (_meAliasableField) {
        this._meAliasableField = _meAliasableField;
        return this;
    };
    ListDeletedMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListDeletedMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idsField: this._idsField !== UnassignedValue ? this._idsField : maybe(someString()),
            itemsField: this._itemsField !== UnassignedValue ? this._itemsField : maybe(someString()),
            meAliasableField: this._meAliasableField !== UnassignedValue ? this._meAliasableField : maybe(manyOf(function () { return someString(); })),
            paging: this._paging !== UnassignedValue ? this._paging : maybe(exports.aPaging().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListDeletedMethodOptionsDTOBuilder;
}());
exports.ListDeletedMethodOptionsDTOBuilder = ListDeletedMethodOptionsDTOBuilder;
var ListMethodOptionsDTOBuilder = /** @class */ (function () {
    function ListMethodOptionsDTOBuilder() {
        this._idsField = UnassignedValue;
        this._itemsField = UnassignedValue;
        this._meAliasableField = UnassignedValue;
        this._paging = UnassignedValue;
    }
    ListMethodOptionsDTOBuilder.prototype.withIdsField = function (_idsField) {
        this._idsField = _idsField;
        return this;
    };
    ListMethodOptionsDTOBuilder.prototype.withItemsField = function (_itemsField) {
        this._itemsField = _itemsField;
        return this;
    };
    ListMethodOptionsDTOBuilder.prototype.withPaging = function (_paging) {
        this._paging = _paging;
        return this;
    };
    ListMethodOptionsDTOBuilder.prototype.withMeAliasableField = function (_meAliasableField) {
        this._meAliasableField = _meAliasableField;
        return this;
    };
    ListMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idsField: this._idsField !== UnassignedValue ? this._idsField : maybe(someString()),
            itemsField: this._itemsField !== UnassignedValue ? this._itemsField : maybe(someString()),
            meAliasableField: this._meAliasableField !== UnassignedValue ? this._meAliasableField : maybe(manyOf(function () { return someString(); })),
            paging: this._paging !== UnassignedValue ? this._paging : maybe(exports.aPaging().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListMethodOptionsDTOBuilder;
}());
exports.ListMethodOptionsDTOBuilder = ListMethodOptionsDTOBuilder;
var ListOffersBulkRequestDTOBuilder = /** @class */ (function () {
    function ListOffersBulkRequestDTOBuilder() {
        this._customParams = UnassignedValue;
        this._excludeOfferIds = UnassignedValue;
        this._extensions = UnassignedValue;
        this._realEstateIds = UnassignedValue;
        this._skipTargeting = UnassignedValue;
    }
    ListOffersBulkRequestDTOBuilder.prototype.withRealEstateIds = function (_realEstateIds) {
        this._realEstateIds = _realEstateIds;
        return this;
    };
    ListOffersBulkRequestDTOBuilder.prototype.withExcludeOfferIds = function (_excludeOfferIds) {
        this._excludeOfferIds = _excludeOfferIds;
        return this;
    };
    ListOffersBulkRequestDTOBuilder.prototype.withExtensions = function (_extensions) {
        this._extensions = _extensions;
        return this;
    };
    ListOffersBulkRequestDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    ListOffersBulkRequestDTOBuilder.prototype.withSkipTargeting = function (_skipTargeting) {
        this._skipTargeting = _skipTargeting;
        return this;
    };
    ListOffersBulkRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListOffersBulkRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(manyOf(function () { return exports.aCustomParam().build({ buildersVisited: buildersVisited }); })),
            excludeOfferIds: this._excludeOfferIds !== UnassignedValue ? this._excludeOfferIds : maybe(manyOf(function () { return someGuid(); })),
            extensions: this._extensions !== UnassignedValue ? this._extensions : maybe(exports.aRequestExtensions().build({ buildersVisited: buildersVisited })),
            realEstateIds: this._realEstateIds !== UnassignedValue ? this._realEstateIds : maybe(boundedManyOf(1, 3, function () { return someString(); })),
            skipTargeting: this._skipTargeting !== UnassignedValue ? this._skipTargeting : maybe(someBoolean()),
        };
    };
    return ListOffersBulkRequestDTOBuilder;
}());
exports.ListOffersBulkRequestDTOBuilder = ListOffersBulkRequestDTOBuilder;
var ListOffersBulkResponseDTOBuilder = /** @class */ (function () {
    function ListOffersBulkResponseDTOBuilder() {
        this._realEstates = UnassignedValue;
    }
    ListOffersBulkResponseDTOBuilder.prototype.withRealEstates = function (_realEstates) {
        this._realEstates = _realEstates;
        return this;
    };
    ListOffersBulkResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListOffersBulkResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            realEstates: this._realEstates !== UnassignedValue ? this._realEstates : maybe(jsonMapOf(function () { return exports.aListOffersResponse().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ListOffersBulkResponseDTOBuilder;
}());
exports.ListOffersBulkResponseDTOBuilder = ListOffersBulkResponseDTOBuilder;
var ListOffersRequestDTOBuilder = /** @class */ (function () {
    function ListOffersRequestDTOBuilder() {
        this._customParams = UnassignedValue;
        this._deviantArtUserId = UnassignedValue;
        this._excludeOfferIds = UnassignedValue;
        this._extensions = UnassignedValue;
        this._frequencyCapsOverrides = UnassignedValue;
        this._limit = UnassignedValue;
        this._prioritizationStrategyOverrides = UnassignedValue;
        this._realEstateId = UnassignedValue;
        this._skipTargeting = UnassignedValue;
    }
    ListOffersRequestDTOBuilder.prototype.withRealEstateId = function (_realEstateId) {
        this._realEstateId = _realEstateId;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withLimit = function (_limit) {
        this._limit = _limit;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withExcludeOfferIds = function (_excludeOfferIds) {
        this._excludeOfferIds = _excludeOfferIds;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withExtensions = function (_extensions) {
        this._extensions = _extensions;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withDeviantArtUserId = function (_deviantArtUserId) {
        this._deviantArtUserId = _deviantArtUserId;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withFrequencyCapsOverrides = function (_frequencyCapsOverrides) {
        this._frequencyCapsOverrides = _frequencyCapsOverrides;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withSkipTargeting = function (_skipTargeting) {
        this._skipTargeting = _skipTargeting;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.withPrioritizationStrategyOverrides = function (_prioritizationStrategyOverrides) {
        this._prioritizationStrategyOverrides = _prioritizationStrategyOverrides;
        return this;
    };
    ListOffersRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListOffersRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(manyOf(function () { return exports.aCustomParam().build({ buildersVisited: buildersVisited }); })),
            deviantArtUserId: this._deviantArtUserId !== UnassignedValue ? this._deviantArtUserId : maybe(someString()),
            excludeOfferIds: this._excludeOfferIds !== UnassignedValue ? this._excludeOfferIds : maybe(manyOf(function () { return someGuid(); })),
            extensions: this._extensions !== UnassignedValue ? this._extensions : maybe(exports.aRequestExtensions().build({ buildersVisited: buildersVisited })),
            frequencyCapsOverrides: this._frequencyCapsOverrides !== UnassignedValue ? this._frequencyCapsOverrides : maybe(exports.aFrequencyCapsRequestOverrides().build({ buildersVisited: buildersVisited })),
            limit: this._limit !== UnassignedValue ? this._limit : maybe(someInt()),
            prioritizationStrategyOverrides: this._prioritizationStrategyOverrides !== UnassignedValue ? this._prioritizationStrategyOverrides : maybe(exports.aPrioritizationStrategyOverrides().build({ buildersVisited: buildersVisited })),
            realEstateId: this._realEstateId !== UnassignedValue ? this._realEstateId : maybe(someString()),
            skipTargeting: this._skipTargeting !== UnassignedValue ? this._skipTargeting : maybe(someBoolean()),
        };
    };
    return ListOffersRequestDTOBuilder;
}());
exports.ListOffersRequestDTOBuilder = ListOffersRequestDTOBuilder;
var ListOffersResponseDTOBuilder = /** @class */ (function () {
    function ListOffersResponseDTOBuilder() {
        this._offers = UnassignedValue;
    }
    ListOffersResponseDTOBuilder.prototype.withOffers = function (_offers) {
        this._offers = _offers;
        return this;
    };
    ListOffersResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListOffersResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            offers: this._offers !== UnassignedValue ? this._offers : maybe(manyOf(function () { return exports.anOffer().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ListOffersResponseDTOBuilder;
}());
exports.ListOffersResponseDTOBuilder = ListOffersResponseDTOBuilder;
var ListPlacementsRequestDTOBuilder = /** @class */ (function () {
    function ListPlacementsRequestDTOBuilder() {
    }
    ListPlacementsRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListPlacementsRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return ListPlacementsRequestDTOBuilder;
}());
exports.ListPlacementsRequestDTOBuilder = ListPlacementsRequestDTOBuilder;
var ListPlacementsResponseDTOBuilder = /** @class */ (function () {
    function ListPlacementsResponseDTOBuilder() {
        this._placements = UnassignedValue;
    }
    ListPlacementsResponseDTOBuilder.prototype.withPlacements = function (_placements) {
        this._placements = _placements;
        return this;
    };
    ListPlacementsResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListPlacementsResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placements: this._placements !== UnassignedValue ? this._placements : maybe(manyOf(function () { return exports.aPlacement().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ListPlacementsResponseDTOBuilder;
}());
exports.ListPlacementsResponseDTOBuilder = ListPlacementsResponseDTOBuilder;
var ListValueDTOBuilder = /** @class */ (function () {
    function ListValueDTOBuilder() {
        this._values = UnassignedValue;
    }
    ListValueDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    ListValueDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListValue', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return createNull(); })),
        };
    };
    return ListValueDTOBuilder;
}());
exports.ListValueDTOBuilder = ListValueDTOBuilder;
var LocalizedDataDTOBuilder = /** @class */ (function () {
    function LocalizedDataDTOBuilder() {
        this._translations = UnassignedValue;
    }
    LocalizedDataDTOBuilder.prototype.withTranslations = function (_translations) {
        this._translations = _translations;
        return this;
    };
    LocalizedDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'LocalizedData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            translations: this._translations !== UnassignedValue ? this._translations : maybe(jsonMapOf(function () { return someString(); })),
        };
    };
    return LocalizedDataDTOBuilder;
}());
exports.LocalizedDataDTOBuilder = LocalizedDataDTOBuilder;
var LocationDTOBuilder = /** @class */ (function () {
    function LocationDTOBuilder() {
        this._leadingComments = UnassignedValue;
        this._leadingDetachedComments = UnassignedValue;
        this._path = UnassignedValue;
        this._span = UnassignedValue;
        this._trailingComments = UnassignedValue;
    }
    LocationDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    LocationDTOBuilder.prototype.withSpan = function (_span) {
        this._span = _span;
        return this;
    };
    LocationDTOBuilder.prototype.withLeadingComments = function (_leadingComments) {
        this._leadingComments = _leadingComments;
        return this;
    };
    LocationDTOBuilder.prototype.withTrailingComments = function (_trailingComments) {
        this._trailingComments = _trailingComments;
        return this;
    };
    LocationDTOBuilder.prototype.withLeadingDetachedComments = function (_leadingDetachedComments) {
        this._leadingDetachedComments = _leadingDetachedComments;
        return this;
    };
    LocationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Location', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            leadingComments: this._leadingComments !== UnassignedValue ? this._leadingComments : maybe(someString()),
            leadingDetachedComments: this._leadingDetachedComments !== UnassignedValue ? this._leadingDetachedComments : maybe(manyOf(function () { return someString(); })),
            path: this._path !== UnassignedValue ? this._path : maybe(manyOf(function () { return someInt(); })),
            span: this._span !== UnassignedValue ? this._span : maybe(manyOf(function () { return someInt(); })),
            trailingComments: this._trailingComments !== UnassignedValue ? this._trailingComments : maybe(someString()),
        };
    };
    return LocationDTOBuilder;
}());
exports.LocationDTOBuilder = LocationDTOBuilder;
var MailboxCriteriaDTOBuilder = /** @class */ (function () {
    function MailboxCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    MailboxCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    MailboxCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MailboxCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aMailboxCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return MailboxCriteriaDTOBuilder;
}());
exports.MailboxCriteriaDTOBuilder = MailboxCriteriaDTOBuilder;
var MailboxCriteriaEnumDTOBuilder = /** @class */ (function () {
    function MailboxCriteriaEnumDTOBuilder() {
    }
    MailboxCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.MailboxCriteriaEnum.UNKNOWN, types_1.MailboxCriteriaEnum.HAS_MAILBOX, types_1.MailboxCriteriaEnum.NO_MAILBOX]);
    };
    return MailboxCriteriaEnumDTOBuilder;
}());
exports.MailboxCriteriaEnumDTOBuilder = MailboxCriteriaEnumDTOBuilder;
var ManagerIdsWrapperDTOBuilder = /** @class */ (function () {
    function ManagerIdsWrapperDTOBuilder() {
        this._values = UnassignedValue;
    }
    ManagerIdsWrapperDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    ManagerIdsWrapperDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ManagerIdsWrapper', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            values: this._values !== UnassignedValue ? this._values : maybe(boundedManyOf(0, 3, function () { return someGuid(); })),
        };
    };
    return ManagerIdsWrapperDTOBuilder;
}());
exports.ManagerIdsWrapperDTOBuilder = ManagerIdsWrapperDTOBuilder;
var ManagerLocalizationIdsWrapperDTOBuilder = /** @class */ (function () {
    function ManagerLocalizationIdsWrapperDTOBuilder() {
        this._values = UnassignedValue;
    }
    ManagerLocalizationIdsWrapperDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    ManagerLocalizationIdsWrapperDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ManagerLocalizationIdsWrapper', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            values: this._values !== UnassignedValue ? this._values : maybe(boundedManyOf(0, 3, function () { return someGuid(); })),
        };
    };
    return ManagerLocalizationIdsWrapperDTOBuilder;
}());
exports.ManagerLocalizationIdsWrapperDTOBuilder = ManagerLocalizationIdsWrapperDTOBuilder;
var MaturityDTOBuilder = /** @class */ (function () {
    function MaturityDTOBuilder() {
    }
    MaturityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Maturity.ALPHA, types_1.Maturity.BETA, types_1.Maturity.IA, types_1.Maturity.GA, types_1.Maturity.NOT_IMPLEMENTED]);
    };
    return MaturityDTOBuilder;
}());
exports.MaturityDTOBuilder = MaturityDTOBuilder;
var MessageAppendixDTOBuilder = /** @class */ (function () {
    function MessageAppendixDTOBuilder() {
        this._path = UnassignedValue;
        this._type = UnassignedValue;
    }
    MessageAppendixDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    MessageAppendixDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    MessageAppendixDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MessageAppendix', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            path: this._path !== UnassignedValue ? this._path : maybe(someString()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aMessageAppendixType().build({ buildersVisited: buildersVisited })),
        };
    };
    return MessageAppendixDTOBuilder;
}());
exports.MessageAppendixDTOBuilder = MessageAppendixDTOBuilder;
var MessageAppendixTypeDTOBuilder = /** @class */ (function () {
    function MessageAppendixTypeDTOBuilder() {
    }
    MessageAppendixTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.MessageAppendixType.UNKNOWN_APPENDIX_TYPE, types_1.MessageAppendixType.AUTO_VELO, types_1.MessageAppendixType.DOCS_CONF, types_1.MessageAppendixType.MULTILINGUAL]);
    };
    return MessageAppendixTypeDTOBuilder;
}());
exports.MessageAppendixTypeDTOBuilder = MessageAppendixTypeDTOBuilder;
var MessageOptionsDTOBuilder = /** @class */ (function () {
    function MessageOptionsDTOBuilder() {
        this._deprecated = UnassignedValue;
        this._mapEntry = UnassignedValue;
        this._messageSetWireFormat = UnassignedValue;
        this._noStandardDescriptorAccessor = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    MessageOptionsDTOBuilder.prototype.withMessageSetWireFormat = function (_messageSetWireFormat) {
        this._messageSetWireFormat = _messageSetWireFormat;
        return this;
    };
    MessageOptionsDTOBuilder.prototype.withNoStandardDescriptorAccessor = function (_noStandardDescriptorAccessor) {
        this._noStandardDescriptorAccessor = _noStandardDescriptorAccessor;
        return this;
    };
    MessageOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    MessageOptionsDTOBuilder.prototype.withMapEntry = function (_mapEntry) {
        this._mapEntry = _mapEntry;
        return this;
    };
    MessageOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    MessageOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MessageOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            mapEntry: this._mapEntry !== UnassignedValue ? this._mapEntry : maybe(someBoolean()),
            messageSetWireFormat: this._messageSetWireFormat !== UnassignedValue ? this._messageSetWireFormat : maybe(someBoolean()),
            noStandardDescriptorAccessor: this._noStandardDescriptorAccessor !== UnassignedValue ? this._noStandardDescriptorAccessor : maybe(someBoolean()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return MessageOptionsDTOBuilder;
}());
exports.MessageOptionsDTOBuilder = MessageOptionsDTOBuilder;
var MetaSiteIdInContextDTOBuilder = /** @class */ (function () {
    function MetaSiteIdInContextDTOBuilder() {
        this._metaSiteId = UnassignedValue;
    }
    MetaSiteIdInContextDTOBuilder.prototype.withMetaSiteId = function (_metaSiteId) {
        this._metaSiteId = _metaSiteId;
        return this;
    };
    MetaSiteIdInContextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MetaSiteIdInContext', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            metaSiteId: this._metaSiteId !== UnassignedValue ? this._metaSiteId : maybe(someGuid()),
        };
    };
    return MetaSiteIdInContextDTOBuilder;
}());
exports.MetaSiteIdInContextDTOBuilder = MetaSiteIdInContextDTOBuilder;
var MethodDTOBuilder = /** @class */ (function () {
    function MethodDTOBuilder() {
    }
    MethodDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.Method.UNKNOWN_METHOD,
            types_1.Method.CREATE,
            types_1.Method.GET_ITEM,
            types_1.Method.UPDATE,
            types_1.Method.DELETE,
            types_1.Method.UPSERT,
            types_1.Method.LIST,
            types_1.Method.QUERY,
            types_1.Method.SEARCH,
            types_1.Method.BULK_CREATE,
            types_1.Method.BULK_UPDATE,
            types_1.Method.BULK_UPDATE_BY_FILTER,
            types_1.Method.BULK_DELETE,
            types_1.Method.BULK_DELETE_BY_FILTER,
            types_1.Method.BULK_UPSERT,
            types_1.Method.LIST_DELETED,
            types_1.Method.GET_DELETED,
            types_1.Method.RESTORE_FROM_TRASHBIN,
            types_1.Method.REMOVE_FROM_TRASHBIN,
            types_1.Method.COUNT,
        ]);
    };
    return MethodDTOBuilder;
}());
exports.MethodDTOBuilder = MethodDTOBuilder;
var MethodDescriptorProtoDTOBuilder = /** @class */ (function () {
    function MethodDescriptorProtoDTOBuilder() {
        this._clientStreaming = UnassignedValue;
        this._inputType = UnassignedValue;
        this._name = UnassignedValue;
        this._options = UnassignedValue;
        this._outputType = UnassignedValue;
        this._serverStreaming = UnassignedValue;
    }
    MethodDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.withInputType = function (_inputType) {
        this._inputType = _inputType;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.withOutputType = function (_outputType) {
        this._outputType = _outputType;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.withClientStreaming = function (_clientStreaming) {
        this._clientStreaming = _clientStreaming;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.withServerStreaming = function (_serverStreaming) {
        this._serverStreaming = _serverStreaming;
        return this;
    };
    MethodDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MethodDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            clientStreaming: this._clientStreaming !== UnassignedValue ? this._clientStreaming : maybe(someBoolean()),
            inputType: this._inputType !== UnassignedValue ? this._inputType : maybe(someString()),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.aMethodOptions().build({ buildersVisited: buildersVisited })),
            outputType: this._outputType !== UnassignedValue ? this._outputType : maybe(someString()),
            serverStreaming: this._serverStreaming !== UnassignedValue ? this._serverStreaming : maybe(someBoolean()),
        };
    };
    return MethodDescriptorProtoDTOBuilder;
}());
exports.MethodDescriptorProtoDTOBuilder = MethodDescriptorProtoDTOBuilder;
var MethodOptionsDTOBuilder = /** @class */ (function () {
    function MethodOptionsDTOBuilder() {
        this._deprecated = UnassignedValue;
        this._idempotencyLevel = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    MethodOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    MethodOptionsDTOBuilder.prototype.withIdempotencyLevel = function (_idempotencyLevel) {
        this._idempotencyLevel = _idempotencyLevel;
        return this;
    };
    MethodOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    MethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            idempotencyLevel: this._idempotencyLevel !== UnassignedValue ? this._idempotencyLevel : maybe(exports.anIdempotencyLevel().build({ buildersVisited: buildersVisited })),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return MethodOptionsDTOBuilder;
}());
exports.MethodOptionsDTOBuilder = MethodOptionsDTOBuilder;
var NamePartDTOBuilder = /** @class */ (function () {
    function NamePartDTOBuilder() {
        this._isExtension = UnassignedValue;
        this._namePart = UnassignedValue;
    }
    NamePartDTOBuilder.prototype.withNamePart = function (_namePart) {
        this._namePart = _namePart;
        return this;
    };
    NamePartDTOBuilder.prototype.withIsExtension = function (_isExtension) {
        this._isExtension = _isExtension;
        return this;
    };
    NamePartDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'NamePart', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            isExtension: this._isExtension !== UnassignedValue ? this._isExtension : maybe(someBoolean()),
            namePart: this._namePart !== UnassignedValue ? this._namePart : maybe(someString()),
        };
    };
    return NamePartDTOBuilder;
}());
exports.NamePartDTOBuilder = NamePartDTOBuilder;
var NullValueDTOBuilder = /** @class */ (function () {
    function NullValueDTOBuilder() {
    }
    NullValueDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.NullValue.NULL_VALUE]);
    };
    return NullValueDTOBuilder;
}());
exports.NullValueDTOBuilder = NullValueDTOBuilder;
var OfferDTOBuilder = /** @class */ (function () {
    function OfferDTOBuilder() {
        this._asset = UnassignedValue;
        this._campaignId = UnassignedValue;
        this._endDate = UnassignedValue;
        this._offerGuid = UnassignedValue;
        this._offerName = UnassignedValue;
        this._priorityMetadata = UnassignedValue;
        this._realEstateId = UnassignedValue;
        this._startDate = UnassignedValue;
    }
    OfferDTOBuilder.prototype.withOfferGuid = function (_offerGuid) {
        this._offerGuid = _offerGuid;
        return this;
    };
    OfferDTOBuilder.prototype.withRealEstateId = function (_realEstateId) {
        this._realEstateId = _realEstateId;
        return this;
    };
    OfferDTOBuilder.prototype.withOfferName = function (_offerName) {
        this._offerName = _offerName;
        return this;
    };
    OfferDTOBuilder.prototype.withAsset = function (_asset) {
        this._asset = _asset;
        return this;
    };
    OfferDTOBuilder.prototype.withCampaignId = function (_campaignId) {
        this._campaignId = _campaignId;
        return this;
    };
    OfferDTOBuilder.prototype.withStartDate = function (_startDate) {
        this._startDate = _startDate;
        return this;
    };
    OfferDTOBuilder.prototype.withEndDate = function (_endDate) {
        this._endDate = _endDate;
        return this;
    };
    OfferDTOBuilder.prototype.withPriorityMetadata = function (_priorityMetadata) {
        this._priorityMetadata = _priorityMetadata;
        return this;
    };
    OfferDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Offer', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            asset: this._asset !== UnassignedValue ? this._asset : maybe(exports.anAsset().build({ buildersVisited: buildersVisited })),
            campaignId: this._campaignId !== UnassignedValue ? this._campaignId : maybe(someString()),
            endDate: this._endDate !== UnassignedValue ? this._endDate : maybe(someDateString()),
            offerGuid: this._offerGuid !== UnassignedValue ? this._offerGuid : maybe(someGuid()),
            offerName: this._offerName !== UnassignedValue ? this._offerName : maybe(someString()),
            priorityMetadata: this._priorityMetadata !== UnassignedValue ? this._priorityMetadata : maybe(jsonMapOf(function () { return createNull(); })),
            realEstateId: this._realEstateId !== UnassignedValue ? this._realEstateId : maybe(someString()),
            startDate: this._startDate !== UnassignedValue ? this._startDate : maybe(someDateString()),
        };
    };
    return OfferDTOBuilder;
}());
exports.OfferDTOBuilder = OfferDTOBuilder;
var OffersConfigDTOBuilder = /** @class */ (function () {
    function OffersConfigDTOBuilder() {
        this._maximumLiveTime = UnassignedValue;
    }
    OffersConfigDTOBuilder.prototype.withMaximumLiveTime = function (_maximumLiveTime) {
        this._maximumLiveTime = _maximumLiveTime;
        return this;
    };
    OffersConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OffersConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            maximumLiveTime: this._maximumLiveTime !== UnassignedValue ? this._maximumLiveTime : maybe(exports.aDateUnit().build({ buildersVisited: buildersVisited })),
        };
    };
    return OffersConfigDTOBuilder;
}());
exports.OffersConfigDTOBuilder = OffersConfigDTOBuilder;
var OneofDescriptorProtoDTOBuilder = /** @class */ (function () {
    function OneofDescriptorProtoDTOBuilder() {
        this._name = UnassignedValue;
        this._options = UnassignedValue;
    }
    OneofDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    OneofDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    OneofDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OneofDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.anOneofOptions().build({ buildersVisited: buildersVisited })),
        };
    };
    return OneofDescriptorProtoDTOBuilder;
}());
exports.OneofDescriptorProtoDTOBuilder = OneofDescriptorProtoDTOBuilder;
var OneofOptionsDTOBuilder = /** @class */ (function () {
    function OneofOptionsDTOBuilder() {
        this._uninterpretedOption = UnassignedValue;
    }
    OneofOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    OneofOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OneofOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return OneofOptionsDTOBuilder;
}());
exports.OneofOptionsDTOBuilder = OneofOptionsDTOBuilder;
var OperatorFieldSupportDTOBuilder = /** @class */ (function () {
    function OperatorFieldSupportDTOBuilder() {
        this._field = UnassignedValue;
        this._glob = UnassignedValue;
        this._maturity = UnassignedValue;
        this._operator = UnassignedValue;
        this._requiredFields = UnassignedValue;
        this._sort = UnassignedValue;
    }
    OperatorFieldSupportDTOBuilder.prototype.withOperator = function (_operator) {
        this._operator = _operator;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.withGlob = function (_glob) {
        this._glob = _glob;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.withSort = function (_sort) {
        this._sort = _sort;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.withRequiredFields = function (_requiredFields) {
        this._requiredFields = _requiredFields;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.withMaturity = function (_maturity) {
        this._maturity = _maturity;
        return this;
    };
    OperatorFieldSupportDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OperatorFieldSupport', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return someString(); })),
            glob: this._glob !== UnassignedValue ? this._glob : maybe(someString()),
            maturity: this._maturity !== UnassignedValue ? this._maturity : maybe(exports.aMaturity().build({ buildersVisited: buildersVisited })),
            operator: this._operator !== UnassignedValue ? this._operator : maybe(manyOf(function () { return exports.aWqlOperator().build({ buildersVisited: buildersVisited }); })),
            requiredFields: this._requiredFields !== UnassignedValue ? this._requiredFields : maybe(manyOf(function () { return exports.aRequiredFields().build({ buildersVisited: buildersVisited }); })),
            sort: this._sort !== UnassignedValue ? this._sort : maybe(exports.aSort().build({ buildersVisited: buildersVisited })),
        };
    };
    return OperatorFieldSupportDTOBuilder;
}());
exports.OperatorFieldSupportDTOBuilder = OperatorFieldSupportDTOBuilder;
var OperatorValueTypeDTOBuilder = /** @class */ (function () {
    function OperatorValueTypeDTOBuilder() {
    }
    OperatorValueTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OperatorValueType', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return OperatorValueTypeDTOBuilder;
}());
exports.OperatorValueTypeDTOBuilder = OperatorValueTypeDTOBuilder;
var OperatorValueTypeEnumDTOBuilder = /** @class */ (function () {
    function OperatorValueTypeEnumDTOBuilder() {
    }
    OperatorValueTypeEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.OperatorValueTypeEnum.UNKNOWN,
            types_1.OperatorValueTypeEnum.NUMBER,
            types_1.OperatorValueTypeEnum.STRING,
            types_1.OperatorValueTypeEnum.LIST,
            types_1.OperatorValueTypeEnum.TIMESTAMP,
            types_1.OperatorValueTypeEnum.BOOLEAN,
        ]);
    };
    return OperatorValueTypeEnumDTOBuilder;
}());
exports.OperatorValueTypeEnumDTOBuilder = OperatorValueTypeEnumDTOBuilder;
var OptimizeModeDTOBuilder = /** @class */ (function () {
    function OptimizeModeDTOBuilder() {
    }
    OptimizeModeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.OptimizeMode.SPEED, types_1.OptimizeMode.CODE_SIZE, types_1.OptimizeMode.LITE_RUNTIME]);
    };
    return OptimizeModeDTOBuilder;
}());
exports.OptimizeModeDTOBuilder = OptimizeModeDTOBuilder;
var PagingDTOBuilder = /** @class */ (function () {
    function PagingDTOBuilder() {
        this._pagingMetadataField = UnassignedValue;
        this._type = UnassignedValue;
    }
    PagingDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    PagingDTOBuilder.prototype.withPagingMetadataField = function (_pagingMetadataField) {
        this._pagingMetadataField = _pagingMetadataField;
        return this;
    };
    PagingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Paging', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            pagingMetadataField: this._pagingMetadataField !== UnassignedValue ? this._pagingMetadataField : maybe(someString()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aPagingType().build({ buildersVisited: buildersVisited })),
        };
    };
    return PagingDTOBuilder;
}());
exports.PagingDTOBuilder = PagingDTOBuilder;
var PagingTypeDTOBuilder = /** @class */ (function () {
    function PagingTypeDTOBuilder() {
    }
    PagingTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PagingType.UNKNOWN_TYPE, types_1.PagingType.OFFSET, types_1.PagingType.CURSOR]);
    };
    return PagingTypeDTOBuilder;
}());
exports.PagingTypeDTOBuilder = PagingTypeDTOBuilder;
var ParentAccountDTOBuilder = /** @class */ (function () {
    function ParentAccountDTOBuilder() {
        this._parentAccountId = UnassignedValue;
    }
    ParentAccountDTOBuilder.prototype.withParentAccountId = function (_parentAccountId) {
        this._parentAccountId = _parentAccountId;
        return this;
    };
    ParentAccountDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ParentAccount', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            parentAccountId: this._parentAccountId !== UnassignedValue ? this._parentAccountId : maybe(someString()),
        };
    };
    return ParentAccountDTOBuilder;
}());
exports.ParentAccountDTOBuilder = ParentAccountDTOBuilder;
var PermissionRuleDTOBuilder = /** @class */ (function () {
    function PermissionRuleDTOBuilder() {
        this._name = UnassignedValue;
        this._type = UnassignedValue;
    }
    PermissionRuleDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    PermissionRuleDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    PermissionRuleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PermissionRule', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aPermissionType().build({ buildersVisited: buildersVisited })),
        };
    };
    return PermissionRuleDTOBuilder;
}());
exports.PermissionRuleDTOBuilder = PermissionRuleDTOBuilder;
var PermissionTypeDTOBuilder = /** @class */ (function () {
    function PermissionTypeDTOBuilder() {
    }
    PermissionTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PermissionType.AUTO, types_1.PermissionType.MANUAL]);
    };
    return PermissionTypeDTOBuilder;
}());
exports.PermissionTypeDTOBuilder = PermissionTypeDTOBuilder;
var PersonDTOBuilder = /** @class */ (function () {
    function PersonDTOBuilder() {
        this._hasUserRole = UnassignedValue;
        this._id = UnassignedValue;
        this._impersonatingUserId = UnassignedValue;
        this._isWixCs = UnassignedValue;
        this._isWixStaff = UnassignedValue;
        this._type = UnassignedValue;
        this._userAccountInfo = UnassignedValue;
    }
    PersonDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    PersonDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    PersonDTOBuilder.prototype.withHasUserRole = function (_hasUserRole) {
        this._hasUserRole = _hasUserRole;
        return this;
    };
    PersonDTOBuilder.prototype.withIsWixStaff = function (_isWixStaff) {
        this._isWixStaff = _isWixStaff;
        return this;
    };
    PersonDTOBuilder.prototype.withUserAccountInfo = function (_userAccountInfo) {
        this._userAccountInfo = _userAccountInfo;
        return this;
    };
    PersonDTOBuilder.prototype.withImpersonatingUserId = function (_impersonatingUserId) {
        this._impersonatingUserId = _impersonatingUserId;
        return this;
    };
    PersonDTOBuilder.prototype.withIsWixCs = function (_isWixCs) {
        this._isWixCs = _isWixCs;
        return this;
    };
    PersonDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Person', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            hasUserRole: this._hasUserRole !== UnassignedValue ? this._hasUserRole : maybe(someBoolean()),
            id: this._id !== UnassignedValue ? this._id : maybe(someString()),
            impersonatingUserId: this._impersonatingUserId !== UnassignedValue ? this._impersonatingUserId : maybe(someGuid()),
            isWixCs: this._isWixCs !== UnassignedValue ? this._isWixCs : maybe(someBoolean()),
            isWixStaff: this._isWixStaff !== UnassignedValue ? this._isWixStaff : maybe(someBoolean()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aPersonType().build({ buildersVisited: buildersVisited })),
            userAccountInfo: this._userAccountInfo !== UnassignedValue ? this._userAccountInfo : maybe(exports.anUserAccountInfo().build({ buildersVisited: buildersVisited })),
        };
    };
    return PersonDTOBuilder;
}());
exports.PersonDTOBuilder = PersonDTOBuilder;
var PersonTypeDTOBuilder = /** @class */ (function () {
    function PersonTypeDTOBuilder() {
    }
    PersonTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PersonType.USER, types_1.PersonType.SITEMEMBER, types_1.PersonType.VISITOR]);
    };
    return PersonTypeDTOBuilder;
}());
exports.PersonTypeDTOBuilder = PersonTypeDTOBuilder;
var PlacementDTOBuilder = /** @class */ (function () {
    function PlacementDTOBuilder() {
        this._assetType = UnassignedValue;
        this._availability = UnassignedValue;
        this._bestFor = UnassignedValue;
        this._createdBy = UnassignedValue;
        this._createdDate = UnassignedValue;
        this._description = UnassignedValue;
        this._frequencyCapsConfig = UnassignedValue;
        this._guid = UnassignedValue;
        this._guidelines = UnassignedValue;
        this._isCreativeV2OptIn = UnassignedValue;
        this._isTranslatable = UnassignedValue;
        this._level = UnassignedValue;
        this._localizationManagersIds = UnassignedValue;
        this._managersIds = UnassignedValue;
        this._name = UnassignedValue;
        this._offersConfig = UnassignedValue;
        this._parent = UnassignedValue;
        this._prioritizationStrategyConfig = UnassignedValue;
        this._schema = UnassignedValue;
        this._slug = UnassignedValue;
        this._status = UnassignedValue;
        this._updatedBy = UnassignedValue;
        this._updatedDate = UnassignedValue;
        this._url = UnassignedValue;
    }
    PlacementDTOBuilder.prototype.withGuid = function (_guid) {
        this._guid = _guid;
        return this;
    };
    PlacementDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    PlacementDTOBuilder.prototype.withParent = function (_parent) {
        this._parent = _parent;
        return this;
    };
    PlacementDTOBuilder.prototype.withAssetType = function (_assetType) {
        this._assetType = _assetType;
        return this;
    };
    PlacementDTOBuilder.prototype.withDescription = function (_description) {
        this._description = _description;
        return this;
    };
    PlacementDTOBuilder.prototype.withBestFor = function (_bestFor) {
        this._bestFor = _bestFor;
        return this;
    };
    PlacementDTOBuilder.prototype.withCreatedBy = function (_createdBy) {
        this._createdBy = _createdBy;
        return this;
    };
    PlacementDTOBuilder.prototype.withUpdatedBy = function (_updatedBy) {
        this._updatedBy = _updatedBy;
        return this;
    };
    PlacementDTOBuilder.prototype.withCreatedDate = function (_createdDate) {
        this._createdDate = _createdDate;
        return this;
    };
    PlacementDTOBuilder.prototype.withUpdatedDate = function (_updatedDate) {
        this._updatedDate = _updatedDate;
        return this;
    };
    PlacementDTOBuilder.prototype.withUrl = function (_url) {
        this._url = _url;
        return this;
    };
    PlacementDTOBuilder.prototype.withGuidelines = function (_guidelines) {
        this._guidelines = _guidelines;
        return this;
    };
    PlacementDTOBuilder.prototype.withAvailability = function (_availability) {
        this._availability = _availability;
        return this;
    };
    PlacementDTOBuilder.prototype.withSlug = function (_slug) {
        this._slug = _slug;
        return this;
    };
    PlacementDTOBuilder.prototype.withFrequencyCapsConfig = function (_frequencyCapsConfig) {
        this._frequencyCapsConfig = _frequencyCapsConfig;
        return this;
    };
    PlacementDTOBuilder.prototype.withManagersIds = function (_managersIds) {
        this._managersIds = _managersIds;
        return this;
    };
    PlacementDTOBuilder.prototype.withSchema = function (_schema) {
        this._schema = _schema;
        return this;
    };
    PlacementDTOBuilder.prototype.withLevel = function (_level) {
        this._level = _level;
        return this;
    };
    PlacementDTOBuilder.prototype.withIsCreativeV2OptIn = function (_isCreativeV2OptIn) {
        this._isCreativeV2OptIn = _isCreativeV2OptIn;
        return this;
    };
    PlacementDTOBuilder.prototype.withLocalizationManagersIds = function (_localizationManagersIds) {
        this._localizationManagersIds = _localizationManagersIds;
        return this;
    };
    PlacementDTOBuilder.prototype.withIsTranslatable = function (_isTranslatable) {
        this._isTranslatable = _isTranslatable;
        return this;
    };
    PlacementDTOBuilder.prototype.withStatus = function (_status) {
        this._status = _status;
        return this;
    };
    PlacementDTOBuilder.prototype.withPrioritizationStrategyConfig = function (_prioritizationStrategyConfig) {
        this._prioritizationStrategyConfig = _prioritizationStrategyConfig;
        return this;
    };
    PlacementDTOBuilder.prototype.withOffersConfig = function (_offersConfig) {
        this._offersConfig = _offersConfig;
        return this;
    };
    PlacementDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Placement', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            assetType: this._assetType !== UnassignedValue ? this._assetType : maybe(boundedString(1, 32)),
            availability: this._availability !== UnassignedValue ? this._availability : maybe(someString()),
            bestFor: this._bestFor !== UnassignedValue ? this._bestFor : maybe(someString()),
            createdBy: this._createdBy !== UnassignedValue ? this._createdBy : maybe(someGuid()),
            createdDate: this._createdDate !== UnassignedValue ? this._createdDate : maybe(someDateString()),
            description: this._description !== UnassignedValue ? this._description : maybe(someString()),
            frequencyCapsConfig: this._frequencyCapsConfig !== UnassignedValue ? this._frequencyCapsConfig : maybe(exports.aFrequencyCapsConfig().build({ buildersVisited: buildersVisited })),
            guid: this._guid !== UnassignedValue ? this._guid : maybe(someGuid()),
            guidelines: this._guidelines !== UnassignedValue ? this._guidelines : maybe(someString()),
            isCreativeV2OptIn: this._isCreativeV2OptIn !== UnassignedValue ? this._isCreativeV2OptIn : maybe(someBoolean()),
            isTranslatable: this._isTranslatable !== UnassignedValue ? this._isTranslatable : maybe(someBoolean()),
            level: this._level !== UnassignedValue ? this._level : maybe(exports.aLevel().build({ buildersVisited: buildersVisited })),
            localizationManagersIds: this._localizationManagersIds !== UnassignedValue ? this._localizationManagersIds : maybe(exports.aManagerLocalizationIdsWrapper().build({ buildersVisited: buildersVisited })),
            managersIds: this._managersIds !== UnassignedValue ? this._managersIds : maybe(exports.aManagerIdsWrapper().build({ buildersVisited: buildersVisited })),
            name: this._name !== UnassignedValue ? this._name : maybe(boundedString(1, 32)),
            offersConfig: this._offersConfig !== UnassignedValue ? this._offersConfig : maybe(exports.anOffersConfig().build({ buildersVisited: buildersVisited })),
            parent: this._parent !== UnassignedValue ? this._parent : maybe(boundedString(1, 32)),
            prioritizationStrategyConfig: this._prioritizationStrategyConfig !== UnassignedValue ? this._prioritizationStrategyConfig : maybe(exports.aPrioritizationStrategyConfig().build({ buildersVisited: buildersVisited })),
            schema: this._schema !== UnassignedValue ? this._schema : maybe(exports.aSchema().build({ buildersVisited: buildersVisited })),
            slug: this._slug !== UnassignedValue ? this._slug : maybe(boundedString(1, 32)),
            status: this._status !== UnassignedValue ? this._status : maybe(exports.aPlacementStatus().build({ buildersVisited: buildersVisited })),
            updatedBy: this._updatedBy !== UnassignedValue ? this._updatedBy : maybe(someGuid()),
            updatedDate: this._updatedDate !== UnassignedValue ? this._updatedDate : maybe(someDateString()),
            url: this._url !== UnassignedValue ? this._url : maybe(someString()),
        };
    };
    return PlacementDTOBuilder;
}());
exports.PlacementDTOBuilder = PlacementDTOBuilder;
var PlacementStatusDTOBuilder = /** @class */ (function () {
    function PlacementStatusDTOBuilder() {
    }
    PlacementStatusDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PlacementStatus.UNKNOWN, types_1.PlacementStatus.ACTIVE, types_1.PlacementStatus.CREATIVE_READ_ONLY, types_1.PlacementStatus.ARCHIVED, types_1.PlacementStatus.DRAFT]);
    };
    return PlacementStatusDTOBuilder;
}());
exports.PlacementStatusDTOBuilder = PlacementStatusDTOBuilder;
var PlanDTOBuilder = /** @class */ (function () {
    function PlanDTOBuilder() {
    }
    PlanDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Plan.UNKNOWN, types_1.Plan.PREMIUM, types_1.Plan.NONE]);
    };
    return PlanDTOBuilder;
}());
exports.PlanDTOBuilder = PlanDTOBuilder;
var PremiumAccountCriteriaDTOBuilder = /** @class */ (function () {
    function PremiumAccountCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    PremiumAccountCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    PremiumAccountCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumAccountCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aPremiumAccountCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return PremiumAccountCriteriaDTOBuilder;
}());
exports.PremiumAccountCriteriaDTOBuilder = PremiumAccountCriteriaDTOBuilder;
var PremiumAccountCriteriaEnumDTOBuilder = /** @class */ (function () {
    function PremiumAccountCriteriaEnumDTOBuilder() {
    }
    PremiumAccountCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PremiumAccountCriteriaEnum.UNKNOWN, types_1.PremiumAccountCriteriaEnum.IS_PREMIUM, types_1.PremiumAccountCriteriaEnum.IS_NOT_PREMIUM]);
    };
    return PremiumAccountCriteriaEnumDTOBuilder;
}());
exports.PremiumAccountCriteriaEnumDTOBuilder = PremiumAccountCriteriaEnumDTOBuilder;
var PremiumLandingTabCriteriaDTOBuilder = /** @class */ (function () {
    function PremiumLandingTabCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    PremiumLandingTabCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    PremiumLandingTabCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumLandingTabCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.aPremiumLandingTabCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return PremiumLandingTabCriteriaDTOBuilder;
}());
exports.PremiumLandingTabCriteriaDTOBuilder = PremiumLandingTabCriteriaDTOBuilder;
var PremiumLandingTabCriteriaEnumDTOBuilder = /** @class */ (function () {
    function PremiumLandingTabCriteriaEnumDTOBuilder() {
    }
    PremiumLandingTabCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PremiumLandingTabCriteriaEnum.UNKNOWN, types_1.PremiumLandingTabCriteriaEnum.WEBSITE, types_1.PremiumLandingTabCriteriaEnum.BUSINESS]);
    };
    return PremiumLandingTabCriteriaEnumDTOBuilder;
}());
exports.PremiumLandingTabCriteriaEnumDTOBuilder = PremiumLandingTabCriteriaEnumDTOBuilder;
var PremiumPlanCriteriaDTOBuilder = /** @class */ (function () {
    function PremiumPlanCriteriaDTOBuilder() {
        this._plan = UnassignedValue;
        this._products = UnassignedValue;
    }
    PremiumPlanCriteriaDTOBuilder.prototype.withProducts = function (_products) {
        this._products = _products;
        return this;
    };
    PremiumPlanCriteriaDTOBuilder.prototype.withPlan = function (_plan) {
        this._plan = _plan;
        return this;
    };
    PremiumPlanCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumPlanCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            plan: this._plan !== UnassignedValue ? this._plan : maybe(exports.aPlan().build({ buildersVisited: buildersVisited })),
            products: this._products !== UnassignedValue ? this._products : maybe(manyOf(function () { return someInt(); })),
        };
    };
    return PremiumPlanCriteriaDTOBuilder;
}());
exports.PremiumPlanCriteriaDTOBuilder = PremiumPlanCriteriaDTOBuilder;
var PrioritizationABTestStrategiesDTOBuilder = /** @class */ (function () {
    function PrioritizationABTestStrategiesDTOBuilder() {
        this._paramsA = UnassignedValue;
        this._paramsB = UnassignedValue;
        this._specName = UnassignedValue;
    }
    PrioritizationABTestStrategiesDTOBuilder.prototype.withSpecName = function (_specName) {
        this._specName = _specName;
        return this;
    };
    PrioritizationABTestStrategiesDTOBuilder.prototype.withParamsA = function (_paramsA) {
        this._paramsA = _paramsA;
        return this;
    };
    PrioritizationABTestStrategiesDTOBuilder.prototype.withParamsB = function (_paramsB) {
        this._paramsB = _paramsB;
        return this;
    };
    PrioritizationABTestStrategiesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PrioritizationABTestStrategies', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            paramsA: this._paramsA !== UnassignedValue ? this._paramsA : maybe(exports.aPrioritizationStrategyParams().build({ buildersVisited: buildersVisited })),
            paramsB: this._paramsB !== UnassignedValue ? this._paramsB : maybe(exports.aPrioritizationStrategyParams().build({ buildersVisited: buildersVisited })),
            specName: this._specName !== UnassignedValue ? this._specName : maybe(boundedString(1, 100)),
        };
    };
    return PrioritizationABTestStrategiesDTOBuilder;
}());
exports.PrioritizationABTestStrategiesDTOBuilder = PrioritizationABTestStrategiesDTOBuilder;
var PrioritizationStrategyDTOBuilder = /** @class */ (function () {
    function PrioritizationStrategyDTOBuilder() {
    }
    PrioritizationStrategyDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.PrioritizationStrategy.UNKNOWN,
            types_1.PrioritizationStrategy.MANUAL,
            types_1.PrioritizationStrategy.CTR,
            types_1.PrioritizationStrategy.RANDOM,
            types_1.PrioritizationStrategy.ABCTR,
            types_1.PrioritizationStrategy.PremiumCTR,
            types_1.PrioritizationStrategy.MLModel,
            types_1.PrioritizationStrategy.LLMModel,
            types_1.PrioritizationStrategy.WHATS_NEXT,
            types_1.PrioritizationStrategy.ADVICES,
        ]);
    };
    return PrioritizationStrategyDTOBuilder;
}());
exports.PrioritizationStrategyDTOBuilder = PrioritizationStrategyDTOBuilder;
var PrioritizationStrategyConfigDTOBuilder = /** @class */ (function () {
    function PrioritizationStrategyConfigDTOBuilder() {
        this._abTestStrategies = UnassignedValue;
        this._defaultParams = UnassignedValue;
        this._shadowedStrategy = UnassignedValue;
    }
    PrioritizationStrategyConfigDTOBuilder.prototype.withDefaultParams = function (_defaultParams) {
        this._defaultParams = _defaultParams;
        this._abTestStrategies = UnassignedValue;
        this._shadowedStrategy = UnassignedValue;
        return this;
    };
    PrioritizationStrategyConfigDTOBuilder.prototype.withAbTestStrategies = function (_abTestStrategies) {
        this._abTestStrategies = _abTestStrategies;
        this._defaultParams = UnassignedValue;
        this._shadowedStrategy = UnassignedValue;
        return this;
    };
    PrioritizationStrategyConfigDTOBuilder.prototype.withShadowedStrategy = function (_shadowedStrategy) {
        this._shadowedStrategy = _shadowedStrategy;
        this._defaultParams = UnassignedValue;
        this._abTestStrategies = UnassignedValue;
        return this;
    };
    PrioritizationStrategyConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PrioritizationStrategyConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._defaultParams === UnassignedValue && this._abTestStrategies === UnassignedValue && this._shadowedStrategy === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['defaultParams', 'abTestStrategies', 'shadowedStrategy'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 3), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                abTestStrategies: assignRandomOneOf('abTestStrategies', maybe(exports.aPrioritizationABTestStrategies().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                defaultParams: assignRandomOneOf('defaultParams', maybe(exports.aPrioritizationStrategyParams().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                shadowedStrategy: assignRandomOneOf('shadowedStrategy', maybe(exports.aShadowedStrategy().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            abTestStrategies: this._abTestStrategies === UnassignedValue ? undefined : this._abTestStrategies,
            defaultParams: this._defaultParams === UnassignedValue ? undefined : this._defaultParams,
            shadowedStrategy: this._shadowedStrategy === UnassignedValue ? undefined : this._shadowedStrategy,
        };
    };
    return PrioritizationStrategyConfigDTOBuilder;
}());
exports.PrioritizationStrategyConfigDTOBuilder = PrioritizationStrategyConfigDTOBuilder;
var PrioritizationStrategyOverridesDTOBuilder = /** @class */ (function () {
    function PrioritizationStrategyOverridesDTOBuilder() {
        this._prioritizationStrategyConfig = UnassignedValue;
    }
    PrioritizationStrategyOverridesDTOBuilder.prototype.withPrioritizationStrategyConfig = function (_prioritizationStrategyConfig) {
        this._prioritizationStrategyConfig = _prioritizationStrategyConfig;
        return this;
    };
    PrioritizationStrategyOverridesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PrioritizationStrategyOverrides', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            prioritizationStrategyConfig: this._prioritizationStrategyConfig !== UnassignedValue ? this._prioritizationStrategyConfig : maybe(exports.aPrioritizationStrategyConfig().build({ buildersVisited: buildersVisited })),
        };
    };
    return PrioritizationStrategyOverridesDTOBuilder;
}());
exports.PrioritizationStrategyOverridesDTOBuilder = PrioritizationStrategyOverridesDTOBuilder;
var PrioritizationStrategyParamsDTOBuilder = /** @class */ (function () {
    function PrioritizationStrategyParamsDTOBuilder() {
        this._abCtrConfig = UnassignedValue;
        this._advicesConfig = UnassignedValue;
        this._fixedItems = UnassignedValue;
        this._learningAllocation = UnassignedValue;
        this._strategy = UnassignedValue;
        this._whatsNextConfig = UnassignedValue;
    }
    PrioritizationStrategyParamsDTOBuilder.prototype.withStrategy = function (_strategy) {
        this._strategy = _strategy;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.withLearningAllocation = function (_learningAllocation) {
        this._learningAllocation = _learningAllocation;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.withFixedItems = function (_fixedItems) {
        this._fixedItems = _fixedItems;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.withAbCtrConfig = function (_abCtrConfig) {
        this._abCtrConfig = _abCtrConfig;
        this._whatsNextConfig = UnassignedValue;
        this._advicesConfig = UnassignedValue;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.withWhatsNextConfig = function (_whatsNextConfig) {
        this._whatsNextConfig = _whatsNextConfig;
        this._abCtrConfig = UnassignedValue;
        this._advicesConfig = UnassignedValue;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.withAdvicesConfig = function (_advicesConfig) {
        this._advicesConfig = _advicesConfig;
        this._abCtrConfig = UnassignedValue;
        this._whatsNextConfig = UnassignedValue;
        return this;
    };
    PrioritizationStrategyParamsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PrioritizationStrategyParams', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._abCtrConfig === UnassignedValue && this._whatsNextConfig === UnassignedValue && this._advicesConfig === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['abCtrConfig', 'whatsNextConfig', 'advicesConfig'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 3), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                abCtrConfig: assignRandomOneOf('abCtrConfig', maybe(exports.anABCTRConfig().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                advicesConfig: assignRandomOneOf('advicesConfig', maybe(exports.anAdvicesConfig().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                fixedItems: this._fixedItems !== UnassignedValue ? this._fixedItems : maybe(manyOf(function () { return exports.aFixedItem().build({ buildersVisited: buildersVisited }); })),
                learningAllocation: this._learningAllocation !== UnassignedValue ? this._learningAllocation : maybe(someString()),
                strategy: this._strategy !== UnassignedValue ? this._strategy : maybe(exports.aPrioritizationStrategy().build({ buildersVisited: buildersVisited })),
                whatsNextConfig: assignRandomOneOf('whatsNextConfig', maybe(exports.aWHATSNEXTConfig().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            abCtrConfig: this._abCtrConfig === UnassignedValue ? undefined : this._abCtrConfig,
            advicesConfig: this._advicesConfig === UnassignedValue ? undefined : this._advicesConfig,
            fixedItems: this._fixedItems !== UnassignedValue ? this._fixedItems : maybe(manyOf(function () { return exports.aFixedItem().build({ buildersVisited: buildersVisited }); })),
            learningAllocation: this._learningAllocation !== UnassignedValue ? this._learningAllocation : maybe(someString()),
            strategy: this._strategy !== UnassignedValue ? this._strategy : maybe(exports.aPrioritizationStrategy().build({ buildersVisited: buildersVisited })),
            whatsNextConfig: this._whatsNextConfig === UnassignedValue ? undefined : this._whatsNextConfig,
        };
    };
    return PrioritizationStrategyParamsDTOBuilder;
}());
exports.PrioritizationStrategyParamsDTOBuilder = PrioritizationStrategyParamsDTOBuilder;
var PriorityItemDTOBuilder = /** @class */ (function () {
    function PriorityItemDTOBuilder() {
        this._itemId = UnassignedValue;
        this._weight = UnassignedValue;
    }
    PriorityItemDTOBuilder.prototype.withItemId = function (_itemId) {
        this._itemId = _itemId;
        return this;
    };
    PriorityItemDTOBuilder.prototype.withWeight = function (_weight) {
        this._weight = _weight;
        return this;
    };
    PriorityItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PriorityItem', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemId: this._itemId !== UnassignedValue ? this._itemId : maybe(someGuid()),
            weight: this._weight !== UnassignedValue ? this._weight : maybe(someInt()),
        };
    };
    return PriorityItemDTOBuilder;
}());
exports.PriorityItemDTOBuilder = PriorityItemDTOBuilder;
var PublishErrorsDTOBuilder = /** @class */ (function () {
    function PublishErrorsDTOBuilder() {
        this._description = UnassignedValue;
        this._field = UnassignedValue;
    }
    PublishErrorsDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    PublishErrorsDTOBuilder.prototype.withDescription = function (_description) {
        this._description = _description;
        return this;
    };
    PublishErrorsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PublishErrors', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            description: this._description !== UnassignedValue ? this._description : maybe(someString()),
            field: this._field !== UnassignedValue ? this._field : maybe(someString()),
        };
    };
    return PublishErrorsDTOBuilder;
}());
exports.PublishErrorsDTOBuilder = PublishErrorsDTOBuilder;
var PublishPlacementRequestDTOBuilder = /** @class */ (function () {
    function PublishPlacementRequestDTOBuilder() {
        this._placementGuid = UnassignedValue;
    }
    PublishPlacementRequestDTOBuilder.prototype.withPlacementGuid = function (_placementGuid) {
        this._placementGuid = _placementGuid;
        return this;
    };
    PublishPlacementRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PublishPlacementRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placementGuid: this._placementGuid !== UnassignedValue ? this._placementGuid : maybe(someGuid()),
        };
    };
    return PublishPlacementRequestDTOBuilder;
}());
exports.PublishPlacementRequestDTOBuilder = PublishPlacementRequestDTOBuilder;
var PublishPlacementResponseDTOBuilder = /** @class */ (function () {
    function PublishPlacementResponseDTOBuilder() {
        this._errors = UnassignedValue;
        this._status = UnassignedValue;
    }
    PublishPlacementResponseDTOBuilder.prototype.withStatus = function (_status) {
        this._status = _status;
        return this;
    };
    PublishPlacementResponseDTOBuilder.prototype.withErrors = function (_errors) {
        this._errors = _errors;
        return this;
    };
    PublishPlacementResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PublishPlacementResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            errors: this._errors !== UnassignedValue ? this._errors : maybe(manyOf(function () { return exports.aPublishErrors().build({ buildersVisited: buildersVisited }); })),
            status: this._status !== UnassignedValue ? this._status : maybe(exports.aPublishStatus().build({ buildersVisited: buildersVisited })),
        };
    };
    return PublishPlacementResponseDTOBuilder;
}());
exports.PublishPlacementResponseDTOBuilder = PublishPlacementResponseDTOBuilder;
var PublishStatusDTOBuilder = /** @class */ (function () {
    function PublishStatusDTOBuilder() {
    }
    PublishStatusDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PublishStatus.UNKNOWN, types_1.PublishStatus.OK, types_1.PublishStatus.FAILED]);
    };
    return PublishStatusDTOBuilder;
}());
exports.PublishStatusDTOBuilder = PublishStatusDTOBuilder;
var QueryMethodOptionsDTOBuilder = /** @class */ (function () {
    function QueryMethodOptionsDTOBuilder() {
        this._itemsField = UnassignedValue;
        this._meAliasableField = UnassignedValue;
        this._paging = UnassignedValue;
        this._queryField = UnassignedValue;
        this._wql = UnassignedValue;
    }
    QueryMethodOptionsDTOBuilder.prototype.withQueryField = function (_queryField) {
        this._queryField = _queryField;
        return this;
    };
    QueryMethodOptionsDTOBuilder.prototype.withItemsField = function (_itemsField) {
        this._itemsField = _itemsField;
        return this;
    };
    QueryMethodOptionsDTOBuilder.prototype.withPaging = function (_paging) {
        this._paging = _paging;
        return this;
    };
    QueryMethodOptionsDTOBuilder.prototype.withWql = function (_wql) {
        this._wql = _wql;
        return this;
    };
    QueryMethodOptionsDTOBuilder.prototype.withMeAliasableField = function (_meAliasableField) {
        this._meAliasableField = _meAliasableField;
        return this;
    };
    QueryMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'QueryMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemsField: this._itemsField !== UnassignedValue ? this._itemsField : maybe(someString()),
            meAliasableField: this._meAliasableField !== UnassignedValue ? this._meAliasableField : maybe(manyOf(function () { return someString(); })),
            paging: this._paging !== UnassignedValue ? this._paging : maybe(exports.aPaging().build({ buildersVisited: buildersVisited })),
            queryField: this._queryField !== UnassignedValue ? this._queryField : maybe(someString()),
            wql: this._wql !== UnassignedValue ? this._wql : maybe(exports.aWql().build({ buildersVisited: buildersVisited })),
        };
    };
    return QueryMethodOptionsDTOBuilder;
}());
exports.QueryMethodOptionsDTOBuilder = QueryMethodOptionsDTOBuilder;
var ReferenceEntityFieldDTOBuilder = /** @class */ (function () {
    function ReferenceEntityFieldDTOBuilder() {
        this._path = UnassignedValue;
    }
    ReferenceEntityFieldDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    ReferenceEntityFieldDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ReferenceEntityField', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            path: this._path !== UnassignedValue ? this._path : maybe(someString()),
        };
    };
    return ReferenceEntityFieldDTOBuilder;
}());
exports.ReferenceEntityFieldDTOBuilder = ReferenceEntityFieldDTOBuilder;
var RefreshIdentityRequestDTOBuilder = /** @class */ (function () {
    function RefreshIdentityRequestDTOBuilder() {
        this._signedToken = UnassignedValue;
    }
    RefreshIdentityRequestDTOBuilder.prototype.withSignedToken = function (_signedToken) {
        this._signedToken = _signedToken;
        return this;
    };
    RefreshIdentityRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RefreshIdentityRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            signedToken: this._signedToken !== UnassignedValue ? this._signedToken : maybe(someString()),
        };
    };
    return RefreshIdentityRequestDTOBuilder;
}());
exports.RefreshIdentityRequestDTOBuilder = RefreshIdentityRequestDTOBuilder;
var RefreshIdentityResponseDTOBuilder = /** @class */ (function () {
    function RefreshIdentityResponseDTOBuilder() {
        this._identificationData = UnassignedValue;
        this._signedToken = UnassignedValue;
    }
    RefreshIdentityResponseDTOBuilder.prototype.withIdentificationData = function (_identificationData) {
        this._identificationData = _identificationData;
        return this;
    };
    RefreshIdentityResponseDTOBuilder.prototype.withSignedToken = function (_signedToken) {
        this._signedToken = _signedToken;
        return this;
    };
    RefreshIdentityResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RefreshIdentityResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            identificationData: this._identificationData !== UnassignedValue ? this._identificationData : maybe(exports.anIdentificationData().build({ buildersVisited: buildersVisited })),
            signedToken: this._signedToken !== UnassignedValue ? this._signedToken : maybe(someString()),
        };
    };
    return RefreshIdentityResponseDTOBuilder;
}());
exports.RefreshIdentityResponseDTOBuilder = RefreshIdentityResponseDTOBuilder;
var ReleaseAudienceDTOBuilder = /** @class */ (function () {
    function ReleaseAudienceDTOBuilder() {
        this._experimentExecutionResult = UnassignedValue;
        this._experimentKey = UnassignedValue;
        this._experimentValue = UnassignedValue;
        this._releaseExecutionResult = UnassignedValue;
        this._releaseStatus = UnassignedValue;
        this._timeExecutionResult = UnassignedValue;
        this._timeStart = UnassignedValue;
        this._timeStop = UnassignedValue;
    }
    ReleaseAudienceDTOBuilder.prototype.withReleaseStatus = function (_releaseStatus) {
        this._releaseStatus = _releaseStatus;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withReleaseExecutionResult = function (_releaseExecutionResult) {
        this._releaseExecutionResult = _releaseExecutionResult;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withTimeStart = function (_timeStart) {
        this._timeStart = _timeStart;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withTimeStop = function (_timeStop) {
        this._timeStop = _timeStop;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withTimeExecutionResult = function (_timeExecutionResult) {
        this._timeExecutionResult = _timeExecutionResult;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withExperimentKey = function (_experimentKey) {
        this._experimentKey = _experimentKey;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withExperimentValue = function (_experimentValue) {
        this._experimentValue = _experimentValue;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.withExperimentExecutionResult = function (_experimentExecutionResult) {
        this._experimentExecutionResult = _experimentExecutionResult;
        return this;
    };
    ReleaseAudienceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ReleaseAudience', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            experimentExecutionResult: this._experimentExecutionResult !== UnassignedValue ? this._experimentExecutionResult : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            experimentKey: this._experimentKey !== UnassignedValue ? this._experimentKey : maybe(someString()),
            experimentValue: this._experimentValue !== UnassignedValue ? this._experimentValue : maybe(someString()),
            releaseExecutionResult: this._releaseExecutionResult !== UnassignedValue ? this._releaseExecutionResult : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            releaseStatus: this._releaseStatus !== UnassignedValue ? this._releaseStatus : maybe(exports.aReleaseAudienceStatus().build({ buildersVisited: buildersVisited })),
            timeExecutionResult: this._timeExecutionResult !== UnassignedValue ? this._timeExecutionResult : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            timeStart: this._timeStart !== UnassignedValue ? this._timeStart : maybe(someDateString()),
            timeStop: this._timeStop !== UnassignedValue ? this._timeStop : maybe(someDateString()),
        };
    };
    return ReleaseAudienceDTOBuilder;
}());
exports.ReleaseAudienceDTOBuilder = ReleaseAudienceDTOBuilder;
var ReleaseAudienceStatusDTOBuilder = /** @class */ (function () {
    function ReleaseAudienceStatusDTOBuilder() {
    }
    ReleaseAudienceStatusDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.ReleaseAudienceStatus.UNKNOWN, types_1.ReleaseAudienceStatus.ALL, types_1.ReleaseAudienceStatus.WIX_EMPLOYEE]);
    };
    return ReleaseAudienceStatusDTOBuilder;
}());
exports.ReleaseAudienceStatusDTOBuilder = ReleaseAudienceStatusDTOBuilder;
var RemoveFromTrashbinMethodOptionsDTOBuilder = /** @class */ (function () {
    function RemoveFromTrashbinMethodOptionsDTOBuilder() {
        this._idField = UnassignedValue;
    }
    RemoveFromTrashbinMethodOptionsDTOBuilder.prototype.withIdField = function (_idField) {
        this._idField = _idField;
        return this;
    };
    RemoveFromTrashbinMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RemoveFromTrashbinMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idField: this._idField !== UnassignedValue ? this._idField : maybe(someString()),
        };
    };
    return RemoveFromTrashbinMethodOptionsDTOBuilder;
}());
exports.RemoveFromTrashbinMethodOptionsDTOBuilder = RemoveFromTrashbinMethodOptionsDTOBuilder;
var RequestContextDTOBuilder = /** @class */ (function () {
    function RequestContextDTOBuilder() {
        this._brand = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._loggedInAccountId = UnassignedValue;
        this._siteId = UnassignedValue;
        this._targetAccountId = UnassignedValue;
        this._userId = UnassignedValue;
    }
    RequestContextDTOBuilder.prototype.withUserId = function (_userId) {
        this._userId = _userId;
        return this;
    };
    RequestContextDTOBuilder.prototype.withTargetAccountId = function (_targetAccountId) {
        this._targetAccountId = _targetAccountId;
        return this;
    };
    RequestContextDTOBuilder.prototype.withLoggedInAccountId = function (_loggedInAccountId) {
        this._loggedInAccountId = _loggedInAccountId;
        return this;
    };
    RequestContextDTOBuilder.prototype.withSiteId = function (_siteId) {
        this._siteId = _siteId;
        return this;
    };
    RequestContextDTOBuilder.prototype.withGeo = function (_geo) {
        this._geo = _geo;
        return this;
    };
    RequestContextDTOBuilder.prototype.withLanguage = function (_language) {
        this._language = _language;
        return this;
    };
    RequestContextDTOBuilder.prototype.withBrand = function (_brand) {
        this._brand = _brand;
        return this;
    };
    RequestContextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequestContext', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            brand: this._brand !== UnassignedValue ? this._brand : maybe(exports.aBrand().build({ buildersVisited: buildersVisited })),
            geo: this._geo !== UnassignedValue ? this._geo : maybe(someString()),
            language: this._language !== UnassignedValue ? this._language : maybe(someString()),
            loggedInAccountId: this._loggedInAccountId !== UnassignedValue ? this._loggedInAccountId : maybe(someGuid()),
            siteId: this._siteId !== UnassignedValue ? this._siteId : maybe(someGuid()),
            targetAccountId: this._targetAccountId !== UnassignedValue ? this._targetAccountId : maybe(someGuid()),
            userId: this._userId !== UnassignedValue ? this._userId : maybe(someGuid()),
        };
    };
    return RequestContextDTOBuilder;
}());
exports.RequestContextDTOBuilder = RequestContextDTOBuilder;
var RequestExtensionsDTOBuilder = /** @class */ (function () {
    function RequestExtensionsDTOBuilder() {
        this._siteId = UnassignedValue;
    }
    RequestExtensionsDTOBuilder.prototype.withSiteId = function (_siteId) {
        this._siteId = _siteId;
        return this;
    };
    RequestExtensionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequestExtensions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            siteId: this._siteId !== UnassignedValue ? this._siteId : maybe(someGuid()),
        };
    };
    return RequestExtensionsDTOBuilder;
}());
exports.RequestExtensionsDTOBuilder = RequestExtensionsDTOBuilder;
var RequiredFieldDTOBuilder = /** @class */ (function () {
    function RequiredFieldDTOBuilder() {
        this._path = UnassignedValue;
        this._sort = UnassignedValue;
    }
    RequiredFieldDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    RequiredFieldDTOBuilder.prototype.withSort = function (_sort) {
        this._sort = _sort;
        return this;
    };
    RequiredFieldDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequiredField', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            path: this._path !== UnassignedValue ? this._path : maybe(someString()),
            sort: this._sort !== UnassignedValue ? this._sort : maybe(exports.aSort().build({ buildersVisited: buildersVisited })),
        };
    };
    return RequiredFieldDTOBuilder;
}());
exports.RequiredFieldDTOBuilder = RequiredFieldDTOBuilder;
var RequiredFieldsDTOBuilder = /** @class */ (function () {
    function RequiredFieldsDTOBuilder() {
        this._field = UnassignedValue;
        this._requiredField = UnassignedValue;
    }
    RequiredFieldsDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    RequiredFieldsDTOBuilder.prototype.withRequiredField = function (_requiredField) {
        this._requiredField = _requiredField;
        return this;
    };
    RequiredFieldsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequiredFields', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return someString(); })),
            requiredField: this._requiredField !== UnassignedValue ? this._requiredField : maybe(manyOf(function () { return exports.aRequiredField().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return RequiredFieldsDTOBuilder;
}());
exports.RequiredFieldsDTOBuilder = RequiredFieldsDTOBuilder;
var ReservedRangeDTOBuilder = /** @class */ (function () {
    function ReservedRangeDTOBuilder() {
        this._end = UnassignedValue;
        this._start = UnassignedValue;
    }
    ReservedRangeDTOBuilder.prototype.withStart = function (_start) {
        this._start = _start;
        return this;
    };
    ReservedRangeDTOBuilder.prototype.withEnd = function (_end) {
        this._end = _end;
        return this;
    };
    ReservedRangeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ReservedRange', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            end: this._end !== UnassignedValue ? this._end : maybe(someInt()),
            start: this._start !== UnassignedValue ? this._start : maybe(someInt()),
        };
    };
    return ReservedRangeDTOBuilder;
}());
exports.ReservedRangeDTOBuilder = ReservedRangeDTOBuilder;
var ResolveOfferRequestDTOBuilder = /** @class */ (function () {
    function ResolveOfferRequestDTOBuilder() {
        this._customParams = UnassignedValue;
        this._offerId = UnassignedValue;
    }
    ResolveOfferRequestDTOBuilder.prototype.withOfferId = function (_offerId) {
        this._offerId = _offerId;
        return this;
    };
    ResolveOfferRequestDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    ResolveOfferRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ResolveOfferRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(manyOf(function () { return exports.aCustomParam().build({ buildersVisited: buildersVisited }); })),
            offerId: this._offerId !== UnassignedValue ? this._offerId : maybe(someString()),
        };
    };
    return ResolveOfferRequestDTOBuilder;
}());
exports.ResolveOfferRequestDTOBuilder = ResolveOfferRequestDTOBuilder;
var ResolveOfferResponseDTOBuilder = /** @class */ (function () {
    function ResolveOfferResponseDTOBuilder() {
        this._offer = UnassignedValue;
    }
    ResolveOfferResponseDTOBuilder.prototype.withOffer = function (_offer) {
        this._offer = _offer;
        return this;
    };
    ResolveOfferResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ResolveOfferResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            offer: this._offer !== UnassignedValue ? this._offer : maybe(exports.anOffer().build({ buildersVisited: buildersVisited })),
        };
    };
    return ResolveOfferResponseDTOBuilder;
}());
exports.ResolveOfferResponseDTOBuilder = ResolveOfferResponseDTOBuilder;
var RestoreFromTrashbinMethodOptionsDTOBuilder = /** @class */ (function () {
    function RestoreFromTrashbinMethodOptionsDTOBuilder() {
        this._idField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    RestoreFromTrashbinMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    RestoreFromTrashbinMethodOptionsDTOBuilder.prototype.withIdField = function (_idField) {
        this._idField = _idField;
        return this;
    };
    RestoreFromTrashbinMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RestoreFromTrashbinMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            idField: this._idField !== UnassignedValue ? this._idField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return RestoreFromTrashbinMethodOptionsDTOBuilder;
}());
exports.RestoreFromTrashbinMethodOptionsDTOBuilder = RestoreFromTrashbinMethodOptionsDTOBuilder;
var SchemaDTOBuilder = /** @class */ (function () {
    function SchemaDTOBuilder() {
        this._createdBy = UnassignedValue;
        this._createdDate = UnassignedValue;
        this._dataSchema = UnassignedValue;
        this._extendedFields = UnassignedValue;
        this._id = UnassignedValue;
        this._revision = UnassignedValue;
        this._schemaId = UnassignedValue;
        this._type = UnassignedValue;
        this._uiSchema = UnassignedValue;
    }
    SchemaDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    SchemaDTOBuilder.prototype.withDataSchema = function (_dataSchema) {
        this._dataSchema = _dataSchema;
        return this;
    };
    SchemaDTOBuilder.prototype.withUiSchema = function (_uiSchema) {
        this._uiSchema = _uiSchema;
        return this;
    };
    SchemaDTOBuilder.prototype.withSchemaId = function (_schemaId) {
        this._schemaId = _schemaId;
        return this;
    };
    SchemaDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    SchemaDTOBuilder.prototype.withRevision = function (_revision) {
        this._revision = _revision;
        return this;
    };
    SchemaDTOBuilder.prototype.withCreatedDate = function (_createdDate) {
        this._createdDate = _createdDate;
        return this;
    };
    SchemaDTOBuilder.prototype.withCreatedBy = function (_createdBy) {
        this._createdBy = _createdBy;
        return this;
    };
    SchemaDTOBuilder.prototype.withExtendedFields = function (_extendedFields) {
        this._extendedFields = _extendedFields;
        return this;
    };
    SchemaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Schema', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            createdBy: this._createdBy !== UnassignedValue ? this._createdBy : maybe(someGuid()),
            createdDate: this._createdDate !== UnassignedValue ? this._createdDate : maybe(someDateString()),
            dataSchema: this._dataSchema !== UnassignedValue ? this._dataSchema : maybe(jsonMapOf(function () { return createNull(); })),
            extendedFields: this._extendedFields !== UnassignedValue ? this._extendedFields : maybe(exports.anExtendedFields().build({ buildersVisited: buildersVisited })),
            id: this._id !== UnassignedValue ? this._id : maybe(someGuid()),
            revision: this._revision !== UnassignedValue ? this._revision : maybe(someInt()),
            schemaId: this._schemaId !== UnassignedValue ? this._schemaId : maybe(someGuid()),
            type: this._type !== UnassignedValue ? this._type : maybe(someString()),
            uiSchema: this._uiSchema !== UnassignedValue ? this._uiSchema : maybe(jsonMapOf(function () { return createNull(); })),
        };
    };
    return SchemaDTOBuilder;
}());
exports.SchemaDTOBuilder = SchemaDTOBuilder;
var SearchDTOBuilder = /** @class */ (function () {
    function SearchDTOBuilder() {
        this._field = UnassignedValue;
        this._maturity = UnassignedValue;
    }
    SearchDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    SearchDTOBuilder.prototype.withMaturity = function (_maturity) {
        this._maturity = _maturity;
        return this;
    };
    SearchDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Search', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return someString(); })),
            maturity: this._maturity !== UnassignedValue ? this._maturity : maybe(exports.aMaturity().build({ buildersVisited: buildersVisited })),
        };
    };
    return SearchDTOBuilder;
}());
exports.SearchDTOBuilder = SearchDTOBuilder;
var SearchMethodOptionsDTOBuilder = /** @class */ (function () {
    function SearchMethodOptionsDTOBuilder() {
        this._itemsField = UnassignedValue;
        this._meAliasableField = UnassignedValue;
        this._paging = UnassignedValue;
        this._search = UnassignedValue;
        this._searchField = UnassignedValue;
        this._wql = UnassignedValue;
    }
    SearchMethodOptionsDTOBuilder.prototype.withSearchField = function (_searchField) {
        this._searchField = _searchField;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.withItemsField = function (_itemsField) {
        this._itemsField = _itemsField;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.withPaging = function (_paging) {
        this._paging = _paging;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.withWql = function (_wql) {
        this._wql = _wql;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.withMeAliasableField = function (_meAliasableField) {
        this._meAliasableField = _meAliasableField;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.withSearch = function (_search) {
        this._search = _search;
        return this;
    };
    SearchMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SearchMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            itemsField: this._itemsField !== UnassignedValue ? this._itemsField : maybe(someString()),
            meAliasableField: this._meAliasableField !== UnassignedValue ? this._meAliasableField : maybe(manyOf(function () { return someString(); })),
            paging: this._paging !== UnassignedValue ? this._paging : maybe(exports.aPaging().build({ buildersVisited: buildersVisited })),
            search: this._search !== UnassignedValue ? this._search : maybe(manyOf(function () { return exports.aSearch().build({ buildersVisited: buildersVisited }); })),
            searchField: this._searchField !== UnassignedValue ? this._searchField : maybe(someString()),
            wql: this._wql !== UnassignedValue ? this._wql : maybe(exports.aWql().build({ buildersVisited: buildersVisited })),
        };
    };
    return SearchMethodOptionsDTOBuilder;
}());
exports.SearchMethodOptionsDTOBuilder = SearchMethodOptionsDTOBuilder;
var SegmentDTOBuilder = /** @class */ (function () {
    function SegmentDTOBuilder() {
    }
    SegmentDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Segment', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return SegmentDTOBuilder;
}());
exports.SegmentDTOBuilder = SegmentDTOBuilder;
var SegmentNameDTOBuilder = /** @class */ (function () {
    function SegmentNameDTOBuilder() {
    }
    SegmentNameDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.SegmentName.UNSPECIFIED, types_1.SegmentName.USERS, types_1.SegmentName.PUBLIC, types_1.SegmentName.OTHERS]);
    };
    return SegmentNameDTOBuilder;
}());
exports.SegmentNameDTOBuilder = SegmentNameDTOBuilder;
var ServiceAppendixDTOBuilder = /** @class */ (function () {
    function ServiceAppendixDTOBuilder() {
        this._path = UnassignedValue;
        this._type = UnassignedValue;
    }
    ServiceAppendixDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    ServiceAppendixDTOBuilder.prototype.withPath = function (_path) {
        this._path = _path;
        return this;
    };
    ServiceAppendixDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceAppendix', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            path: this._path !== UnassignedValue ? this._path : maybe(someString()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aServiceAppendixType().build({ buildersVisited: buildersVisited })),
        };
    };
    return ServiceAppendixDTOBuilder;
}());
exports.ServiceAppendixDTOBuilder = ServiceAppendixDTOBuilder;
var ServiceAppendixTypeDTOBuilder = /** @class */ (function () {
    function ServiceAppendixTypeDTOBuilder() {
    }
    ServiceAppendixTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.ServiceAppendixType.UNKNOWN_APPENDIX_TYPE, types_1.ServiceAppendixType.NILE, types_1.ServiceAppendixType.MESSAGE_BUS]);
    };
    return ServiceAppendixTypeDTOBuilder;
}());
exports.ServiceAppendixTypeDTOBuilder = ServiceAppendixTypeDTOBuilder;
var ServiceDescriptorProtoDTOBuilder = /** @class */ (function () {
    function ServiceDescriptorProtoDTOBuilder() {
        this._method = UnassignedValue;
        this._name = UnassignedValue;
        this._options = UnassignedValue;
    }
    ServiceDescriptorProtoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    ServiceDescriptorProtoDTOBuilder.prototype.withMethod = function (_method) {
        this._method = _method;
        return this;
    };
    ServiceDescriptorProtoDTOBuilder.prototype.withOptions = function (_options) {
        this._options = _options;
        return this;
    };
    ServiceDescriptorProtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceDescriptorProto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            method: this._method !== UnassignedValue ? this._method : maybe(manyOf(function () { return exports.aMethodDescriptorProto().build({ buildersVisited: buildersVisited }); })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            options: this._options !== UnassignedValue ? this._options : maybe(exports.aServiceOptions().build({ buildersVisited: buildersVisited })),
        };
    };
    return ServiceDescriptorProtoDTOBuilder;
}());
exports.ServiceDescriptorProtoDTOBuilder = ServiceDescriptorProtoDTOBuilder;
var ServiceEntityDTOBuilder = /** @class */ (function () {
    function ServiceEntityDTOBuilder() {
        this._message = UnassignedValue;
        this._namespace = UnassignedValue;
    }
    ServiceEntityDTOBuilder.prototype.withMessage = function (_message) {
        this._message = _message;
        return this;
    };
    ServiceEntityDTOBuilder.prototype.withNamespace = function (_namespace) {
        this._namespace = _namespace;
        return this;
    };
    ServiceEntityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceEntity', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            message: this._message !== UnassignedValue ? this._message : maybe(someString()),
            namespace: this._namespace !== UnassignedValue ? this._namespace : maybe(someString()),
        };
    };
    return ServiceEntityDTOBuilder;
}());
exports.ServiceEntityDTOBuilder = ServiceEntityDTOBuilder;
var ServiceOptionsDTOBuilder = /** @class */ (function () {
    function ServiceOptionsDTOBuilder() {
        this._deprecated = UnassignedValue;
        this._uninterpretedOption = UnassignedValue;
    }
    ServiceOptionsDTOBuilder.prototype.withDeprecated = function (_deprecated) {
        this._deprecated = _deprecated;
        return this;
    };
    ServiceOptionsDTOBuilder.prototype.withUninterpretedOption = function (_uninterpretedOption) {
        this._uninterpretedOption = _uninterpretedOption;
        return this;
    };
    ServiceOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            deprecated: this._deprecated !== UnassignedValue ? this._deprecated : maybe(someBoolean()),
            uninterpretedOption: this._uninterpretedOption !== UnassignedValue ? this._uninterpretedOption : maybe(manyOf(function () { return exports.anUninterpretedOption().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ServiceOptionsDTOBuilder;
}());
exports.ServiceOptionsDTOBuilder = ServiceOptionsDTOBuilder;
var ShadowedStrategyDTOBuilder = /** @class */ (function () {
    function ShadowedStrategyDTOBuilder() {
        this._mainStrategy = UnassignedValue;
        this._shadowedStrategy = UnassignedValue;
    }
    ShadowedStrategyDTOBuilder.prototype.withMainStrategy = function (_mainStrategy) {
        this._mainStrategy = _mainStrategy;
        return this;
    };
    ShadowedStrategyDTOBuilder.prototype.withShadowedStrategy = function (_shadowedStrategy) {
        this._shadowedStrategy = _shadowedStrategy;
        return this;
    };
    ShadowedStrategyDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ShadowedStrategy', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            mainStrategy: this._mainStrategy !== UnassignedValue ? this._mainStrategy : maybe(exports.aPrioritizationStrategyParams().build({ buildersVisited: buildersVisited })),
            shadowedStrategy: this._shadowedStrategy !== UnassignedValue ? this._shadowedStrategy : maybe(exports.aPrioritizationStrategyParams().build({ buildersVisited: buildersVisited })),
        };
    };
    return ShadowedStrategyDTOBuilder;
}());
exports.ShadowedStrategyDTOBuilder = ShadowedStrategyDTOBuilder;
var SiteDataDTOBuilder = /** @class */ (function () {
    function SiteDataDTOBuilder() {
        this._instanceId = UnassignedValue;
    }
    SiteDataDTOBuilder.prototype.withInstanceId = function (_instanceId) {
        this._instanceId = _instanceId;
        return this;
    };
    SiteDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SiteData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            instanceId: this._instanceId !== UnassignedValue ? this._instanceId : maybe(someString()),
        };
    };
    return SiteDataDTOBuilder;
}());
exports.SiteDataDTOBuilder = SiteDataDTOBuilder;
var SiteTypeDTOBuilder = /** @class */ (function () {
    function SiteTypeDTOBuilder() {
    }
    SiteTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.SiteType.UNKNOWN, types_1.SiteType.REGULAR, types_1.SiteType.HEADLESS]);
    };
    return SiteTypeDTOBuilder;
}());
exports.SiteTypeDTOBuilder = SiteTypeDTOBuilder;
var SiteTypeCriteriaDTOBuilder = /** @class */ (function () {
    function SiteTypeCriteriaDTOBuilder() {
        this._included = UnassignedValue;
        this._values = UnassignedValue;
    }
    SiteTypeCriteriaDTOBuilder.prototype.withValues = function (_values) {
        this._values = _values;
        return this;
    };
    SiteTypeCriteriaDTOBuilder.prototype.withIncluded = function (_included) {
        this._included = _included;
        return this;
    };
    SiteTypeCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SiteTypeCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            included: this._included !== UnassignedValue ? this._included : maybe(someBoolean()),
            values: this._values !== UnassignedValue ? this._values : maybe(manyOf(function () { return exports.aSiteType().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return SiteTypeCriteriaDTOBuilder;
}());
exports.SiteTypeCriteriaDTOBuilder = SiteTypeCriteriaDTOBuilder;
var SortDTOBuilder = /** @class */ (function () {
    function SortDTOBuilder() {
    }
    SortDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.Sort.NONE, types_1.Sort.ASC, types_1.Sort.DESC, types_1.Sort.BOTH]);
    };
    return SortDTOBuilder;
}());
exports.SortDTOBuilder = SortDTOBuilder;
var SourceCodeInfoDTOBuilder = /** @class */ (function () {
    function SourceCodeInfoDTOBuilder() {
        this._location = UnassignedValue;
    }
    SourceCodeInfoDTOBuilder.prototype.withLocation = function (_location) {
        this._location = _location;
        return this;
    };
    SourceCodeInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SourceCodeInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            location: this._location !== UnassignedValue ? this._location : maybe(manyOf(function () { return exports.aLocation().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return SourceCodeInfoDTOBuilder;
}());
exports.SourceCodeInfoDTOBuilder = SourceCodeInfoDTOBuilder;
var SpiErrorDTOBuilder = /** @class */ (function () {
    function SpiErrorDTOBuilder() {
        this._applicationCode = UnassignedValue;
        this._data = UnassignedValue;
        this._httpCode = UnassignedValue;
        this._name = UnassignedValue;
    }
    SpiErrorDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    SpiErrorDTOBuilder.prototype.withHttpCode = function (_httpCode) {
        this._httpCode = _httpCode;
        return this;
    };
    SpiErrorDTOBuilder.prototype.withApplicationCode = function (_applicationCode) {
        this._applicationCode = _applicationCode;
        return this;
    };
    SpiErrorDTOBuilder.prototype.withData = function (_data) {
        this._data = _data;
        return this;
    };
    SpiErrorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SpiError', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            applicationCode: this._applicationCode !== UnassignedValue ? this._applicationCode : maybe(someString()),
            data: this._data !== UnassignedValue ? this._data : maybe(someString()),
            httpCode: this._httpCode !== UnassignedValue ? this._httpCode : maybe(exports.aSpiHttpStatusCode().build({ buildersVisited: buildersVisited })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
        };
    };
    return SpiErrorDTOBuilder;
}());
exports.SpiErrorDTOBuilder = SpiErrorDTOBuilder;
var SpiHttpStatusCodeDTOBuilder = /** @class */ (function () {
    function SpiHttpStatusCodeDTOBuilder() {
    }
    SpiHttpStatusCodeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.SpiHttpStatusCode.UNKNOWN_ERROR,
            types_1.SpiHttpStatusCode.UNAUTHENTICATED,
            types_1.SpiHttpStatusCode.INVALID_ARGUMENT,
            types_1.SpiHttpStatusCode.INTERNAL,
            types_1.SpiHttpStatusCode.RESOURCE_EXHAUSTED,
            types_1.SpiHttpStatusCode.CANCELED,
            types_1.SpiHttpStatusCode.NOT_FOUND,
            types_1.SpiHttpStatusCode.ALREADY_EXISTS,
            types_1.SpiHttpStatusCode.FAILED_PRECONDITION,
        ]);
    };
    return SpiHttpStatusCodeDTOBuilder;
}());
exports.SpiHttpStatusCodeDTOBuilder = SpiHttpStatusCodeDTOBuilder;
var SpiServiceDTOBuilder = /** @class */ (function () {
    function SpiServiceDTOBuilder() {
        this._appId = UnassignedValue;
        this._businessManagerUrl = UnassignedValue;
        this._configMessage = UnassignedValue;
        this._fqdn = UnassignedValue;
        this._hostService = UnassignedValue;
        this._spiIdentifier = UnassignedValue;
    }
    SpiServiceDTOBuilder.prototype.withSpiIdentifier = function (_spiIdentifier) {
        this._spiIdentifier = _spiIdentifier;
        return this;
    };
    SpiServiceDTOBuilder.prototype.withConfigMessage = function (_configMessage) {
        this._configMessage = _configMessage;
        return this;
    };
    SpiServiceDTOBuilder.prototype.withHostService = function (_hostService) {
        this._hostService = _hostService;
        return this;
    };
    SpiServiceDTOBuilder.prototype.withBusinessManagerUrl = function (_businessManagerUrl) {
        this._businessManagerUrl = _businessManagerUrl;
        return this;
    };
    SpiServiceDTOBuilder.prototype.withFqdn = function (_fqdn) {
        this._fqdn = _fqdn;
        return this;
    };
    SpiServiceDTOBuilder.prototype.withAppId = function (_appId) {
        this._appId = _appId;
        return this;
    };
    SpiServiceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SpiService', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appId: this._appId !== UnassignedValue ? this._appId : maybe(someString()),
            businessManagerUrl: this._businessManagerUrl !== UnassignedValue ? this._businessManagerUrl : maybe(someString()),
            configMessage: this._configMessage !== UnassignedValue ? this._configMessage : maybe(someString()),
            fqdn: this._fqdn !== UnassignedValue ? this._fqdn : maybe(someString()),
            hostService: this._hostService !== UnassignedValue ? this._hostService : maybe(someString()),
            spiIdentifier: this._spiIdentifier !== UnassignedValue ? this._spiIdentifier : maybe(someString()),
        };
    };
    return SpiServiceDTOBuilder;
}());
exports.SpiServiceDTOBuilder = SpiServiceDTOBuilder;
var StatusCodesDTOBuilder = /** @class */ (function () {
    function StatusCodesDTOBuilder() {
    }
    StatusCodesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'StatusCodes', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return StatusCodesDTOBuilder;
}());
exports.StatusCodesDTOBuilder = StatusCodesDTOBuilder;
var StatusCodesHttpStatusCodeDTOBuilder = /** @class */ (function () {
    function StatusCodesHttpStatusCodeDTOBuilder() {
    }
    StatusCodesHttpStatusCodeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.StatusCodesHttpStatusCode.OK,
            types_1.StatusCodesHttpStatusCode.UNAUTHENTICATED,
            types_1.StatusCodesHttpStatusCode.PERMISSION_DENIED,
            types_1.StatusCodesHttpStatusCode.INVALID_ARGUMENT,
            types_1.StatusCodesHttpStatusCode.NOT_FOUND,
            types_1.StatusCodesHttpStatusCode.INTERNAL,
            types_1.StatusCodesHttpStatusCode.UNAVAILABLE,
            types_1.StatusCodesHttpStatusCode.RESOURCE_EXHAUSTED,
            types_1.StatusCodesHttpStatusCode.CANCELED,
            types_1.StatusCodesHttpStatusCode.ALREADY_EXISTS,
            types_1.StatusCodesHttpStatusCode.FAILED_PRECONDITION,
        ]);
    };
    return StatusCodesHttpStatusCodeDTOBuilder;
}());
exports.StatusCodesHttpStatusCodeDTOBuilder = StatusCodesHttpStatusCodeDTOBuilder;
var TargetingDTOBuilder = /** @class */ (function () {
    function TargetingDTOBuilder() {
        this._audience = UnassignedValue;
        this._brand = UnassignedValue;
        this._compound = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._customParam = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._executionResult = UnassignedValue;
        this._experiment = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._geo = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._label = UnassignedValue;
        this._language = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._negate = UnassignedValue;
        this._postReg = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._siteType = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._type = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._vouchers = UnassignedValue;
    }
    TargetingDTOBuilder.prototype.withExecutionResult = function (_executionResult) {
        this._executionResult = _executionResult;
        return this;
    };
    TargetingDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    TargetingDTOBuilder.prototype.withLabel = function (_label) {
        this._label = _label;
        return this;
    };
    TargetingDTOBuilder.prototype.withNegate = function (_negate) {
        this._negate = _negate;
        return this;
    };
    TargetingDTOBuilder.prototype.withCompound = function (_compound) {
        this._compound = _compound;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withCustomFilter = function (_customFilter) {
        this._customFilter = _customFilter;
        this._compound = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withGeo = function (_geo) {
        this._geo = _geo;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withLanguage = function (_language) {
        this._language = _language;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withUserRole = function (_userRole) {
        this._userRole = _userRole;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withUserStatus = function (_userStatus) {
        this._userStatus = _userStatus;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withUserColors = function (_userColors) {
        this._userColors = _userColors;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withUserGuids = function (_userGuids) {
        this._userGuids = _userGuids;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withTemplateGuids = function (_templateGuids) {
        this._templateGuids = _templateGuids;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withPostReg = function (_postReg) {
        this._postReg = _postReg;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withConnectedDomain = function (_connectedDomain) {
        this._connectedDomain = _connectedDomain;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withPremiumPlan = function (_premiumPlan) {
        this._premiumPlan = _premiumPlan;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withExcludeInSale = function (_excludeInSale) {
        this._excludeInSale = _excludeInSale;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withMailbox = function (_mailbox) {
        this._mailbox = _mailbox;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withConnectedOfferingGroup = function (_connectedOfferingGroup) {
        this._connectedOfferingGroup = _connectedOfferingGroup;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withInstalledApps = function (_installedApps) {
        this._installedApps = _installedApps;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withProductGroups = function (_productGroups) {
        this._productGroups = _productGroups;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withDomainLength = function (_domainLength) {
        this._domainLength = _domainLength;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withMailboxSale = function (_mailboxSale) {
        this._mailboxSale = _mailboxSale;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withVouchers = function (_vouchers) {
        this._vouchers = _vouchers;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withFreeSite = function (_freeSite) {
        this._freeSite = _freeSite;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withBrand = function (_brand) {
        this._brand = _brand;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withExperiment = function (_experiment) {
        this._experiment = _experiment;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withCustomParam = function (_customParam) {
        this._customParam = _customParam;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withAudience = function (_audience) {
        this._audience = _audience;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withPremiumLandingTab = function (_premiumLandingTab) {
        this._premiumLandingTab = _premiumLandingTab;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withPremiumAccount = function (_premiumAccount) {
        this._premiumAccount = _premiumAccount;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withEligibleForSale = function (_eligibleForSale) {
        this._eligibleForSale = _eligibleForSale;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withExternalCriteria = function (_externalCriteria) {
        this._externalCriteria = _externalCriteria;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._siteType = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.withSiteType = function (_siteType) {
        this._siteType = _siteType;
        this._compound = UnassignedValue;
        this._customFilter = UnassignedValue;
        this._geo = UnassignedValue;
        this._language = UnassignedValue;
        this._userRole = UnassignedValue;
        this._userStatus = UnassignedValue;
        this._userColors = UnassignedValue;
        this._userGuids = UnassignedValue;
        this._templateGuids = UnassignedValue;
        this._postReg = UnassignedValue;
        this._connectedDomain = UnassignedValue;
        this._premiumPlan = UnassignedValue;
        this._excludeInSale = UnassignedValue;
        this._mailbox = UnassignedValue;
        this._connectedOfferingGroup = UnassignedValue;
        this._installedApps = UnassignedValue;
        this._productGroups = UnassignedValue;
        this._domainLength = UnassignedValue;
        this._mailboxSale = UnassignedValue;
        this._vouchers = UnassignedValue;
        this._freeSite = UnassignedValue;
        this._brand = UnassignedValue;
        this._experiment = UnassignedValue;
        this._customParam = UnassignedValue;
        this._audience = UnassignedValue;
        this._premiumLandingTab = UnassignedValue;
        this._premiumAccount = UnassignedValue;
        this._eligibleForSale = UnassignedValue;
        this._externalCriteria = UnassignedValue;
        return this;
    };
    TargetingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Targeting', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._compound === UnassignedValue &&
            this._customFilter === UnassignedValue &&
            this._geo === UnassignedValue &&
            this._language === UnassignedValue &&
            this._userRole === UnassignedValue &&
            this._userStatus === UnassignedValue &&
            this._userColors === UnassignedValue &&
            this._userGuids === UnassignedValue &&
            this._templateGuids === UnassignedValue &&
            this._postReg === UnassignedValue &&
            this._connectedDomain === UnassignedValue &&
            this._premiumPlan === UnassignedValue &&
            this._excludeInSale === UnassignedValue &&
            this._mailbox === UnassignedValue &&
            this._connectedOfferingGroup === UnassignedValue &&
            this._installedApps === UnassignedValue &&
            this._productGroups === UnassignedValue &&
            this._domainLength === UnassignedValue &&
            this._mailboxSale === UnassignedValue &&
            this._vouchers === UnassignedValue &&
            this._freeSite === UnassignedValue &&
            this._brand === UnassignedValue &&
            this._experiment === UnassignedValue &&
            this._customParam === UnassignedValue &&
            this._audience === UnassignedValue &&
            this._premiumLandingTab === UnassignedValue &&
            this._premiumAccount === UnassignedValue &&
            this._eligibleForSale === UnassignedValue &&
            this._externalCriteria === UnassignedValue &&
            this._siteType === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = [
                'compound',
                'customFilter',
                'geo',
                'language',
                'userRole',
                'userStatus',
                'userColors',
                'userGuids',
                'templateGuids',
                'postReg',
                'connectedDomain',
                'premiumPlan',
                'excludeInSale',
                'mailbox',
                'connectedOfferingGroup',
                'installedApps',
                'productGroups',
                'domainLength',
                'mailboxSale',
                'vouchers',
                'freeSite',
                'brand',
                'experiment',
                'customParam',
                'audience',
                'premiumLandingTab',
                'premiumAccount',
                'eligibleForSale',
                'externalCriteria',
                'siteType',
            ];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 30), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                audience: assignRandomOneOf('audience', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                brand: assignRandomOneOf('brand', maybe(exports.aBrandsCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                compound: assignRandomOneOf('compound', maybe(exports.aCompoundCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                connectedDomain: assignRandomOneOf('connectedDomain', maybe(exports.aConnectedDomainCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                connectedOfferingGroup: assignRandomOneOf('connectedOfferingGroup', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                customFilter: assignRandomOneOf('customFilter', maybe(exports.aCustomFilterCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                customParam: assignRandomOneOf('customParam', maybe(exports.aCustomParamCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                domainLength: assignRandomOneOf('domainLength', maybe(exports.aDomainLengthCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                eligibleForSale: assignRandomOneOf('eligibleForSale', maybe(exports.anEligibleForSaleCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                excludeInSale: assignRandomOneOf('excludeInSale', maybe(someBoolean()), oneOfFieldsToUnAssign),
                executionResult: this._executionResult !== UnassignedValue ? this._executionResult : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
                experiment: assignRandomOneOf('experiment', maybe(exports.anExperimentCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                externalCriteria: assignRandomOneOf('externalCriteria', maybe(exports.anExternalCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                freeSite: assignRandomOneOf('freeSite', maybe(exports.aFreeSiteCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                geo: assignRandomOneOf('geo', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                installedApps: assignRandomOneOf('installedApps', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                label: this._label !== UnassignedValue ? this._label : maybe(someString()),
                language: assignRandomOneOf('language', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                mailbox: assignRandomOneOf('mailbox', maybe(exports.aMailboxCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                mailboxSale: assignRandomOneOf('mailboxSale', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                negate: this._negate !== UnassignedValue ? this._negate : maybe(someBoolean()),
                postReg: assignRandomOneOf('postReg', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                premiumAccount: assignRandomOneOf('premiumAccount', maybe(exports.aPremiumAccountCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                premiumLandingTab: assignRandomOneOf('premiumLandingTab', maybe(exports.aPremiumLandingTabCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                premiumPlan: assignRandomOneOf('premiumPlan', maybe(exports.aPremiumPlanCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                productGroups: assignRandomOneOf('productGroups', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                siteType: assignRandomOneOf('siteType', maybe(exports.aSiteTypeCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                templateGuids: assignRandomOneOf('templateGuids', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                type: this._type !== UnassignedValue ? this._type : maybe(exports.aCriteriaType().build({ buildersVisited: buildersVisited })),
                userColors: assignRandomOneOf('userColors', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                userGuids: assignRandomOneOf('userGuids', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                userRole: assignRandomOneOf('userRole', maybe(exports.anUserRoleCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                userStatus: assignRandomOneOf('userStatus', maybe(exports.anUserStatusCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                vouchers: assignRandomOneOf('vouchers', maybe(exports.aListCriteria().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            audience: this._audience === UnassignedValue ? undefined : this._audience,
            brand: this._brand === UnassignedValue ? undefined : this._brand,
            compound: this._compound === UnassignedValue ? undefined : this._compound,
            connectedDomain: this._connectedDomain === UnassignedValue ? undefined : this._connectedDomain,
            connectedOfferingGroup: this._connectedOfferingGroup === UnassignedValue ? undefined : this._connectedOfferingGroup,
            customFilter: this._customFilter === UnassignedValue ? undefined : this._customFilter,
            customParam: this._customParam === UnassignedValue ? undefined : this._customParam,
            domainLength: this._domainLength === UnassignedValue ? undefined : this._domainLength,
            eligibleForSale: this._eligibleForSale === UnassignedValue ? undefined : this._eligibleForSale,
            excludeInSale: this._excludeInSale === UnassignedValue ? undefined : this._excludeInSale,
            executionResult: this._executionResult !== UnassignedValue ? this._executionResult : maybe(exports.anExecutionResult().build({ buildersVisited: buildersVisited })),
            experiment: this._experiment === UnassignedValue ? undefined : this._experiment,
            externalCriteria: this._externalCriteria === UnassignedValue ? undefined : this._externalCriteria,
            freeSite: this._freeSite === UnassignedValue ? undefined : this._freeSite,
            geo: this._geo === UnassignedValue ? undefined : this._geo,
            installedApps: this._installedApps === UnassignedValue ? undefined : this._installedApps,
            label: this._label !== UnassignedValue ? this._label : maybe(someString()),
            language: this._language === UnassignedValue ? undefined : this._language,
            mailbox: this._mailbox === UnassignedValue ? undefined : this._mailbox,
            mailboxSale: this._mailboxSale === UnassignedValue ? undefined : this._mailboxSale,
            negate: this._negate !== UnassignedValue ? this._negate : maybe(someBoolean()),
            postReg: this._postReg === UnassignedValue ? undefined : this._postReg,
            premiumAccount: this._premiumAccount === UnassignedValue ? undefined : this._premiumAccount,
            premiumLandingTab: this._premiumLandingTab === UnassignedValue ? undefined : this._premiumLandingTab,
            premiumPlan: this._premiumPlan === UnassignedValue ? undefined : this._premiumPlan,
            productGroups: this._productGroups === UnassignedValue ? undefined : this._productGroups,
            siteType: this._siteType === UnassignedValue ? undefined : this._siteType,
            templateGuids: this._templateGuids === UnassignedValue ? undefined : this._templateGuids,
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aCriteriaType().build({ buildersVisited: buildersVisited })),
            userColors: this._userColors === UnassignedValue ? undefined : this._userColors,
            userGuids: this._userGuids === UnassignedValue ? undefined : this._userGuids,
            userRole: this._userRole === UnassignedValue ? undefined : this._userRole,
            userStatus: this._userStatus === UnassignedValue ? undefined : this._userStatus,
            vouchers: this._vouchers === UnassignedValue ? undefined : this._vouchers,
        };
    };
    return TargetingDTOBuilder;
}());
exports.TargetingDTOBuilder = TargetingDTOBuilder;
var TranslatableDTOBuilder = /** @class */ (function () {
    function TranslatableDTOBuilder() {
        this._displayOnly = UnassignedValue;
        this._grouping = UnassignedValue;
        this._hidden = UnassignedValue;
        this._name = UnassignedValue;
        this._type = UnassignedValue;
    }
    TranslatableDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    TranslatableDTOBuilder.prototype.withHidden = function (_hidden) {
        this._hidden = _hidden;
        return this;
    };
    TranslatableDTOBuilder.prototype.withGrouping = function (_grouping) {
        this._grouping = _grouping;
        return this;
    };
    TranslatableDTOBuilder.prototype.withType = function (_type) {
        this._type = _type;
        return this;
    };
    TranslatableDTOBuilder.prototype.withDisplayOnly = function (_displayOnly) {
        this._displayOnly = _displayOnly;
        return this;
    };
    TranslatableDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Translatable', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            displayOnly: this._displayOnly !== UnassignedValue ? this._displayOnly : maybe(someBoolean()),
            grouping: this._grouping !== UnassignedValue ? this._grouping : maybe(someString()),
            hidden: this._hidden !== UnassignedValue ? this._hidden : maybe(someBoolean()),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            type: this._type !== UnassignedValue ? this._type : maybe(exports.aTranslatableType().build({ buildersVisited: buildersVisited })),
        };
    };
    return TranslatableDTOBuilder;
}());
exports.TranslatableDTOBuilder = TranslatableDTOBuilder;
var TranslatableTypeDTOBuilder = /** @class */ (function () {
    function TranslatableTypeDTOBuilder() {
    }
    TranslatableTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.TranslatableType.UNDEFINED_TYPE,
            types_1.TranslatableType.SHORT_TEXT,
            types_1.TranslatableType.LONG_TEXT,
            types_1.TranslatableType.RICH_TEXT,
            types_1.TranslatableType.RICH_CONTENT_EDITOR,
            types_1.TranslatableType.SELECTION,
            types_1.TranslatableType.MULTI_SELECTION,
            types_1.TranslatableType.DOCUMENT,
            types_1.TranslatableType.IMAGE,
            types_1.TranslatableType.VIDEO,
            types_1.TranslatableType.IMAGE_LINK,
        ]);
    };
    return TranslatableTypeDTOBuilder;
}());
exports.TranslatableTypeDTOBuilder = TranslatableTypeDTOBuilder;
var UninterpretedOptionDTOBuilder = /** @class */ (function () {
    function UninterpretedOptionDTOBuilder() {
        this._aggregateValue = UnassignedValue;
        this._doubleValue = UnassignedValue;
        this._identifierValue = UnassignedValue;
        this._name = UnassignedValue;
        this._negativeIntValue = UnassignedValue;
        this._positiveIntValue = UnassignedValue;
        this._stringValue = UnassignedValue;
    }
    UninterpretedOptionDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withIdentifierValue = function (_identifierValue) {
        this._identifierValue = _identifierValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withPositiveIntValue = function (_positiveIntValue) {
        this._positiveIntValue = _positiveIntValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withNegativeIntValue = function (_negativeIntValue) {
        this._negativeIntValue = _negativeIntValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withDoubleValue = function (_doubleValue) {
        this._doubleValue = _doubleValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withStringValue = function (_stringValue) {
        this._stringValue = _stringValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.withAggregateValue = function (_aggregateValue) {
        this._aggregateValue = _aggregateValue;
        return this;
    };
    UninterpretedOptionDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UninterpretedOption', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            aggregateValue: this._aggregateValue !== UnassignedValue ? this._aggregateValue : maybe(someString()),
            doubleValue: this._doubleValue !== UnassignedValue ? this._doubleValue : maybe(someNumber()),
            identifierValue: this._identifierValue !== UnassignedValue ? this._identifierValue : maybe(someString()),
            name: this._name !== UnassignedValue ? this._name : maybe(manyOf(function () { return exports.aNamePart().build({ buildersVisited: buildersVisited }); })),
            negativeIntValue: this._negativeIntValue !== UnassignedValue ? this._negativeIntValue : maybe(someInt()),
            positiveIntValue: this._positiveIntValue !== UnassignedValue ? this._positiveIntValue : maybe(someInt()),
            stringValue: this._stringValue !== UnassignedValue ? this._stringValue : maybe(someString()),
        };
    };
    return UninterpretedOptionDTOBuilder;
}());
exports.UninterpretedOptionDTOBuilder = UninterpretedOptionDTOBuilder;
var UniqueDTOBuilder = /** @class */ (function () {
    function UniqueDTOBuilder() {
        this._field = UnassignedValue;
    }
    UniqueDTOBuilder.prototype.withField = function (_field) {
        this._field = _field;
        return this;
    };
    UniqueDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Unique', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            field: this._field !== UnassignedValue ? this._field : maybe(manyOf(function () { return someString(); })),
        };
    };
    return UniqueDTOBuilder;
}());
exports.UniqueDTOBuilder = UniqueDTOBuilder;
var UpdateMethodOptionsDTOBuilder = /** @class */ (function () {
    function UpdateMethodOptionsDTOBuilder() {
        this._fieldmaskField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    UpdateMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    UpdateMethodOptionsDTOBuilder.prototype.withFieldmaskField = function (_fieldmaskField) {
        this._fieldmaskField = _fieldmaskField;
        return this;
    };
    UpdateMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdateMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fieldmaskField: this._fieldmaskField !== UnassignedValue ? this._fieldmaskField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return UpdateMethodOptionsDTOBuilder;
}());
exports.UpdateMethodOptionsDTOBuilder = UpdateMethodOptionsDTOBuilder;
var UpdatePlacementRequestDTOBuilder = /** @class */ (function () {
    function UpdatePlacementRequestDTOBuilder() {
        this._placement = UnassignedValue;
    }
    UpdatePlacementRequestDTOBuilder.prototype.withPlacement = function (_placement) {
        this._placement = _placement;
        return this;
    };
    UpdatePlacementRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placement: this._placement !== UnassignedValue ? this._placement : maybe(exports.aPlacement().build({ buildersVisited: buildersVisited })),
        };
    };
    return UpdatePlacementRequestDTOBuilder;
}());
exports.UpdatePlacementRequestDTOBuilder = UpdatePlacementRequestDTOBuilder;
var UpdatePlacementResponseDTOBuilder = /** @class */ (function () {
    function UpdatePlacementResponseDTOBuilder() {
        this._placement = UnassignedValue;
    }
    UpdatePlacementResponseDTOBuilder.prototype.withPlacement = function (_placement) {
        this._placement = _placement;
        return this;
    };
    UpdatePlacementResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placement: this._placement !== UnassignedValue ? this._placement : maybe(exports.aPlacement().build({ buildersVisited: buildersVisited })),
        };
    };
    return UpdatePlacementResponseDTOBuilder;
}());
exports.UpdatePlacementResponseDTOBuilder = UpdatePlacementResponseDTOBuilder;
var UpdatePlacementSlugRequestDTOBuilder = /** @class */ (function () {
    function UpdatePlacementSlugRequestDTOBuilder() {
        this._placementGuid = UnassignedValue;
        this._slug = UnassignedValue;
    }
    UpdatePlacementSlugRequestDTOBuilder.prototype.withPlacementGuid = function (_placementGuid) {
        this._placementGuid = _placementGuid;
        return this;
    };
    UpdatePlacementSlugRequestDTOBuilder.prototype.withSlug = function (_slug) {
        this._slug = _slug;
        return this;
    };
    UpdatePlacementSlugRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementSlugRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placementGuid: this._placementGuid !== UnassignedValue ? this._placementGuid : maybe(someGuid()),
            slug: this._slug !== UnassignedValue ? this._slug : maybe(boundedString(1, 32)),
        };
    };
    return UpdatePlacementSlugRequestDTOBuilder;
}());
exports.UpdatePlacementSlugRequestDTOBuilder = UpdatePlacementSlugRequestDTOBuilder;
var UpdatePlacementSlugResponseDTOBuilder = /** @class */ (function () {
    function UpdatePlacementSlugResponseDTOBuilder() {
        this._success = UnassignedValue;
    }
    UpdatePlacementSlugResponseDTOBuilder.prototype.withSuccess = function (_success) {
        this._success = _success;
        return this;
    };
    UpdatePlacementSlugResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementSlugResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            success: this._success !== UnassignedValue ? this._success : maybe(someBoolean()),
        };
    };
    return UpdatePlacementSlugResponseDTOBuilder;
}());
exports.UpdatePlacementSlugResponseDTOBuilder = UpdatePlacementSlugResponseDTOBuilder;
var UpdatePlacementStatusRequestDTOBuilder = /** @class */ (function () {
    function UpdatePlacementStatusRequestDTOBuilder() {
        this._placementGuid = UnassignedValue;
        this._status = UnassignedValue;
    }
    UpdatePlacementStatusRequestDTOBuilder.prototype.withPlacementGuid = function (_placementGuid) {
        this._placementGuid = _placementGuid;
        return this;
    };
    UpdatePlacementStatusRequestDTOBuilder.prototype.withStatus = function (_status) {
        this._status = _status;
        return this;
    };
    UpdatePlacementStatusRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementStatusRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            placementGuid: this._placementGuid !== UnassignedValue ? this._placementGuid : maybe(someGuid()),
            status: this._status !== UnassignedValue ? this._status : maybe(exports.aPlacementStatus().build({ buildersVisited: buildersVisited })),
        };
    };
    return UpdatePlacementStatusRequestDTOBuilder;
}());
exports.UpdatePlacementStatusRequestDTOBuilder = UpdatePlacementStatusRequestDTOBuilder;
var UpdatePlacementStatusResponseDTOBuilder = /** @class */ (function () {
    function UpdatePlacementStatusResponseDTOBuilder() {
    }
    UpdatePlacementStatusResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpdatePlacementStatusResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return UpdatePlacementStatusResponseDTOBuilder;
}());
exports.UpdatePlacementStatusResponseDTOBuilder = UpdatePlacementStatusResponseDTOBuilder;
var UpsertMethodOptionsDTOBuilder = /** @class */ (function () {
    function UpsertMethodOptionsDTOBuilder() {
        this._fieldmaskField = UnassignedValue;
        this._itemField = UnassignedValue;
    }
    UpsertMethodOptionsDTOBuilder.prototype.withItemField = function (_itemField) {
        this._itemField = _itemField;
        return this;
    };
    UpsertMethodOptionsDTOBuilder.prototype.withFieldmaskField = function (_fieldmaskField) {
        this._fieldmaskField = _fieldmaskField;
        return this;
    };
    UpsertMethodOptionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpsertMethodOptions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fieldmaskField: this._fieldmaskField !== UnassignedValue ? this._fieldmaskField : maybe(someString()),
            itemField: this._itemField !== UnassignedValue ? this._itemField : maybe(someString()),
        };
    };
    return UpsertMethodOptionsDTOBuilder;
}());
exports.UpsertMethodOptionsDTOBuilder = UpsertMethodOptionsDTOBuilder;
var UserAccountInfoDTOBuilder = /** @class */ (function () {
    function UserAccountInfoDTOBuilder() {
        this._isAccountOwner = UnassignedValue;
        this._isLogInAccountOwner = UnassignedValue;
        this._loggedInAccountId = UnassignedValue;
        this._parentAccountId = UnassignedValue;
    }
    UserAccountInfoDTOBuilder.prototype.withLoggedInAccountId = function (_loggedInAccountId) {
        this._loggedInAccountId = _loggedInAccountId;
        return this;
    };
    UserAccountInfoDTOBuilder.prototype.withIsAccountOwner = function (_isAccountOwner) {
        this._isAccountOwner = _isAccountOwner;
        return this;
    };
    UserAccountInfoDTOBuilder.prototype.withIsLogInAccountOwner = function (_isLogInAccountOwner) {
        this._isLogInAccountOwner = _isLogInAccountOwner;
        return this;
    };
    UserAccountInfoDTOBuilder.prototype.withParentAccountId = function (_parentAccountId) {
        this._parentAccountId = _parentAccountId;
        return this;
    };
    UserAccountInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UserAccountInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            isAccountOwner: this._isAccountOwner !== UnassignedValue ? this._isAccountOwner : maybe(someBoolean()),
            isLogInAccountOwner: this._isLogInAccountOwner !== UnassignedValue ? this._isLogInAccountOwner : maybe(someBoolean()),
            loggedInAccountId: this._loggedInAccountId !== UnassignedValue ? this._loggedInAccountId : maybe(someString()),
            parentAccountId: this._parentAccountId !== UnassignedValue ? this._parentAccountId : maybe(someString()),
        };
    };
    return UserAccountInfoDTOBuilder;
}());
exports.UserAccountInfoDTOBuilder = UserAccountInfoDTOBuilder;
var UserDataDTOBuilder = /** @class */ (function () {
    function UserDataDTOBuilder() {
        this._userId = UnassignedValue;
    }
    UserDataDTOBuilder.prototype.withUserId = function (_userId) {
        this._userId = _userId;
        return this;
    };
    UserDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UserData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            userId: this._userId !== UnassignedValue ? this._userId : maybe(someString()),
        };
    };
    return UserDataDTOBuilder;
}());
exports.UserDataDTOBuilder = UserDataDTOBuilder;
var UserRoleCriteriaDTOBuilder = /** @class */ (function () {
    function UserRoleCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    UserRoleCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    UserRoleCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UserRoleCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.anUserRoleCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return UserRoleCriteriaDTOBuilder;
}());
exports.UserRoleCriteriaDTOBuilder = UserRoleCriteriaDTOBuilder;
var UserRoleCriteriaEnumDTOBuilder = /** @class */ (function () {
    function UserRoleCriteriaEnumDTOBuilder() {
    }
    UserRoleCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.UserRoleCriteriaEnum.UNKNOWN, types_1.UserRoleCriteriaEnum.OWNER, types_1.UserRoleCriteriaEnum.NOT_OWNER]);
    };
    return UserRoleCriteriaEnumDTOBuilder;
}());
exports.UserRoleCriteriaEnumDTOBuilder = UserRoleCriteriaEnumDTOBuilder;
var UserStatusCriteriaDTOBuilder = /** @class */ (function () {
    function UserStatusCriteriaDTOBuilder() {
        this._value = UnassignedValue;
    }
    UserStatusCriteriaDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    UserStatusCriteriaDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UserStatusCriteria', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            value: this._value !== UnassignedValue ? this._value : maybe(exports.anUserStatusCriteriaEnum().build({ buildersVisited: buildersVisited })),
        };
    };
    return UserStatusCriteriaDTOBuilder;
}());
exports.UserStatusCriteriaDTOBuilder = UserStatusCriteriaDTOBuilder;
var UserStatusCriteriaEnumDTOBuilder = /** @class */ (function () {
    function UserStatusCriteriaEnumDTOBuilder() {
    }
    UserStatusCriteriaEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.UserStatusCriteriaEnum.UNKNOWN, types_1.UserStatusCriteriaEnum.NEW]);
    };
    return UserStatusCriteriaEnumDTOBuilder;
}());
exports.UserStatusCriteriaEnumDTOBuilder = UserStatusCriteriaEnumDTOBuilder;
var WHATSNEXTConfigDTOBuilder = /** @class */ (function () {
    function WHATSNEXTConfigDTOBuilder() {
        this._customParams = UnassignedValue;
    }
    WHATSNEXTConfigDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    WHATSNEXTConfigDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'WHATSNEXTConfig', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(jsonMapOf(function () { return createNull(); })),
        };
    };
    return WHATSNEXTConfigDTOBuilder;
}());
exports.WHATSNEXTConfigDTOBuilder = WHATSNEXTConfigDTOBuilder;
var WhatsNextConfigurationDTOBuilder = /** @class */ (function () {
    function WhatsNextConfigurationDTOBuilder() {
        this._customParams = UnassignedValue;
        this._llmTimeoutInMs = UnassignedValue;
        this._totalAdvices = UnassignedValue;
    }
    WhatsNextConfigurationDTOBuilder.prototype.withCustomParams = function (_customParams) {
        this._customParams = _customParams;
        return this;
    };
    WhatsNextConfigurationDTOBuilder.prototype.withTotalAdvices = function (_totalAdvices) {
        this._totalAdvices = _totalAdvices;
        return this;
    };
    WhatsNextConfigurationDTOBuilder.prototype.withLlmTimeoutInMs = function (_llmTimeoutInMs) {
        this._llmTimeoutInMs = _llmTimeoutInMs;
        return this;
    };
    WhatsNextConfigurationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'WhatsNextConfiguration', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            customParams: this._customParams !== UnassignedValue ? this._customParams : maybe(jsonMapOf(function () { return createNull(); })),
            llmTimeoutInMs: this._llmTimeoutInMs !== UnassignedValue ? this._llmTimeoutInMs : maybe(someInt()),
            totalAdvices: this._totalAdvices !== UnassignedValue ? this._totalAdvices : maybe(someInt()),
        };
    };
    return WhatsNextConfigurationDTOBuilder;
}());
exports.WhatsNextConfigurationDTOBuilder = WhatsNextConfigurationDTOBuilder;
var WixGlobalDataDTOBuilder = /** @class */ (function () {
    function WixGlobalDataDTOBuilder() {
    }
    WixGlobalDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'WixGlobalData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return WixGlobalDataDTOBuilder;
}());
exports.WixGlobalDataDTOBuilder = WixGlobalDataDTOBuilder;
var WqlDTOBuilder = /** @class */ (function () {
    function WqlDTOBuilder() {
        this._operatorFieldSupport = UnassignedValue;
        this._pattern = UnassignedValue;
    }
    WqlDTOBuilder.prototype.withOperatorFieldSupport = function (_operatorFieldSupport) {
        this._operatorFieldSupport = _operatorFieldSupport;
        return this;
    };
    WqlDTOBuilder.prototype.withPattern = function (_pattern) {
        this._pattern = _pattern;
        return this;
    };
    WqlDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Wql', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            operatorFieldSupport: this._operatorFieldSupport !== UnassignedValue ? this._operatorFieldSupport : maybe(manyOf(function () { return exports.anOperatorFieldSupport().build({ buildersVisited: buildersVisited }); })),
            pattern: this._pattern !== UnassignedValue ? this._pattern : maybe(manyOf(function () { return exports.anOperatorFieldSupport().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return WqlDTOBuilder;
}());
exports.WqlDTOBuilder = WqlDTOBuilder;
var WqlOperatorDTOBuilder = /** @class */ (function () {
    function WqlOperatorDTOBuilder() {
    }
    WqlOperatorDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.WqlOperator.ALL_APPLICABLE_OPERATORS,
            types_1.WqlOperator.EQ,
            types_1.WqlOperator.GT,
            types_1.WqlOperator.GTE,
            types_1.WqlOperator.IN,
            types_1.WqlOperator.LT,
            types_1.WqlOperator.LTE,
            types_1.WqlOperator.NE,
            types_1.WqlOperator.NIN,
            types_1.WqlOperator.BEGINS,
            types_1.WqlOperator.EXISTS,
            types_1.WqlOperator.ALL,
            types_1.WqlOperator.HAS_ALL,
            types_1.WqlOperator.ANY,
            types_1.WqlOperator.HAS_SOME,
            types_1.WqlOperator.EMPTY,
            types_1.WqlOperator.MATCH_ALL,
        ]);
    };
    return WqlOperatorDTOBuilder;
}());
exports.WqlOperatorDTOBuilder = WqlOperatorDTOBuilder;
var anABCTRConfig = function () { return new ABCTRConfigDTOBuilder(); };
exports.anABCTRConfig = anABCTRConfig;
var anAccountData = function () { return new AccountDataDTOBuilder(); };
exports.anAccountData = anAccountData;
var anAccountIdInContext = function () { return new AccountIdInContextDTOBuilder(); };
exports.anAccountIdInContext = anAccountIdInContext;
var anAdvices = function () { return new AdvicesDTOBuilder(); };
exports.anAdvices = anAdvices;
var anAdvicesConfig = function () { return new AdvicesConfigDTOBuilder(); };
exports.anAdvicesConfig = anAdvicesConfig;
var anAlignedWithEnum = function () { return new AlignedWithEnumDTOBuilder(); };
exports.anAlignedWithEnum = anAlignedWithEnum;
var anAnnotation = function () { return new AnnotationDTOBuilder(); };
exports.anAnnotation = anAnnotation;
var anApiError = function () { return new ApiErrorDTOBuilder(); };
exports.anApiError = anApiError;
var anAppScope = function () { return new AppScopeDTOBuilder(); };
exports.anAppScope = anAppScope;
var anApplyFilterListRequest = function () { return new ApplyFilterListRequestDTOBuilder(); };
exports.anApplyFilterListRequest = anApplyFilterListRequest;
var anApplyFilterListResponse = function () { return new ApplyFilterListResponseDTOBuilder(); };
exports.anApplyFilterListResponse = anApplyFilterListResponse;
var anApplyFilterRequest = function () { return new ApplyFilterRequestDTOBuilder(); };
exports.anApplyFilterRequest = anApplyFilterRequest;
var anApplyFilterResponse = function () { return new ApplyFilterResponseDTOBuilder(); };
exports.anApplyFilterResponse = anApplyFilterResponse;
var anApplyFilterResult = function () { return new ApplyFilterResultDTOBuilder(); };
exports.anApplyFilterResult = anApplyFilterResult;
var anAsset = function () { return new AssetDTOBuilder(); };
exports.anAsset = anAsset;
var aBrand = function () { return new BrandDTOBuilder(); };
exports.aBrand = aBrand;
var aBrandsCriteria = function () { return new BrandsCriteriaDTOBuilder(); };
exports.aBrandsCriteria = aBrandsCriteria;
var aBulkCreateMethodOptions = function () { return new BulkCreateMethodOptionsDTOBuilder(); };
exports.aBulkCreateMethodOptions = aBulkCreateMethodOptions;
var aBulkDeleteByFilterMethodOptions = function () { return new BulkDeleteByFilterMethodOptionsDTOBuilder(); };
exports.aBulkDeleteByFilterMethodOptions = aBulkDeleteByFilterMethodOptions;
var aBulkDeleteMethodOptions = function () { return new BulkDeleteMethodOptionsDTOBuilder(); };
exports.aBulkDeleteMethodOptions = aBulkDeleteMethodOptions;
var aBulkUpdateByFilterMethodOptions = function () { return new BulkUpdateByFilterMethodOptionsDTOBuilder(); };
exports.aBulkUpdateByFilterMethodOptions = aBulkUpdateByFilterMethodOptions;
var aBulkUpdateMethodOptions = function () { return new BulkUpdateMethodOptionsDTOBuilder(); };
exports.aBulkUpdateMethodOptions = aBulkUpdateMethodOptions;
var aBulkUpsertMethodOptions = function () { return new BulkUpsertMethodOptionsDTOBuilder(); };
exports.aBulkUpsertMethodOptions = aBulkUpsertMethodOptions;
var aBytesValue = function () { return new BytesValueDTOBuilder(); };
exports.aBytesValue = aBytesValue;
var aCType = function () { return new CTypeDTOBuilder(); };
exports.aCType = aCType;
var aCache = function () { return new CacheDTOBuilder(); };
exports.aCache = aCache;
var aCacheSettings = function () { return new CacheSettingsDTOBuilder(); };
exports.aCacheSettings = aCacheSettings;
var aCallback = function () { return new CallbackDTOBuilder(); };
exports.aCallback = aCallback;
var aCallbackDeprecation = function () { return new CallbackDeprecationDTOBuilder(); };
exports.aCallbackDeprecation = aCallbackDeprecation;
var aCallbackEventType = function () { return new CallbackEventTypeDTOBuilder(); };
exports.aCallbackEventType = aCallbackEventType;
var aComparatorType = function () { return new ComparatorTypeDTOBuilder(); };
exports.aComparatorType = aComparatorType;
var aComparatorTypeEnum = function () { return new ComparatorTypeEnumDTOBuilder(); };
exports.aComparatorTypeEnum = aComparatorTypeEnum;
var aCompoundCriteria = function () { return new CompoundCriteriaDTOBuilder(); };
exports.aCompoundCriteria = aCompoundCriteria;
var aCompoundCriteriaOperator = function () { return new CompoundCriteriaOperatorDTOBuilder(); };
exports.aCompoundCriteriaOperator = aCompoundCriteriaOperator;
var aConditional = function () { return new ConditionalDTOBuilder(); };
exports.aConditional = aConditional;
var aConditions = function () { return new ConditionsDTOBuilder(); };
exports.aConditions = aConditions;
var aConnectedDomainCriteria = function () { return new ConnectedDomainCriteriaDTOBuilder(); };
exports.aConnectedDomainCriteria = aConnectedDomainCriteria;
var aConnectedDomainCriteriaEnum = function () { return new ConnectedDomainCriteriaEnumDTOBuilder(); };
exports.aConnectedDomainCriteriaEnum = aConnectedDomainCriteriaEnum;
var aContext = function () { return new ContextDTOBuilder(); };
exports.aContext = aContext;
var aCountOptions = function () { return new CountOptionsDTOBuilder(); };
exports.aCountOptions = aCountOptions;
var aCountType = function () { return new CountTypeDTOBuilder(); };
exports.aCountType = aCountType;
var aCreateMethodOptions = function () { return new CreateMethodOptionsDTOBuilder(); };
exports.aCreateMethodOptions = aCreateMethodOptions;
var aCreatePlacementRequest = function () { return new CreatePlacementRequestDTOBuilder(); };
exports.aCreatePlacementRequest = aCreatePlacementRequest;
var aCreatePlacementResponse = function () { return new CreatePlacementResponseDTOBuilder(); };
exports.aCreatePlacementResponse = aCreatePlacementResponse;
var aCriteriaMetaData = function () { return new CriteriaMetaDataDTOBuilder(); };
exports.aCriteriaMetaData = aCriteriaMetaData;
var aCriteriaType = function () { return new CriteriaTypeDTOBuilder(); };
exports.aCriteriaType = aCriteriaType;
var aCrud = function () { return new CrudDTOBuilder(); };
exports.aCrud = aCrud;
var aCustomFilterCriteria = function () { return new CustomFilterCriteriaDTOBuilder(); };
exports.aCustomFilterCriteria = aCustomFilterCriteria;
var aCustomFilterDataSource = function () { return new CustomFilterDataSourceDTOBuilder(); };
exports.aCustomFilterDataSource = aCustomFilterDataSource;
var aCustomFilterOperator = function () { return new CustomFilterOperatorDTOBuilder(); };
exports.aCustomFilterOperator = aCustomFilterOperator;
var aCustomHttpPattern = function () { return new CustomHttpPatternDTOBuilder(); };
exports.aCustomHttpPattern = aCustomHttpPattern;
var aCustomParam = function () { return new CustomParamDTOBuilder(); };
exports.aCustomParam = aCustomParam;
var aCustomParamCriteria = function () { return new CustomParamCriteriaDTOBuilder(); };
exports.aCustomParamCriteria = aCustomParamCriteria;
var aCustomParamOperator = function () { return new CustomParamOperatorDTOBuilder(); };
exports.aCustomParamOperator = aCustomParamOperator;
var aCustomValidationError = function () { return new CustomValidationErrorDTOBuilder(); };
exports.aCustomValidationError = aCustomValidationError;
var aDateUnit = function () { return new DateUnitDTOBuilder(); };
exports.aDateUnit = aDateUnit;
var aDebugOfferRequest = function () { return new DebugOfferRequestDTOBuilder(); };
exports.aDebugOfferRequest = aDebugOfferRequest;
var aDebugOfferResponse = function () { return new DebugOfferResponseDTOBuilder(); };
exports.aDebugOfferResponse = aDebugOfferResponse;
var aDecimalValueOptions = function () { return new DecimalValueOptionsDTOBuilder(); };
exports.aDecimalValueOptions = aDecimalValueOptions;
var aDeleteMethodOptions = function () { return new DeleteMethodOptionsDTOBuilder(); };
exports.aDeleteMethodOptions = aDeleteMethodOptions;
var aDeprecated = function () { return new DeprecatedDTOBuilder(); };
exports.aDeprecated = aDeprecated;
var aDescriptorProto = function () { return new DescriptorProtoDTOBuilder(); };
exports.aDescriptorProto = aDescriptorProto;
var aDomainEvent = function () { return new DomainEventDTOBuilder(); };
exports.aDomainEvent = aDomainEvent;
var aDomainEventEventType = function () { return new DomainEventEventTypeDTOBuilder(); };
exports.aDomainEventEventType = aDomainEventEventType;
var aDomainEventOptions = function () { return new DomainEventOptionsDTOBuilder(); };
exports.aDomainEventOptions = aDomainEventOptions;
var aDomainLengthCriteria = function () { return new DomainLengthCriteriaDTOBuilder(); };
exports.aDomainLengthCriteria = aDomainLengthCriteria;
var anEligibleForSaleCriteria = function () { return new EligibleForSaleCriteriaDTOBuilder(); };
exports.anEligibleForSaleCriteria = anEligibleForSaleCriteria;
var anEligibleForSaleCriteriaEnum = function () { return new EligibleForSaleCriteriaEnumDTOBuilder(); };
exports.anEligibleForSaleCriteriaEnum = anEligibleForSaleCriteriaEnum;
var anEmits = function () { return new EmitsDTOBuilder(); };
exports.anEmits = anEmits;
var anEntity = function () { return new EntityDTOBuilder(); };
exports.anEntity = anEntity;
var anEnumDescriptorProto = function () { return new EnumDescriptorProtoDTOBuilder(); };
exports.anEnumDescriptorProto = anEnumDescriptorProto;
var anEnumOptions = function () { return new EnumOptionsDTOBuilder(); };
exports.anEnumOptions = anEnumOptions;
var anEnumReservedRange = function () { return new EnumReservedRangeDTOBuilder(); };
exports.anEnumReservedRange = anEnumReservedRange;
var anEnumValueDescriptorProto = function () { return new EnumValueDescriptorProtoDTOBuilder(); };
exports.anEnumValueDescriptorProto = anEnumValueDescriptorProto;
var anEnumValueOptions = function () { return new EnumValueOptionsDTOBuilder(); };
exports.anEnumValueOptions = anEnumValueOptions;
var anEvent = function () { return new EventDTOBuilder(); };
exports.anEvent = anEvent;
var anEventsCountLimit = function () { return new EventsCountLimitDTOBuilder(); };
exports.anEventsCountLimit = anEventsCountLimit;
var anExecutionResult = function () { return new ExecutionResultDTOBuilder(); };
exports.anExecutionResult = anExecutionResult;
var anExperimentCriteria = function () { return new ExperimentCriteriaDTOBuilder(); };
exports.anExperimentCriteria = anExperimentCriteria;
var anExposure = function () { return new ExposureDTOBuilder(); };
exports.anExposure = anExposure;
var anExtendedFields = function () { return new ExtendedFieldsDTOBuilder(); };
exports.anExtendedFields = anExtendedFields;
var anExtensible = function () { return new ExtensibleDTOBuilder(); };
exports.anExtensible = anExtensible;
var anExtensionRange = function () { return new ExtensionRangeDTOBuilder(); };
exports.anExtensionRange = anExtensionRange;
var anExtensionRangeOptions = function () { return new ExtensionRangeOptionsDTOBuilder(); };
exports.anExtensionRangeOptions = anExtensionRangeOptions;
var anExternalApp = function () { return new ExternalAppDTOBuilder(); };
exports.anExternalApp = anExternalApp;
var anExternalCriteria = function () { return new ExternalCriteriaDTOBuilder(); };
exports.anExternalCriteria = anExternalCriteria;
var anExternalCriteriaConditionType = function () { return new ExternalCriteriaConditionTypeDTOBuilder(); };
exports.anExternalCriteriaConditionType = anExternalCriteriaConditionType;
var anExternalCriteriaConditionTypeEnum = function () { return new ExternalCriteriaConditionTypeEnumDTOBuilder(); };
exports.anExternalCriteriaConditionTypeEnum = anExternalCriteriaConditionTypeEnum;
var anExternalFilterCriteria = function () { return new ExternalFilterCriteriaDTOBuilder(); };
exports.anExternalFilterCriteria = anExternalFilterCriteria;
var anExternalFilterCriteriaConditionType = function () { return new ExternalFilterCriteriaConditionTypeDTOBuilder(); };
exports.anExternalFilterCriteriaConditionType = anExternalFilterCriteriaConditionType;
var anExternalFilterCriteriaConditionTypeEnum = function () { return new ExternalFilterCriteriaConditionTypeEnumDTOBuilder(); };
exports.anExternalFilterCriteriaConditionTypeEnum = anExternalFilterCriteriaConditionTypeEnum;
var anExternalFilterProviderConfig = function () { return new ExternalFilterProviderConfigDTOBuilder(); };
exports.anExternalFilterProviderConfig = anExternalFilterProviderConfig;
var aFieldDescriptorProto = function () { return new FieldDescriptorProtoDTOBuilder(); };
exports.aFieldDescriptorProto = aFieldDescriptorProto;
var aFieldDescriptorProtoType = function () { return new FieldDescriptorProtoTypeDTOBuilder(); };
exports.aFieldDescriptorProtoType = aFieldDescriptorProtoType;
var aFieldOptions = function () { return new FieldOptionsDTOBuilder(); };
exports.aFieldOptions = aFieldOptions;
var aFieldSet = function () { return new FieldSetDTOBuilder(); };
exports.aFieldSet = aFieldSet;
var aFileDescriptorSet = function () { return new FileDescriptorSetDTOBuilder(); };
exports.aFileDescriptorSet = aFileDescriptorSet;
var aFileOptions = function () { return new FileOptionsDTOBuilder(); };
exports.aFileOptions = aFileOptions;
var aFixedItem = function () { return new FixedItemDTOBuilder(); };
exports.aFixedItem = aFixedItem;
var aFormat = function () { return new FormatDTOBuilder(); };
exports.aFormat = aFormat;
var aFreeSiteCriteria = function () { return new FreeSiteCriteriaDTOBuilder(); };
exports.aFreeSiteCriteria = aFreeSiteCriteria;
var aFreeSiteCriteriaEnum = function () { return new FreeSiteCriteriaEnumDTOBuilder(); };
exports.aFreeSiteCriteriaEnum = aFreeSiteCriteriaEnum;
var aFrequencyCaps = function () { return new FrequencyCapsDTOBuilder(); };
exports.aFrequencyCaps = aFrequencyCaps;
var aFrequencyCapsConditionsResult = function () { return new FrequencyCapsConditionsResultDTOBuilder(); };
exports.aFrequencyCapsConditionsResult = aFrequencyCapsConditionsResult;
var aFrequencyCapsConfig = function () { return new FrequencyCapsConfigDTOBuilder(); };
exports.aFrequencyCapsConfig = aFrequencyCapsConfig;
var aFrequencyCapsEventType = function () { return new FrequencyCapsEventTypeDTOBuilder(); };
exports.aFrequencyCapsEventType = aFrequencyCapsEventType;
var aFrequencyCapsEvents = function () { return new FrequencyCapsEventsDTOBuilder(); };
exports.aFrequencyCapsEvents = aFrequencyCapsEvents;
var aFrequencyCapsExecutionResult = function () { return new FrequencyCapsExecutionResultDTOBuilder(); };
exports.aFrequencyCapsExecutionResult = aFrequencyCapsExecutionResult;
var aFrequencyCapsOverridesType = function () { return new FrequencyCapsOverridesTypeDTOBuilder(); };
exports.aFrequencyCapsOverridesType = aFrequencyCapsOverridesType;
var aFrequencyCapsRequestOverrides = function () { return new FrequencyCapsRequestOverridesDTOBuilder(); };
exports.aFrequencyCapsRequestOverrides = aFrequencyCapsRequestOverrides;
var aGeneratedCodeInfo = function () { return new GeneratedCodeInfoDTOBuilder(); };
exports.aGeneratedCodeInfo = aGeneratedCodeInfo;
var aGetDeletedMethodOptions = function () { return new GetDeletedMethodOptionsDTOBuilder(); };
exports.aGetDeletedMethodOptions = aGetDeletedMethodOptions;
var aGetItemMethodOptions = function () { return new GetItemMethodOptionsDTOBuilder(); };
exports.aGetItemMethodOptions = aGetItemMethodOptions;
var aGetOfferRequest = function () { return new GetOfferRequestDTOBuilder(); };
exports.aGetOfferRequest = aGetOfferRequest;
var aGetOfferResponse = function () { return new GetOfferResponseDTOBuilder(); };
exports.aGetOfferResponse = aGetOfferResponse;
var aGetPlacementRequest = function () { return new GetPlacementRequestDTOBuilder(); };
exports.aGetPlacementRequest = aGetPlacementRequest;
var aGetPlacementResponse = function () { return new GetPlacementResponseDTOBuilder(); };
exports.aGetPlacementResponse = aGetPlacementResponse;
var aGetPlacementsBulkRequest = function () { return new GetPlacementsBulkRequestDTOBuilder(); };
exports.aGetPlacementsBulkRequest = aGetPlacementsBulkRequest;
var aGetPlacementsBulkResponse = function () { return new GetPlacementsBulkResponseDTOBuilder(); };
exports.aGetPlacementsBulkResponse = aGetPlacementsBulkResponse;
var aHookable = function () { return new HookableDTOBuilder(); };
exports.aHookable = aHookable;
var aHttp = function () { return new HttpDTOBuilder(); };
exports.aHttp = aHttp;
var anIdempotencyLevel = function () { return new IdempotencyLevelDTOBuilder(); };
exports.anIdempotencyLevel = anIdempotencyLevel;
var anIdentification2Service = function () { return new Identification2ServiceDTOBuilder(); };
exports.anIdentification2Service = anIdentification2Service;
var anIdentificationData = function () { return new IdentificationDataDTOBuilder(); };
exports.anIdentificationData = anIdentificationData;
var anIdentity = function () { return new IdentityDTOBuilder(); };
exports.anIdentity = anIdentity;
var anIdentityRequest = function () { return new IdentityRequestDTOBuilder(); };
exports.anIdentityRequest = anIdentityRequest;
var anIdentityRequestWithExplicitContext = function () { return new IdentityRequestWithExplicitContextDTOBuilder(); };
exports.anIdentityRequestWithExplicitContext = anIdentityRequestWithExplicitContext;
var anIdentityRequestWithServerSigner = function () { return new IdentityRequestWithServerSignerDTOBuilder(); };
exports.anIdentityRequestWithServerSigner = anIdentityRequestWithServerSigner;
var anIdentityResponse = function () { return new IdentityResponseDTOBuilder(); };
exports.anIdentityResponse = anIdentityResponse;
var anInheritCrudErrors = function () { return new InheritCrudErrorsDTOBuilder(); };
exports.anInheritCrudErrors = anInheritCrudErrors;
var anItemPrioritized = function () { return new ItemPrioritizedDTOBuilder(); };
exports.anItemPrioritized = anItemPrioritized;
var aJSType = function () { return new JSTypeDTOBuilder(); };
exports.aJSType = aJSType;
var aLabel = function () { return new LabelDTOBuilder(); };
exports.aLabel = aLabel;
var aLastEventLimit = function () { return new LastEventLimitDTOBuilder(); };
exports.aLastEventLimit = aLastEventLimit;
var aLevel = function () { return new LevelDTOBuilder(); };
exports.aLevel = aLevel;
var aLevelEnum = function () { return new LevelEnumDTOBuilder(); };
exports.aLevelEnum = aLevelEnum;
var aListCriteria = function () { return new ListCriteriaDTOBuilder(); };
exports.aListCriteria = aListCriteria;
var aListDeletedMethodOptions = function () { return new ListDeletedMethodOptionsDTOBuilder(); };
exports.aListDeletedMethodOptions = aListDeletedMethodOptions;
var aListMethodOptions = function () { return new ListMethodOptionsDTOBuilder(); };
exports.aListMethodOptions = aListMethodOptions;
var aListOffersBulkRequest = function () { return new ListOffersBulkRequestDTOBuilder(); };
exports.aListOffersBulkRequest = aListOffersBulkRequest;
var aListOffersBulkResponse = function () { return new ListOffersBulkResponseDTOBuilder(); };
exports.aListOffersBulkResponse = aListOffersBulkResponse;
var aListOffersRequest = function () { return new ListOffersRequestDTOBuilder(); };
exports.aListOffersRequest = aListOffersRequest;
var aListOffersResponse = function () { return new ListOffersResponseDTOBuilder(); };
exports.aListOffersResponse = aListOffersResponse;
var aListPlacementsRequest = function () { return new ListPlacementsRequestDTOBuilder(); };
exports.aListPlacementsRequest = aListPlacementsRequest;
var aListPlacementsResponse = function () { return new ListPlacementsResponseDTOBuilder(); };
exports.aListPlacementsResponse = aListPlacementsResponse;
var aListValue = function () { return new ListValueDTOBuilder(); };
exports.aListValue = aListValue;
var aLocalizedData = function () { return new LocalizedDataDTOBuilder(); };
exports.aLocalizedData = aLocalizedData;
var aLocation = function () { return new LocationDTOBuilder(); };
exports.aLocation = aLocation;
var aMailboxCriteria = function () { return new MailboxCriteriaDTOBuilder(); };
exports.aMailboxCriteria = aMailboxCriteria;
var aMailboxCriteriaEnum = function () { return new MailboxCriteriaEnumDTOBuilder(); };
exports.aMailboxCriteriaEnum = aMailboxCriteriaEnum;
var aManagerIdsWrapper = function () { return new ManagerIdsWrapperDTOBuilder(); };
exports.aManagerIdsWrapper = aManagerIdsWrapper;
var aManagerLocalizationIdsWrapper = function () { return new ManagerLocalizationIdsWrapperDTOBuilder(); };
exports.aManagerLocalizationIdsWrapper = aManagerLocalizationIdsWrapper;
var aMaturity = function () { return new MaturityDTOBuilder(); };
exports.aMaturity = aMaturity;
var aMessageAppendix = function () { return new MessageAppendixDTOBuilder(); };
exports.aMessageAppendix = aMessageAppendix;
var aMessageAppendixType = function () { return new MessageAppendixTypeDTOBuilder(); };
exports.aMessageAppendixType = aMessageAppendixType;
var aMessageOptions = function () { return new MessageOptionsDTOBuilder(); };
exports.aMessageOptions = aMessageOptions;
var aMetaSiteIdInContext = function () { return new MetaSiteIdInContextDTOBuilder(); };
exports.aMetaSiteIdInContext = aMetaSiteIdInContext;
var aMethod = function () { return new MethodDTOBuilder(); };
exports.aMethod = aMethod;
var aMethodDescriptorProto = function () { return new MethodDescriptorProtoDTOBuilder(); };
exports.aMethodDescriptorProto = aMethodDescriptorProto;
var aMethodOptions = function () { return new MethodOptionsDTOBuilder(); };
exports.aMethodOptions = aMethodOptions;
var aNamePart = function () { return new NamePartDTOBuilder(); };
exports.aNamePart = aNamePart;
var aNullValue = function () { return new NullValueDTOBuilder(); };
exports.aNullValue = aNullValue;
var anOffer = function () { return new OfferDTOBuilder(); };
exports.anOffer = anOffer;
var anOffersConfig = function () { return new OffersConfigDTOBuilder(); };
exports.anOffersConfig = anOffersConfig;
var anOneofDescriptorProto = function () { return new OneofDescriptorProtoDTOBuilder(); };
exports.anOneofDescriptorProto = anOneofDescriptorProto;
var anOneofOptions = function () { return new OneofOptionsDTOBuilder(); };
exports.anOneofOptions = anOneofOptions;
var anOperatorFieldSupport = function () { return new OperatorFieldSupportDTOBuilder(); };
exports.anOperatorFieldSupport = anOperatorFieldSupport;
var anOperatorValueType = function () { return new OperatorValueTypeDTOBuilder(); };
exports.anOperatorValueType = anOperatorValueType;
var anOperatorValueTypeEnum = function () { return new OperatorValueTypeEnumDTOBuilder(); };
exports.anOperatorValueTypeEnum = anOperatorValueTypeEnum;
var anOptimizeMode = function () { return new OptimizeModeDTOBuilder(); };
exports.anOptimizeMode = anOptimizeMode;
var aPaging = function () { return new PagingDTOBuilder(); };
exports.aPaging = aPaging;
var aPagingType = function () { return new PagingTypeDTOBuilder(); };
exports.aPagingType = aPagingType;
var aParentAccount = function () { return new ParentAccountDTOBuilder(); };
exports.aParentAccount = aParentAccount;
var aPermissionRule = function () { return new PermissionRuleDTOBuilder(); };
exports.aPermissionRule = aPermissionRule;
var aPermissionType = function () { return new PermissionTypeDTOBuilder(); };
exports.aPermissionType = aPermissionType;
var aPerson = function () { return new PersonDTOBuilder(); };
exports.aPerson = aPerson;
var aPersonType = function () { return new PersonTypeDTOBuilder(); };
exports.aPersonType = aPersonType;
var aPlacement = function () { return new PlacementDTOBuilder(); };
exports.aPlacement = aPlacement;
var aPlacementStatus = function () { return new PlacementStatusDTOBuilder(); };
exports.aPlacementStatus = aPlacementStatus;
var aPlan = function () { return new PlanDTOBuilder(); };
exports.aPlan = aPlan;
var aPremiumAccountCriteria = function () { return new PremiumAccountCriteriaDTOBuilder(); };
exports.aPremiumAccountCriteria = aPremiumAccountCriteria;
var aPremiumAccountCriteriaEnum = function () { return new PremiumAccountCriteriaEnumDTOBuilder(); };
exports.aPremiumAccountCriteriaEnum = aPremiumAccountCriteriaEnum;
var aPremiumLandingTabCriteria = function () { return new PremiumLandingTabCriteriaDTOBuilder(); };
exports.aPremiumLandingTabCriteria = aPremiumLandingTabCriteria;
var aPremiumLandingTabCriteriaEnum = function () { return new PremiumLandingTabCriteriaEnumDTOBuilder(); };
exports.aPremiumLandingTabCriteriaEnum = aPremiumLandingTabCriteriaEnum;
var aPremiumPlanCriteria = function () { return new PremiumPlanCriteriaDTOBuilder(); };
exports.aPremiumPlanCriteria = aPremiumPlanCriteria;
var aPrioritizationABTestStrategies = function () { return new PrioritizationABTestStrategiesDTOBuilder(); };
exports.aPrioritizationABTestStrategies = aPrioritizationABTestStrategies;
var aPrioritizationStrategy = function () { return new PrioritizationStrategyDTOBuilder(); };
exports.aPrioritizationStrategy = aPrioritizationStrategy;
var aPrioritizationStrategyConfig = function () { return new PrioritizationStrategyConfigDTOBuilder(); };
exports.aPrioritizationStrategyConfig = aPrioritizationStrategyConfig;
var aPrioritizationStrategyOverrides = function () { return new PrioritizationStrategyOverridesDTOBuilder(); };
exports.aPrioritizationStrategyOverrides = aPrioritizationStrategyOverrides;
var aPrioritizationStrategyParams = function () { return new PrioritizationStrategyParamsDTOBuilder(); };
exports.aPrioritizationStrategyParams = aPrioritizationStrategyParams;
var aPriorityItem = function () { return new PriorityItemDTOBuilder(); };
exports.aPriorityItem = aPriorityItem;
var aPublishErrors = function () { return new PublishErrorsDTOBuilder(); };
exports.aPublishErrors = aPublishErrors;
var aPublishPlacementRequest = function () { return new PublishPlacementRequestDTOBuilder(); };
exports.aPublishPlacementRequest = aPublishPlacementRequest;
var aPublishPlacementResponse = function () { return new PublishPlacementResponseDTOBuilder(); };
exports.aPublishPlacementResponse = aPublishPlacementResponse;
var aPublishStatus = function () { return new PublishStatusDTOBuilder(); };
exports.aPublishStatus = aPublishStatus;
var aQueryMethodOptions = function () { return new QueryMethodOptionsDTOBuilder(); };
exports.aQueryMethodOptions = aQueryMethodOptions;
var aReferenceEntityField = function () { return new ReferenceEntityFieldDTOBuilder(); };
exports.aReferenceEntityField = aReferenceEntityField;
var aRefreshIdentityRequest = function () { return new RefreshIdentityRequestDTOBuilder(); };
exports.aRefreshIdentityRequest = aRefreshIdentityRequest;
var aRefreshIdentityResponse = function () { return new RefreshIdentityResponseDTOBuilder(); };
exports.aRefreshIdentityResponse = aRefreshIdentityResponse;
var aReleaseAudience = function () { return new ReleaseAudienceDTOBuilder(); };
exports.aReleaseAudience = aReleaseAudience;
var aReleaseAudienceStatus = function () { return new ReleaseAudienceStatusDTOBuilder(); };
exports.aReleaseAudienceStatus = aReleaseAudienceStatus;
var aRemoveFromTrashbinMethodOptions = function () { return new RemoveFromTrashbinMethodOptionsDTOBuilder(); };
exports.aRemoveFromTrashbinMethodOptions = aRemoveFromTrashbinMethodOptions;
var aRequestContext = function () { return new RequestContextDTOBuilder(); };
exports.aRequestContext = aRequestContext;
var aRequestExtensions = function () { return new RequestExtensionsDTOBuilder(); };
exports.aRequestExtensions = aRequestExtensions;
var aRequiredField = function () { return new RequiredFieldDTOBuilder(); };
exports.aRequiredField = aRequiredField;
var aRequiredFields = function () { return new RequiredFieldsDTOBuilder(); };
exports.aRequiredFields = aRequiredFields;
var aReservedRange = function () { return new ReservedRangeDTOBuilder(); };
exports.aReservedRange = aReservedRange;
var aResolveOfferRequest = function () { return new ResolveOfferRequestDTOBuilder(); };
exports.aResolveOfferRequest = aResolveOfferRequest;
var aResolveOfferResponse = function () { return new ResolveOfferResponseDTOBuilder(); };
exports.aResolveOfferResponse = aResolveOfferResponse;
var aRestoreFromTrashbinMethodOptions = function () { return new RestoreFromTrashbinMethodOptionsDTOBuilder(); };
exports.aRestoreFromTrashbinMethodOptions = aRestoreFromTrashbinMethodOptions;
var aSchema = function () { return new SchemaDTOBuilder(); };
exports.aSchema = aSchema;
var aSearch = function () { return new SearchDTOBuilder(); };
exports.aSearch = aSearch;
var aSearchMethodOptions = function () { return new SearchMethodOptionsDTOBuilder(); };
exports.aSearchMethodOptions = aSearchMethodOptions;
var aSegment = function () { return new SegmentDTOBuilder(); };
exports.aSegment = aSegment;
var aSegmentName = function () { return new SegmentNameDTOBuilder(); };
exports.aSegmentName = aSegmentName;
var aServiceAppendix = function () { return new ServiceAppendixDTOBuilder(); };
exports.aServiceAppendix = aServiceAppendix;
var aServiceAppendixType = function () { return new ServiceAppendixTypeDTOBuilder(); };
exports.aServiceAppendixType = aServiceAppendixType;
var aServiceDescriptorProto = function () { return new ServiceDescriptorProtoDTOBuilder(); };
exports.aServiceDescriptorProto = aServiceDescriptorProto;
var aServiceEntity = function () { return new ServiceEntityDTOBuilder(); };
exports.aServiceEntity = aServiceEntity;
var aServiceOptions = function () { return new ServiceOptionsDTOBuilder(); };
exports.aServiceOptions = aServiceOptions;
var aShadowedStrategy = function () { return new ShadowedStrategyDTOBuilder(); };
exports.aShadowedStrategy = aShadowedStrategy;
var aSiteData = function () { return new SiteDataDTOBuilder(); };
exports.aSiteData = aSiteData;
var aSiteType = function () { return new SiteTypeDTOBuilder(); };
exports.aSiteType = aSiteType;
var aSiteTypeCriteria = function () { return new SiteTypeCriteriaDTOBuilder(); };
exports.aSiteTypeCriteria = aSiteTypeCriteria;
var aSort = function () { return new SortDTOBuilder(); };
exports.aSort = aSort;
var aSourceCodeInfo = function () { return new SourceCodeInfoDTOBuilder(); };
exports.aSourceCodeInfo = aSourceCodeInfo;
var aSpiError = function () { return new SpiErrorDTOBuilder(); };
exports.aSpiError = aSpiError;
var aSpiHttpStatusCode = function () { return new SpiHttpStatusCodeDTOBuilder(); };
exports.aSpiHttpStatusCode = aSpiHttpStatusCode;
var aSpiService = function () { return new SpiServiceDTOBuilder(); };
exports.aSpiService = aSpiService;
var aStatusCodes = function () { return new StatusCodesDTOBuilder(); };
exports.aStatusCodes = aStatusCodes;
var aStatusCodesHttpStatusCode = function () { return new StatusCodesHttpStatusCodeDTOBuilder(); };
exports.aStatusCodesHttpStatusCode = aStatusCodesHttpStatusCode;
var aTargeting = function () { return new TargetingDTOBuilder(); };
exports.aTargeting = aTargeting;
var aTranslatable = function () { return new TranslatableDTOBuilder(); };
exports.aTranslatable = aTranslatable;
var aTranslatableType = function () { return new TranslatableTypeDTOBuilder(); };
exports.aTranslatableType = aTranslatableType;
var anUninterpretedOption = function () { return new UninterpretedOptionDTOBuilder(); };
exports.anUninterpretedOption = anUninterpretedOption;
var anUnique = function () { return new UniqueDTOBuilder(); };
exports.anUnique = anUnique;
var anUpdateMethodOptions = function () { return new UpdateMethodOptionsDTOBuilder(); };
exports.anUpdateMethodOptions = anUpdateMethodOptions;
var anUpdatePlacementRequest = function () { return new UpdatePlacementRequestDTOBuilder(); };
exports.anUpdatePlacementRequest = anUpdatePlacementRequest;
var anUpdatePlacementResponse = function () { return new UpdatePlacementResponseDTOBuilder(); };
exports.anUpdatePlacementResponse = anUpdatePlacementResponse;
var anUpdatePlacementSlugRequest = function () { return new UpdatePlacementSlugRequestDTOBuilder(); };
exports.anUpdatePlacementSlugRequest = anUpdatePlacementSlugRequest;
var anUpdatePlacementSlugResponse = function () { return new UpdatePlacementSlugResponseDTOBuilder(); };
exports.anUpdatePlacementSlugResponse = anUpdatePlacementSlugResponse;
var anUpdatePlacementStatusRequest = function () { return new UpdatePlacementStatusRequestDTOBuilder(); };
exports.anUpdatePlacementStatusRequest = anUpdatePlacementStatusRequest;
var anUpdatePlacementStatusResponse = function () { return new UpdatePlacementStatusResponseDTOBuilder(); };
exports.anUpdatePlacementStatusResponse = anUpdatePlacementStatusResponse;
var anUpsertMethodOptions = function () { return new UpsertMethodOptionsDTOBuilder(); };
exports.anUpsertMethodOptions = anUpsertMethodOptions;
var anUserAccountInfo = function () { return new UserAccountInfoDTOBuilder(); };
exports.anUserAccountInfo = anUserAccountInfo;
var anUserData = function () { return new UserDataDTOBuilder(); };
exports.anUserData = anUserData;
var anUserRoleCriteria = function () { return new UserRoleCriteriaDTOBuilder(); };
exports.anUserRoleCriteria = anUserRoleCriteria;
var anUserRoleCriteriaEnum = function () { return new UserRoleCriteriaEnumDTOBuilder(); };
exports.anUserRoleCriteriaEnum = anUserRoleCriteriaEnum;
var anUserStatusCriteria = function () { return new UserStatusCriteriaDTOBuilder(); };
exports.anUserStatusCriteria = anUserStatusCriteria;
var anUserStatusCriteriaEnum = function () { return new UserStatusCriteriaEnumDTOBuilder(); };
exports.anUserStatusCriteriaEnum = anUserStatusCriteriaEnum;
var aWHATSNEXTConfig = function () { return new WHATSNEXTConfigDTOBuilder(); };
exports.aWHATSNEXTConfig = aWHATSNEXTConfig;
var aWhatsNextConfiguration = function () { return new WhatsNextConfigurationDTOBuilder(); };
exports.aWhatsNextConfiguration = aWhatsNextConfiguration;
var aWixGlobalData = function () { return new WixGlobalDataDTOBuilder(); };
exports.aWixGlobalData = aWixGlobalData;
var aWql = function () { return new WqlDTOBuilder(); };
exports.aWql = aWql;
var aWqlOperator = function () { return new WqlOperatorDTOBuilder(); };
exports.aWqlOperator = aWqlOperator;
//# sourceMappingURL=builders.js.map